var data = [];

data.push({
    name: 'Business',
    module: 'sys',
    display: {
        vi: 'Doanh nghiệp',
        en: 'Business',
        fr: 'Entreprise',
        es: 'Negocio',
        id: 'Bisnis',
        ja: 'ビジネス',
        zh: '企业',
        ko: '비즈니스',
        hi: 'व्यापार',
        ar: 'الأعمال'
    }
});
data.push({
    name: 'BUCredit',
    module: 'sys',
    display: {
        vi: 'Công nợ',
        en: 'Business Credit',
        fr: 'Crédit entreprise',
        es: 'Crédito comercial',
        id: 'Kredit bisnis',
        ja: '取引信用',
        zh: '企业信用',
        ko: '사업 신용',
        hi: 'व्यापार क्रेडिट',
        ar: 'ائتمان تجاري'
    }
});

data.push({
    name: 'MEDDocument',
    module: 'media',
    display: {
        vi: 'Tài liệu',
        en: 'Document',
        fr: 'Document',
        es: 'Documento',
        id: 'Dokumen',
        ja: 'ドキュメント',
        zh: '文档',
        ko: '문서',
        hi: 'दस्तावेज़',
        ar: 'مستند'
    }
});
data.push({
    name: 'MEDDocumentVoucher',
    module: 'media',
    display: {
        vi: 'Đính kèm phiếu',
        en: 'Voucher Attachment',
        fr: 'Pièce jointe',
        es: 'Adjunto de bono',
        id: 'Lampiran voucher',
        ja: '伝票添付',
        zh: '凭证附件',
        ko: '전표 첨부',
        hi: 'वाउचर अनुलग्नक',
        ar: 'مرفق القسيمة'
    }
});
data.push({
    name: 'AIImportBatch',
    module: 'ai',
    display: {
        vi: 'Lô phân tích AI',
        en: 'AI Import Batch',
        fr: 'Lot d\'importation IA',
        es: 'Lote IA',
        id: 'Batch impor AI',
        ja: 'AIインポートバッチ',
        zh: 'AI批次',
        ko: 'AI 배치',
        hi: 'AI बैच',
        ar: 'دفعة AI'
    }
});

data.push({
    name: 'APRequest',
    module: 'ap',
    display: {
        vi: 'Đề nghị mua hàng',
        en: 'Purchase Request',
        fr: 'Demande de achat',
        es: 'Solicitud de compra',
        id: 'Permintaan pembelian',
        ja: '購入依頼',
        zh: '采购申请',
        ko: '구매 요청',
        hi: 'खरीद अनुरोध',
        ar: 'طلب شراء'
    }
});
data.push({
    name: 'APRequestItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết mua hàng',
        en: 'Purchase Request Items',
        fr: 'Articles demande',
        es: 'Artículos de solicitud',
        id: 'Item permintaan',
        ja: '購入依頼明細',
        zh: '采购申请明细',
        ko: '구매 요청 항목',
        hi: 'खरीद अनुरोध आइटम',
        ar: 'بنود طلب الشراء'
    }
});
data.push({
    name: 'APOrder',
    module: 'ap',
    display: {
        vi: 'Đơn mua hàng',
        en: 'Purchase Order',
        fr: 'Bon de commande',
        es: 'Orden de compra',
        id: 'Pesanan pembelian',
        ja: '発注書',
        zh: '采购订单',
        ko: '구매 주문',
        hi: 'खरीद आदेश',
        ar: 'أمر شراء'
    }
});
data.push({
    name: 'APOrderItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết mua hàng',
        en: 'Purchase Order Items',
        fr: 'Articles commande',
        es: 'Artículos de pedido',
        id: 'Item pesanan',
        ja: '発注明細',
        zh: '采购订单明细',
        ko: '구매 주문 항목',
        hi: 'खरीद आदेश आइटम',
        ar: 'بنود أمر الشراء'
    }
});
data.push({
    name: 'APShipment',
    module: 'ap',
    display: {
        vi: 'Giao nhận',
        en: 'Purchase Shipment',
        fr: 'Expédition achat',
        es: 'Envío de compra',
        id: 'Pengiriman pembelian',
        ja: '購入出荷',
        zh: '采购发货',
        ko: '구매 배송',
        hi: 'खरीद शिपमेंट',
        ar: 'شحنة الشراء'
    }
});
data.push({
    name: 'APShipmentItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết giao nhận',
        en: 'Purchase Shipment Items',
        fr: 'Articles expédition',
        es: 'Artículos de envío',
        id: 'Item pengiriman',
        ja: '購入出荷明細',
        zh: '采购发货明细',
        ko: '구매 배송 항목',
        hi: 'खरीद शिपमेंट आइटम',
        ar: 'بنود شحنة الشراء'
    }
});
data.push({
    name: 'APReceive',
    module: 'ap',
    display: {
        vi: 'Phiếu nhận hàng',
        en: 'Purchase Receive',
        fr: 'Réception achat',
        es: 'Recepción de compra',
        id: 'Penerimaan pembelian',
        ja: '購入受領',
        zh: '采购收货',
        ko: '구매 수령',
        hi: 'खरीद प्राप्ति',
        ar: 'استلام الشراء'
    }
});
data.push({
    name: 'APReceiveItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết nhận hàng',
        en: 'Purchase Receive Items',
        fr: 'Articles réception',
        es: 'Artículos de recepción',
        id: 'Item penerimaan',
        ja: '購入受領明細',
        zh: '采购收货明细',
        ko: '구매 수령 항목',
        hi: 'खरीद प्राप्ति आइटम',
        ar: 'بنود استلام الشراء'
    }
});
data.push({
    name: 'APReturn',
    module: 'ap',
    display: {
        vi: 'Phiếu trả hàng',
        en: 'Purchase Return',
        fr: 'Retour achat',
        es: 'Devolución de compra',
        id: 'Retur pembelian',
        ja: '購入返品',
        zh: '采购退货',
        ko: '구매 반품',
        hi: 'खरीद वापसी',
        ar: 'مرتجعات الشراء'
    }
});
data.push({
    name: 'APReturnItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết trả hàng',
        en: 'Purchase Return Items',
        fr: 'Articles retour',
        es: 'Artículos de devolución',
        id: 'Item retur',
        ja: '購入返品明細',
        zh: '采购退货明细',
        ko: '구매 반품 항목',
        hi: 'खरीद वापसी आइटम',
        ar: 'بنود مرتجعات الشراء'
    }
});
data.push({
    name: 'APDelivery',
    module: 'ap',
    display: {
        vi: 'Phiếu nhận/trả hàng',
        en: 'Purchase Delivery',
        fr: 'Livraison achat',
        es: 'Entrega de compra',
        id: 'Pengiriman pembelian',
        ja: '購入配送',
        zh: '采购交付',
        ko: '구매 배달',
        hi: 'खरीद डिलीवरी',
        ar: 'تسليم الشراء'
    }
});
data.push({
    name: 'APDeliveryItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết nhận/trả hàng',
        en: 'Purchase Delivery Items',
        fr: 'Articles livraison',
        es: 'Artículos de entrega',
        id: 'Item pengiriman',
        ja: '購入配送明細',
        zh: '采购交付明细',
        ko: '구매 배달 항목',
        hi: 'खरीद डिलीवरी आइटम',
        ar: 'بنود تسليم الشراء'
    }
});
data.push({
    name: 'APCredit',
    module: 'ap',
    display: {
        vi: 'Công nợ mua hàng',
        en: 'Purchase Credit',
        fr: 'Crédit achat',
        es: 'Crédito de compra',
        id: 'Kredit pembelian',
        ja: '購入掛金',
        zh: '采购信用',
        ko: '구매 외상',
        hi: 'खरीद क्रेडिट',
        ar: 'ائتمان الشراء'
    }
});
data.push({
    name: 'APCreditItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết công nợ mua hàng',
        en: 'Purchase Credit Detail',
        fr: 'Détail crédit achat',
        es: 'Detalle crédito compra',
        id: 'Detail kredit',
        ja: '購入掛金明細',
        zh: '采购信用明细',
        ko: '구매 외상 상세',
        hi: 'खरीद क्रेडिट विवरण',
        ar: 'تفاصيل ائتمان الشراء'
    }
});
data.push({
    name: 'APInvoice',
    module: 'ap',
    display: {
        vi: 'Hóa đơn mua hàng',
        en: 'Purchase Invoice',
        fr: 'Facture achat',
        es: 'Factura de compra',
        id: 'Faktur pembelian',
        ja: '購入請求書',
        zh: '采购发票',
        ko: '구매 송장',
        hi: 'खरीद चालान',
        ar: 'فاتورة الشراء'
    }
});
data.push({
    name: 'APInvoiceItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết hóa đơn mua hàng',
        en: 'Purchase Invoice Detail',
        fr: 'Détail facture achat',
        es: 'Detalle factura compra',
        id: 'Detail faktur',
        ja: '購入請求書明細',
        zh: '采购发票明细',
        ko: '구매 송장 상세',
        hi: 'खरीद चालान विवरण',
        ar: 'تفاصيل فاتورة الشراء'
    }
});
data.push({
    name: 'APImportCost',
    module: 'ap',
    display: {
        vi: 'Chi phí nhập khẩu',
        en: 'Import Duties',
        fr: 'Droits importation',
        es: 'Aranceles de importación',
        id: 'Bea masuk',
        ja: '輸入関税',
        zh: '进口关税',
        ko: '수입 관세',
        hi: 'आयात शुल्क',
        ar: 'رسوم الاستيراد'
    }
});
data.push({
    name: 'APImportCostItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết hóa đơn mua hàng',
        en: 'Import Duties Detail',
        fr: 'Détail droits import',
        es: 'Detalle aranceles',
        id: 'Detail bea masuk',
        ja: '輸入関税明細',
        zh: '进口关税明细',
        ko: '수입 관세 상세',
        hi: 'आयात शुल्क विवरण',
        ar: 'تفاصيل رسوم الاستيراد'
    }
});

data.push({
    name: 'APQuotation',
    module: 'ap',
    display: {
        vi: 'Báo giá NCC',
        en: 'Vendor Quotation',
        fr: 'Devis fournisseur',
        es: 'Cotización proveedor',
        id: 'Penawaran vendor',
        ja: '仕入先見積',
        zh: '供应商报价',
        ko: '공급사 견적',
        hi: 'विक्रेता उद्धरण',
        ar: 'عرض المورد'
    }
});
data.push({
    name: 'APQuotationItem',
    module: 'ap',
    display: {
        vi: 'Chi tiết báo giá NCC',
        en: 'Vendor Quotation Items',
        fr: 'Articles devis',
        es: 'Artículos cotización',
        id: 'Item penawaran',
        ja: '見積明細',
        zh: '报价明细',
        ko: '견적 항목',
        hi: 'उद्धरण आइटम',
        ar: 'بنود العرض'
    }
});
data.push({
    name: 'APVendorPromotion',
    module: 'ap',
    display: {
        vi: 'Khuyến mãi NCC',
        en: 'Vendor Promotion',
        fr: 'Promotion fournisseur',
        es: 'Promoción proveedor',
        id: 'Promosi vendor',
        ja: '仕入先プロモ',
        zh: '供应商促销',
        ko: '공급사 프로모션',
        hi: 'विक्रेता प्रचार',
        ar: 'عرض المورد'
    }
});
data.push({
    name: 'APVendorPromotionTier',
    module: 'ap',
    display: {
        vi: 'Bậc KM NCC',
        en: 'Vendor Promotion Tier',
        fr: 'Palier promotion',
        es: 'Nivel promoción',
        id: 'Tier promosi',
        ja: 'プロモ段階',
        zh: '促销阶梯',
        ko: '프로모션 단계',
        hi: 'प्रचार स्तर',
        ar: 'مستوى العرض'
    }
});

data.push({
    name: 'ARPriceList',
    module: 'ar',
    display: {
        vi: 'Bảng giá',
        en: 'Sale Pricelist',
        fr: 'Tarif de vente',
        es: 'Lista de precios',
        id: 'Daftar harga',
        ja: '販売価格表',
        zh: '销售价格表',
        ko: '판매 가격표',
        hi: 'बिक्री मूल्य सूची',
        ar: 'قائمة أسعار البيع'
    }
});
data.push({
    name: 'ARPriceListItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết bảng giá',
        en: 'Sale Pricelist Detail',
        fr: 'Détail tarif',
        es: 'Detalle lista precios',
        id: 'Detail daftar harga',
        ja: '販売価格表明細',
        zh: '销售价格表明细',
        ko: '판매 가격표 상세',
        hi: 'बिक्री मूल्य सूची विवरण',
        ar: 'تفاصيل قائمة الأسعار'
    }
});
data.push({
    name: 'ARPromotion',
    module: 'ar',
    display: {
        vi: 'Khuyến mại',
        en: 'Sale Promotion',
        fr: 'Promotion de vente',
        es: 'Promoción de venta',
        id: 'Promosi penjualan',
        ja: '販売促進',
        zh: '销售促销',
        ko: '판매 프로모션',
        hi: 'बिक्री प्रचार',
        ar: 'عرض البيع'
    }
});
data.push({
    name: 'ARPromotionItem',
    module: 'ar',
    display: {
        vi: 'Mặt hàng',
        en: 'Sale Promotion Items',
        fr: 'Articles promotion',
        es: 'Artículos promoción',
        id: 'Item promosi',
        ja: '販促品目',
        zh: '促销商品',
        ko: '프로모션 항목',
        hi: 'प्रचार आइटम',
        ar: 'بنود العرض'
    }
});
data.push({
    name: 'ARPromotionX',
    module: 'ar',
    display: {
        vi: 'Mua X',
        en: 'Buy X',
        fr: 'Acheter X',
        es: 'Comprar X',
        id: 'Beli X',
        ja: 'X購入',
        zh: '买X',
        ko: 'X 구매',
        hi: 'X खरीदें',
        ar: 'اشتر X'
    }
});
data.push({
    name: 'ARPromotionY',
    module: 'ar',
    display: {
        vi: 'Tặng Y',
        en: 'Get Y',
        fr: 'Obtenir Y',
        es: 'Obtener Y',
        id: 'Dapat Y',
        ja: 'Y取得',
        zh: '得Y',
        ko: 'Y 획득',
        hi: 'Y पाएं',
        ar: 'احصل على Y'
    }
});
data.push({
    name: 'ARPromotionVoucher',
    module: 'ar',
    display: {
        vi: 'Voucher',
        en: 'Voucher',
        fr: 'Bon',
        es: 'Cupón',
        id: 'Voucher',
        ja: 'バウチャー',
        zh: '代金券',
        ko: '바우처',
        hi: 'वाउचर',
        ar: 'قسيمة'
    }
});
data.push({
    name: 'ARAppointment',
    module: 'ar',
    display: {
        vi: 'Lịch hẹn',
        en: 'Appointment',
        fr: 'Rendez-vous',
        es: 'Cita',
        id: 'Janji temu',
        ja: '予約',
        zh: '预约',
        ko: '예약',
        hi: 'अपॉइंटमेंट',
        ar: 'موعد'
    }
});
data.push({
    name: 'ARAppointmentItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Lịch hẹn',
        en: 'Appointment Detail',
        fr: 'Détail rendez-vous',
        es: 'Detalle de cita',
        id: 'Detail janji temu',
        ja: '予約明細',
        zh: '预约明细',
        ko: '예약 상세',
        hi: 'अपॉइंटमेंट विवरण',
        ar: 'تفاصيل الموعد'
    }
});
data.push({
    name: 'AROrder',
    module: 'ar',
    display: {
        vi: 'Đơn bán hàng',
        en: 'Sale Order',
        fr: 'Commande de vente',
        es: 'Orden de venta',
        id: 'Pesanan penjualan',
        ja: '受注',
        zh: '销售订单',
        ko: '판매 주문',
        hi: 'बिक्री आदेश',
        ar: 'أمر بيع'
    }
});
data.push({
    name: 'AROrderItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Đơn bán hàng',
        en: 'Sale Order Items',
        fr: 'Articles commande vente',
        es: 'Artículos de orden',
        id: 'Item pesanan',
        ja: '受注明細',
        zh: '销售订单明细',
        ko: '판매 주문 항목',
        hi: 'बिक्री आदेश आइटम',
        ar: 'بنود أمر البيع'
    }
});
data.push({
    name: 'ARIssue',
    module: 'ar',
    display: {
        vi: 'Xuất hàng',
        en: 'Fulfillment',
        fr: 'Exécution',
        es: 'Cumplimiento',
        id: 'Pemenuhan',
        ja: 'フルフィルメント',
        zh: '履行',
        ko: '이행',
        hi: 'पूर्ति',
        ar: 'التنفيذ'
    }
});
data.push({
    name: 'ARIssueItem',
    module: 'ar',
    display: {
        vi: 'Xuất hàng',
        en: 'Fulfillment',
        fr: 'Exécution',
        es: 'Cumplimiento',
        id: 'Pemenuhan',
        ja: 'フルフィルメント',
        zh: '履行',
        ko: '이행',
        hi: 'पूर्ति',
        ar: 'التنفيذ'
    }
});
data.push({
    name: 'ARReturn',
    module: 'ar',
    display: {
        vi: 'Trả hàng bán',
        en: 'Sale Return',
        fr: 'Retour de vente',
        es: 'Devolución de venta',
        id: 'Retur penjualan',
        ja: '販売返品',
        zh: '销售退货',
        ko: '판매 반품',
        hi: 'बिक्री वापसी',
        ar: 'مرتجعات البيع'
    }
});
data.push({
    name: 'ARReturnItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Trả hàng bán',
        en: 'Sale Return Items',
        fr: 'Articles retour vente',
        es: 'Artículos de devolución',
        id: 'Item retur',
        ja: '販売返品明細',
        zh: '销售退货明细',
        ko: '판매 반품 항목',
        hi: 'बिक्री वापसी आइटम',
        ar: 'بنود مرتجعات البيع'
    }
});
data.push({
    name: 'ARShipment',
    module: 'ar',
    display: {
        vi: 'Giao nhận',
        en: 'Sale Shipment',
        fr: 'Expédition vente',
        es: 'Envío de venta',
        id: 'Pengiriman penjualan',
        ja: '販売出荷',
        zh: '销售发货',
        ko: '판매 배송',
        hi: 'बिक्री शिपमेंट',
        ar: 'شحنة البيع'
    }
});
data.push({
    name: 'ARShipmentItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Giao nhận',
        en: 'Sale Shipment Items',
        fr: 'Articles expédition vente',
        es: 'Artículos de envío',
        id: 'Item pengiriman',
        ja: '販売出荷明細',
        zh: '销售发货明细',
        ko: '판매 배송 항목',
        hi: 'बिक्री शिपमेंट आइटम',
        ar: 'بنود شحنة البيع'
    }
});
data.push({
    name: 'ARDelivery',
    module: 'ar',
    display: {
        vi: 'Phiếu nhận/trả hàng',
        en: 'Sale Delivery',
        fr: 'Livraison vente',
        es: 'Entrega de venta',
        id: 'Pengiriman penjualan',
        ja: '販売配送',
        zh: '销售交付',
        ko: '판매 배달',
        hi: 'बिक्री डिलीवरी',
        ar: 'تسليم البيع'
    }
});
data.push({
    name: 'ARDeliveryItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết nhận/trả hàng',
        en: 'Sale Delivery Items',
        fr: 'Articles livraison vente',
        es: 'Artículos de entrega',
        id: 'Item pengiriman',
        ja: '販売配送明細',
        zh: '销售交付明细',
        ko: '판매 배달 항목',
        hi: 'बिक्री डिलीवरी आइटम',
        ar: 'بنود تسليم البيع'
    }
});
data.push({
    name: 'ARCredit',
    module: 'ar',
    display: {
        vi: 'Công nợ bán hàng',
        en: 'Sale Credit',
        fr: 'Crédit vente',
        es: 'Crédito de venta',
        id: 'Kredit penjualan',
        ja: '販売掛金',
        zh: '销售信用',
        ko: '판매 외상',
        hi: 'बिक्री क्रेडिट',
        ar: 'ائتمان البيع'
    }
});
data.push({
    name: 'ARCreditItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết công nợ bán hàng',
        en: 'Sale Credit Detail',
        fr: 'Détail crédit vente',
        es: 'Detalle crédito venta',
        id: 'Detail kredit',
        ja: '販売掛金明細',
        zh: '销售信用明细',
        ko: '판매 외상 상세',
        hi: 'बिक्री क्रेडिट विवरण',
        ar: 'تفاصيل ائتمان البيع'
    }
});
data.push({
    name: 'ARInvoice',
    module: 'ar',
    display: {
        vi: 'Hóa đơn bán hàng',
        en: 'Sale Invoice',
        fr: 'Facture de vente',
        es: 'Factura de venta',
        id: 'Faktur penjualan',
        ja: '販売請求書',
        zh: '销售发票',
        ko: '판매 송장',
        hi: 'बिक्री चालान',
        ar: 'فاتورة البيع'
    }
});
data.push({
    name: 'ARInvoiceItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết hóa đơn bán hàng',
        en: 'Sale Invoice Detail',
        fr: 'Détail facture vente',
        es: 'Detalle factura venta',
        id: 'Detail faktur',
        ja: '販売請求書明細',
        zh: '销售发票明细',
        ko: '판매 송장 상세',
        hi: 'बिक्री चालान विवरण',
        ar: 'تفاصيل فاتورة البيع'
    }
});

data.push({
    name: 'ARItemStatus',
    module: 'ar',
    display: {
        vi: 'Hàng Bán',
        en: 'Catalogue',
        fr: 'Catalogue',
        es: 'Catálogo',
        id: 'Katalog',
        ja: 'カタログ',
        zh: '目录',
        ko: '카탈로그',
        hi: 'कैटलॉग',
        ar: 'الكتالوج'
    }
});
data.push({
    name: 'ItemWarehouse',
    module: 'ar',
    display: {
        vi: 'Hàng theo kho',
        en: 'Product By Warehouse',
        fr: 'Produit par entrepôt',
        es: 'Producto por almacén',
        id: 'Produk per gudang',
        ja: '倉庫別商品',
        zh: '按仓库产品',
        ko: '창고별 제품',
        hi: 'गोदाम द्वारा उत्पाद',
        ar: 'المنتج حسب المستودع'
    }
});
data.push({
    name: 'ServicePack',
    module: 'ar',
    display: {
        vi: 'Gói dịch vụ',
        en: 'Service Package',
        fr: 'Forfait service',
        es: 'Paquete de servicio',
        id: 'Paket layanan',
        ja: 'サービスパッケージ',
        zh: '服务套餐',
        ko: '서비스 패키지',
        hi: 'सेवा पैकेज',
        ar: 'حزمة الخدمة'
    }
});
data.push({
    name: 'ServicePackItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Gói dịch vụ',
        en: 'Service Package Detail',
        fr: 'Détail forfait',
        es: 'Detalle paquete',
        id: 'Detail paket',
        ja: 'サービスパッケージ明細',
        zh: '服务套餐明细',
        ko: '서비스 패키지 상세',
        hi: 'सेवा पैकेज विवरण',
        ar: 'تفاصيل حزمة الخدمة'
    }
});
data.push({
    name: 'ServiceCard',
    module: 'ar',
    display: {
        vi: 'Thẻ dịch vụ',
        en: 'Service Card',
        fr: 'Carte service',
        es: 'Tarjeta de servicio',
        id: 'Kartu layanan',
        ja: 'サービスカード',
        zh: '服务卡',
        ko: '서비스 카드',
        hi: 'सेवा कार्ड',
        ar: 'بطاقة الخدمة'
    }
});
data.push({
    name: 'ServiceCardItem',
    module: 'ar',
    display: {
        vi: 'Chi tiết Thẻ dịch vụ',
        en: 'Service Card Detail',
        fr: 'Détail carte service',
        es: 'Detalle tarjeta',
        id: 'Detail kartu',
        ja: 'サービスカード明細',
        zh: '服务卡明细',
        ko: '서비스 카드 상세',
        hi: 'सेवा कार्ड विवरण',
        ar: 'تفاصيل بطاقة الخدمة'
    }
});

data.push({
    name: 'DepositPack',
    module: 'ar',
    display: {
        vi: 'Gói trả trước',
        en: 'Deposit Package',
        fr: 'Forfait prépayé',
        es: 'Paquete de depósito',
        id: 'Paket deposit',
        ja: 'デポジットパッケージ',
        zh: '预付套餐',
        ko: '보증금 패키지',
        hi: 'जमा पैकेज',
        ar: 'حزمة الإيداع'
    }
});
data.push({
    name: 'DepositCard',
    module: 'ar',
    display: {
        vi: 'Thẻ trả trước',
        en: 'Deposit Card',
        fr: 'Carte prépayée',
        es: 'Tarjeta de depósito',
        id: 'Kartu deposit',
        ja: 'デポジットカード',
        zh: '预付卡',
        ko: '보증금 카드',
        hi: 'जमा कार्ड',
        ar: 'بطاقة الإيداع'
    }
});

data.push({
    name: 'AREvent',
    module: 'event',
    display: {
        vi: 'Sự kiện',
        en: 'Event',
        fr: 'Événement',
        es: 'Evento',
        id: 'Acara',
        ja: 'イベント',
        zh: '活动',
        ko: '이벤트',
        hi: 'इवेंट',
        ar: 'الحدث'
    }
});
data.push({
    name: 'AREventItem',
    module: 'event',
    display: {
        vi: 'Chi tiết Sự kiện',
        en: 'Event Detail',
        fr: 'Détail événement',
        es: 'Detalle de evento',
        id: 'Detail acara',
        ja: 'イベント明細',
        zh: '活动明细',
        ko: '이벤트 상세',
        hi: 'इवेंट विवरण',
        ar: 'تفاصيل الحدث'
    }
});
data.push({
    name: 'AREventSession',
    module: 'event',
    display: {
        vi: 'Phiên sự kiện',
        en: 'Event Session',
        fr: 'Session événement',
        es: 'Sesión de evento',
        id: 'Sesi acara',
        ja: 'イベントセッション',
        zh: '活动场次',
        ko: '이벤트 세션',
        hi: 'इवेंट सत्र',
        ar: 'جلسة الحدث'
    }
});
data.push({
    name: 'AREventSessionStatus',
    module: 'event',
    display: {
        vi: 'Bán vé sự kiện',
        en: 'Event Session',
        fr: 'Session événement',
        es: 'Sesión de evento',
        id: 'Sesi acara',
        ja: 'イベントセッション',
        zh: '活动场次',
        ko: '이벤트 세션',
        hi: 'इवेंट सत्र',
        ar: 'جلسة الحدث'
    }
});
data.push({
    name: 'AREventTicket',
    module: 'event',
    display: {
        vi: 'Vé sự kiện',
        en: 'Event Ticket',
        fr: 'Billet événement',
        es: 'Boleto de evento',
        id: 'Tiket acara',
        ja: 'イベントチケット',
        zh: '活动门票',
        ko: '이벤트 티켓',
        hi: 'इवेंट टिकट',
        ar: 'تذكرة الحدث'
    }
});
data.push({
    name: 'AREventTicketItem',
    module: 'event',
    display: {
        vi: 'Chi tiết Vé',
        en: 'Event Ticket Detail',
        fr: 'Détail billet',
        es: 'Detalle de boleto',
        id: 'Detail tiket',
        ja: 'イベントチケット明細',
        zh: '门票明细',
        ko: '이벤트 티켓 상세',
        hi: 'इवेंट टिकट विवरण',
        ar: 'تفاصيل التذكرة'
    }
});

data.push({
    name: 'ARTravel',
    module: 'travel',
    display: { vi: 'Hành trình', en: 'Tour', fr: 'Circuit', es: 'Tour', id: 'Tur', ja: 'ツアー', zh: '旅游', ko: '투어', hi: 'टूर', ar: 'جولة' }
});
data.push({
    name: 'ARTravelItem',
    module: 'travel',
    display: {
        vi: 'Chi tiết hành trình',
        en: 'Tour Detail',
        fr: 'Détail circuit',
        es: 'Detalle de tour',
        id: 'Detail tur',
        ja: 'ツアー明細',
        zh: '旅游明细',
        ko: '투어 상세',
        hi: 'टूर विवरण',
        ar: 'تفاصيل الجولة'
    }
});
data.push({
    name: 'ARTravelSession',
    module: 'travel',
    display: {
        vi: 'Chuyến đi',
        en: 'Trip',
        fr: 'Voyage',
        es: 'Viaje',
        id: 'Perjalanan',
        ja: '旅行',
        zh: '行程',
        ko: '여행',
        hi: 'यात्रा',
        ar: 'رحلة'
    }
});
data.push({
    name: 'ARTravelSessionStatus',
    module: 'travel',
    display: {
        vi: 'Bán vé chuyến đi',
        en: 'Sale Trip',
        fr: 'Vente voyage',
        es: 'Venta de viaje',
        id: 'Jual perjalanan',
        ja: '旅行販売',
        zh: '销售行程',
        ko: '여행 판매',
        hi: 'यात्रा बिक्री',
        ar: 'بيع الرحلة'
    }
});
data.push({
    name: 'ARTravelTicket',
    module: 'travel',
    display: {
        vi: 'Vé chuyến đi',
        en: 'Trip Ticket',
        fr: 'Billet voyage',
        es: 'Boleto de viaje',
        id: 'Tiket perjalanan',
        ja: '旅行チケット',
        zh: '行程票',
        ko: '여행 티켓',
        hi: 'यात्रा टिकट',
        ar: 'تذكرة الرحلة'
    }
});

data.push({
    name: 'RentalObject',
    module: 'rental',
    display: {
        vi: 'Đối tượng thuê',
        en: 'Rental Object',
        fr: 'Objet de location',
        es: 'Objeto de alquiler',
        id: 'Objek sewa',
        ja: 'レンタル対象',
        zh: '租赁对象',
        ko: '대여 객체',
        hi: 'किराए की वस्तु',
        ar: 'كائن الإيجار'
    }
});
data.push({
    name: 'RentalVehicle',
    module: 'rental',
    display: {
        vi: 'Xe cho thuê',
        en: 'Rental Vehicle',
        fr: 'Véhicule de location',
        es: 'Vehículo de alquiler',
        id: 'Kendaraan sewa',
        ja: 'レンタカー',
        zh: '租赁车辆',
        ko: '렌터카',
        hi: 'किराए का वाहन',
        ar: 'سيارة إيجار'
    }
});
data.push({
    name: 'RentalRoom',
    module: 'rental',
    display: {
        vi: 'Phòng cho thuê',
        en: 'Rental Room',
        fr: 'Chambre de location',
        es: 'Habitación de alquiler',
        id: 'Kamar sewa',
        ja: 'レンタルルーム',
        zh: '租赁房间',
        ko: '대여 객실',
        hi: 'किराए का कमरा',
        ar: 'غرفة إيجار'
    }
});
data.push({
    name: 'RentalMachine',
    module: 'rental',
    display: {
        vi: 'Máy cho thuê',
        en: 'Rental Machine',
        fr: 'Machine de location',
        es: 'Máquina de alquiler',
        id: 'Mesin sewa',
        ja: 'レンタル機械',
        zh: '租赁机器',
        ko: '대여 기계',
        hi: 'किराए की मशीन',
        ar: 'آلة إيجار'
    }
});
data.push({
    name: 'RentalService',
    module: 'rental',
    display: {
        vi: 'Dịch vụ cho thuê',
        en: 'Rental Service',
        fr: 'Service de location',
        es: 'Servicio de alquiler',
        id: 'Layanan sewa',
        ja: 'レンタルサービス',
        zh: '租赁服务',
        ko: '대여 서비스',
        hi: 'किराए की सेवा',
        ar: 'خدمة الإيجار'
    }
});
data.push({
    name: 'RentalField',
    module: 'rental',
    display: {
        vi: 'Sân cho thuê',
        en: 'Rental Field',
        fr: 'Terrain de location',
        es: 'Campo de alquiler',
        id: 'Lapangan sewa',
        ja: 'レンタルフィールド',
        zh: '租赁场地',
        ko: '대여 필드',
        hi: 'किराए का मैदान',
        ar: 'ملعب إيجار'
    }
});
data.push({
    name: 'ARRentalItem',
    module: 'rental',
    display: {
        vi: 'Đối tượng cho thuê',
        en: 'Rental Item',
        fr: 'Article de location',
        es: 'Artículo de alquiler',
        id: 'Item sewa',
        ja: 'レンタル品',
        zh: '租赁物品',
        ko: '대여 품목',
        hi: 'किराए का आइटम',
        ar: 'صنف الإيجار'
    }
});
data.push({
    name: 'ARRentalBooking',
    module: 'rental',
    display: {
        vi: 'Đơn thuê',
        en: 'Rental Booking',
        fr: 'Réservation location',
        es: 'Reserva de alquiler',
        id: 'Pemesanan sewa',
        ja: 'レンタル予約',
        zh: '租赁预订',
        ko: '대여 예약',
        hi: 'किराया बुकिंग',
        ar: 'حجز الإيجار'
    }
});
data.push({
    name: 'ARRentalBookingItem',
    module: 'rental',
    display: {
        vi: 'Đơn thuê',
        en: 'Rental Booking',
        fr: 'Réservation location',
        es: 'Reserva de alquiler',
        id: 'Pemesanan sewa',
        ja: 'レンタル予約',
        zh: '租赁预订',
        ko: '대여 예약',
        hi: 'किराया बुकिंग',
        ar: 'حجز الإيجار'
    }
});
data.push({
    name: 'ARRentalRoomBooking',
    module: 'rental',
    display: {
        vi: 'Đặt phòng',
        en: 'Room Booking',
        fr: 'Réservation chambre',
        es: 'Reserva de habitación',
        id: 'Pemesanan kamar',
        ja: '部屋予約',
        zh: '房间预订',
        ko: '객실 예약',
        hi: 'कमरा बुकिंग',
        ar: 'حجز الغرفة'
    }
});
data.push({
    name: 'ARRentalVehicleBooking',
    module: 'rental',
    display: {
        vi: 'Thuê xe',
        en: 'Vehicle Booking',
        fr: 'Réservation véhicule',
        es: 'Reserva de vehículo',
        id: 'Pemesanan kendaraan',
        ja: '車両予約',
        zh: '车辆预订',
        ko: '차량 예약',
        hi: 'वाहन बुकिंग',
        ar: 'حجز السيارة'
    }
});
data.push({
    name: 'ARRentalFieldBooking',
    module: 'rental',
    display: {
        vi: 'Thuê sân',
        en: 'Field Booking',
        fr: 'Réservation terrain',
        es: 'Reserva de campo',
        id: 'Pemesanan lapangan',
        ja: 'フィールド予約',
        zh: '场地预订',
        ko: '필드 예약',
        hi: 'मैदान बुकिंग',
        ar: 'حجز الملعب'
    }
});
data.push({
    name: 'ARRentalMachineBooking',
    module: 'rental',
    display: {
        vi: 'Thuê máy',
        en: 'Machine Booking',
        fr: 'Réservation machine',
        es: 'Reserva de máquina',
        id: 'Pemesanan mesin',
        ja: '機械予約',
        zh: '机器预订',
        ko: '기계 예약',
        hi: 'मशीन बुकिंग',
        ar: 'حجز الآلة'
    }
});
data.push({
    name: 'ARRentalServiceBooking',
    module: 'rental',
    display: {
        vi: 'Thuê dịch vụ',
        en: 'Service Booking',
        fr: 'Réservation service',
        es: 'Reserva de servicio',
        id: 'Pemesanan layanan',
        ja: 'サービス予約',
        zh: '服务预订',
        ko: '서비스 예약',
        hi: 'सेवा बुकिंग',
        ar: 'حجز الخدمة'
    }
});

data.push({
    name: 'ServePlace',
    module: 'serve',
    display: {
        vi: 'Nơi phục vụ',
        en: 'Serve Place',
        fr: 'Lieu de service',
        es: 'Lugar de servicio',
        id: 'Tempat layanan',
        ja: 'サービス場所',
        zh: '服务地点',
        ko: '서비스 장소',
        hi: 'सेवा स्थान',
        ar: 'مكان الخدمة'
    }
});
data.push({
    name: 'ServeField',
    module: 'serve',
    display: {
        vi: 'Sân',
        en: 'Serve Field',
        fr: 'Terrain de service',
        es: 'Campo de servicio',
        id: 'Lapangan layanan',
        ja: 'サービスフィールド',
        zh: '服务场地',
        ko: '서비스 필드',
        hi: 'सेवा मैदान',
        ar: 'ملعب الخدمة'
    }
});
data.push({
    name: 'ServeRoom',
    module: 'serve',
    display: {
        vi: 'Phòng',
        en: 'Serve Room',
        fr: 'Salle de service',
        es: 'Sala de servicio',
        id: 'Ruang layanan',
        ja: 'サービスルーム',
        zh: '服务房间',
        ko: '서비스 룸',
        hi: 'सेवा कमरा',
        ar: 'غرفة الخدمة'
    }
});
data.push({
    name: 'ServeSeat',
    module: 'serve',
    display: {
        vi: 'Ghế',
        en: 'Serve Seat',
        fr: 'Siège de service',
        es: 'Asiento de servicio',
        id: 'Kursi layanan',
        ja: 'サービス席',
        zh: '服务座位',
        ko: '서비스 좌석',
        hi: 'सेवा सीट',
        ar: 'مقعد الخدمة'
    }
});
data.push({
    name: 'ServeTable',
    module: 'serve',
    display: {
        vi: 'Bàn',
        en: 'Serve Table',
        fr: 'Table de service',
        es: 'Mesa de servicio',
        id: 'Meja layanan',
        ja: 'サービステーブル',
        zh: '服务桌',
        ko: '서비스 테이블',
        hi: 'सेवा टेबल',
        ar: 'طاولة الخدمة'
    }
});
data.push({
    name: 'ARServeStatus',
    module: 'serve',
    display: {
        vi: 'Phục vụ',
        en: 'Serve Map',
        fr: 'Plan de service',
        es: 'Mapa de servicio',
        id: 'Peta layanan',
        ja: 'サービスマップ',
        zh: '服务地图',
        ko: '서비스 맵',
        hi: 'सेवा मैप',
        ar: 'خريطة الخدمة'
    }
});
data.push({
    name: 'ARServeAlwnRule',
    module: 'serve',
    display: {
        vi: 'Phụ cấp dịch vụ',
        en: 'Serving Allowance Rule',
        fr: "Règle d'indemnité service",
        es: 'Regla de asignación de servicio',
        id: 'Aturan tunjangan layanan',
        ja: 'サービス手当ルール',
        zh: '服务津贴规则',
        ko: '서비스 수당 규칙',
        hi: 'सेवा भत्ता नियम',
        ar: 'قاعدة بدل الخدمة'
    }
});
data.push({
    name: 'ARServeAlwnRuleGlobal',
    module: 'serve',
    display: {
        vi: 'Tính phụ cấp dịch vụ',
        en: 'Serving Allowance Rule',
        fr: "Règle d'indemnité service",
        es: 'Regla de asignación de servicio',
        id: 'Aturan tunjangan layanan',
        ja: 'サービス手当ルール',
        zh: '服务津贴规则',
        ko: '서비스 수당 규칙',
        hi: 'सेवा भत्ता नियम',
        ar: 'قاعدة بدل الخدمة'
    }
});
data.push({
    name: 'ARServeAlwnRuleOnItem',
    module: 'serve',
    display: {
        vi: 'Tính phụ cấp dịch vụ theo sản phẩm',
        en: 'Serving Allowance Rule On Item',
        fr: 'Règle indemnité par article',
        es: 'Regla asignación por artículo',
        id: 'Aturan tunjangan per item',
        ja: '品目別サービス手当ルール',
        zh: '按商品服务津贴规则',
        ko: '품목별 서비스 수당 규칙',
        hi: 'आइटम द्वारा सेवा भत्ता नियम',
        ar: 'قاعدة بدل الخدمة حسب الصنف'
    }
});
data.push({
    name: 'ARServeMonthlyDetail',
    module: 'serve',
    display: {
        vi: 'Phụ cấp thực hiện dịch vụ',
        en: 'Monthly Serving Allowance',
        fr: 'Indemnité service mensuelle',
        es: 'Asignación de servicio mensual',
        id: 'Tunjangan layanan bulanan',
        ja: '月次サービス手当',
        zh: '月度服务津贴',
        ko: '월 서비스 수당',
        hi: 'मासिक सेवा भत्ता',
        ar: 'بدل الخدمة الشهري'
    }
});
data.push({
    name: 'ARServeMonthlyReport',
    module: 'serve',
    display: {
        vi: 'Phụ cấp thực hiện dịch vụ',
        en: 'Monthly Serving Allowance',
        fr: 'Indemnité service mensuelle',
        es: 'Asignación de servicio mensual',
        id: 'Tunjangan layanan bulanan',
        ja: '月次サービス手当',
        zh: '月度服务津贴',
        ko: '월 서비스 수당',
        hi: 'मासिक सेवा भत्ता',
        ar: 'بدل الخدمة الشهري'
    }
});
data.push({
    name: 'ARServeMaterialIssue',
    module: 'serve',
    display: {
        vi: 'Xuất vật tư',
        en: 'Issue Serving Material',
        fr: 'Émission matériel service',
        es: 'Emisión de material de servicio',
        id: 'Pengeluaran bahan layanan',
        ja: 'サービス資材払出',
        zh: '服务材料领用',
        ko: '서비스 자재 출고',
        hi: 'सर्विंग मटेरियल जारी करें',
        ar: 'إصدار مواد الخدمة'
    }
});
data.push({
    name: 'ARServeMaterialIssueItem',
    module: 'serve',
    display: {
        vi: 'Xuất vật tư',
        en: 'Issue Serving Material',
        fr: 'Émission matériel service',
        es: 'Emisión de material de servicio',
        id: 'Pengeluaran bahan layanan',
        ja: 'サービス資材払出',
        zh: '服务材料领用',
        ko: '서비스 자재 출고',
        hi: 'सर्विंग मटेरियल जारी करें',
        ar: 'إصدار مواد الخدمة'
    }
});
data.push({
    name: 'ARServeMaterialCounting',
    module: 'serve',
    display: {
        vi: 'Kiểm NVL chế biến',
        en: 'Cooking Material Counting',
        fr: 'Comptage matériel cuisine',
        es: 'Conteo de material de cocina',
        id: 'Penghitungan bahan masak',
        ja: '調理材料棚卸',
        zh: '烹饪材料盘点',
        ko: '조리 재료 카운팅',
        hi: 'कुकिंग मटेरियल गिनती',
        ar: 'جرد مواد الطبخ'
    }
});
data.push({
    name: 'ARServeMaterialCountingItem',
    module: 'serve',
    display: {
        vi: 'Kiểm NVL chế biến',
        en: 'Cooking Material Counting',
        fr: 'Comptage matériel cuisine',
        es: 'Conteo de material de cocina',
        id: 'Penghitungan bahan masak',
        ja: '調理材料棚卸',
        zh: '烹饪材料盘点',
        ko: '조리 재료 카운팅',
        hi: 'कुकिंग मटेरियल गिनती',
        ar: 'جرد مواد الطبخ'
    }
});

data.push({
    name: 'ICReceipt',
    module: 'inv',
    display: {
        vi: 'Phiếu nhập kho',
        en: 'Inventory Receipt',
        fr: 'Réception stock',
        es: 'Recepción de inventario',
        id: 'Penerimaan stok',
        ja: '入庫',
        zh: '入库单',
        ko: '입고',
        hi: 'इन्वेंट्री रसीद',
        ar: 'استلام المخزون'
    }
});
data.push({
    name: 'ICReceiptItem',
    module: 'inv',
    display: {
        vi: 'Đề nghị nhập kho',
        en: 'Inventory Receipt Items',
        fr: 'Articles réception stock',
        es: 'Artículos de recepción',
        id: 'Item penerimaan',
        ja: '入庫明細',
        zh: '入库明细',
        ko: '입고 항목',
        hi: 'इन्वेंट्री रसीद आइटम',
        ar: 'بنود استلام المخزون'
    }
});
data.push({
    name: 'ICReceiptDetail',
    module: 'inv',
    display: {
        vi: 'Thực nhập kho',
        en: 'Inventory Receipted Items',
        fr: 'Articles réceptionnés',
        es: 'Artículos recibidos',
        id: 'Item diterima',
        ja: '入庫済み明細',
        zh: '已入库明细',
        ko: '입고 완료 항목',
        hi: 'प्राप्त आइटम',
        ar: 'البنود المستلمة'
    }
});
data.push({
    name: 'ICIssue',
    module: 'inv',
    display: {
        vi: 'Phiếu xuất kho',
        en: 'Inventory Issue',
        fr: 'Sortie stock',
        es: 'Emisión de inventario',
        id: 'Pengeluaran stok',
        ja: '出庫',
        zh: '出库单',
        ko: '출고',
        hi: 'इन्वेंट्री इश्यू',
        ar: 'إصدار المخزون'
    }
});
data.push({
    name: 'ICIssueItem',
    module: 'inv',
    display: {
        vi: 'Đề nghị xuất kho',
        en: 'Inventory Issue Items',
        fr: 'Articles sortie stock',
        es: 'Artículos de emisión',
        id: 'Item pengeluaran',
        ja: '出庫明細',
        zh: '出库明细',
        ko: '출고 항목',
        hi: 'इन्वेंट्री इश्यू आइटम',
        ar: 'بنود إصدار المخزون'
    }
});
data.push({
    name: 'ICIssueDetail',
    module: 'inv',
    display: {
        vi: 'Thực xuất kho',
        en: 'Inventory Issued Items',
        fr: 'Articles émis',
        es: 'Artículos emitidos',
        id: 'Item dikeluarkan',
        ja: '出庫済み明細',
        zh: '已出库明细',
        ko: '출고 완료 항목',
        hi: 'जारी किए गए आइटम',
        ar: 'البنود الصادرة'
    }
});
data.push({
    name: 'ICReceiptDetailSerial',
    module: 'inv',
    display: {
        vi: 'Receive Serial',
        en: 'Inventory Receive Serial',
        fr: 'Réception numéro série',
        es: 'Recepción de serie',
        id: 'Penerimaan serial',
        ja: 'シリアル入庫',
        zh: '序列号入库',
        ko: '시리얼 입고',
        hi: 'सीरियल प्राप्त करें',
        ar: 'استلام الرقم التسلسلي'
    }
});
data.push({
    name: 'ICReceiptDetailLot',
    module: 'inv',
    display: {
        vi: 'Receive Lot',
        en: 'Inventory Receive Lot',
        fr: 'Réception lot',
        es: 'Recepción de lote',
        id: 'Penerimaan lot',
        ja: 'ロット入庫',
        zh: '批次入库',
        ko: '로트 입고',
        hi: 'लॉट प्राप्त करें',
        ar: 'استلام الدفعة'
    }
});
data.push({
    name: 'ICAdjust',
    module: 'inv',
    display: {
        vi: 'Phiếu điều chỉnh kho',
        en: 'Inventory Adjust',
        fr: 'Ajustement stock',
        es: 'Ajuste de inventario',
        id: 'Penyesuaian stok',
        ja: '在庫調整',
        zh: '库存调整',
        ko: '재고 조정',
        hi: 'इन्वेंट्री समायोजन',
        ar: 'تسوية المخزون'
    }
});
data.push({
    name: 'ICAdjustItem',
    module: 'inv',
    display: {
        vi: 'Chi tiết điều chỉnh kho',
        en: 'Inventory Adjust Items',
        fr: 'Articles ajustement',
        es: 'Artículos de ajuste',
        id: 'Item penyesuaian',
        ja: '在庫調整明細',
        zh: '库存调整明细',
        ko: '재고 조정 항목',
        hi: 'समायोजन आइटम',
        ar: 'بنود تسوية المخزون'
    }
});
data.push({
    name: 'ICTransfer',
    module: 'inv',
    display: {
        vi: 'Phiếu chuyển kho',
        en: 'Inventory Transfer',
        fr: 'Transfert stock',
        es: 'Transferencia de inventario',
        id: 'Transfer stok',
        ja: '在庫移動',
        zh: '库存调拨',
        ko: '재고 이동',
        hi: 'इन्वेंट्री ट्रांसफर',
        ar: 'نقل المخزون'
    }
});
data.push({
    name: 'ICTransferItem',
    module: 'inv',
    display: {
        vi: 'Đề nghị chuyển kho',
        en: 'Inventory Transfer Items',
        fr: 'Articles transfert',
        es: 'Artículos de transferencia',
        id: 'Item transfer',
        ja: '在庫移動明細',
        zh: '调拨明细',
        ko: '재고 이동 항목',
        hi: 'ट्रांसफर आइटम',
        ar: 'بنود نقل المخزون'
    }
});
data.push({
    name: 'ICTransferIssueItem',
    module: 'inv',
    display: {
        vi: 'Thực xuất chuyển kho',
        en: 'Inventory Transfer Issued',
        fr: 'Transfert émis',
        es: 'Transferencia emitida',
        id: 'Transfer dikeluarkan',
        ja: '移動出庫',
        zh: '调拨出库',
        ko: '이동 출고',
        hi: 'ट्रांसफर जारी',
        ar: 'نقل صادر'
    }
});
data.push({
    name: 'ICTransferReceiptItem',
    module: 'inv',
    display: {
        vi: 'Thực nhận chuyển kho',
        en: 'Inventory Transfer Receipted',
        fr: 'Transfert reçu',
        es: 'Transferencia recibida',
        id: 'Transfer diterima',
        ja: '移動入庫',
        zh: '调拨入库',
        ko: '이동 입고',
        hi: 'ट्रांसफर प्राप्त',
        ar: 'نقل مستلم'
    }
});
data.push({
    name: 'ICTransferReturnItem',
    module: 'inv',
    display: {
        vi: 'Trả về sau chuyển kho',
        en: 'Inventory Transfer Returned',
        fr: 'Transfert retourné',
        es: 'Transferencia devuelta',
        id: 'Transfer dikembalikan',
        ja: '移動返品',
        zh: '调拨退回',
        ko: '이동 반품',
        hi: 'ट्रांसफर वापस',
        ar: 'نقل مرتجع'
    }
});
data.push({
    name: 'ICCounting',
    module: 'inv',
    display: {
        vi: 'Phiếu kiểm kho',
        en: 'Inventory Counting',
        fr: 'Comptage stock',
        es: 'Conteo de inventario',
        id: 'Penghitungan stok',
        ja: '棚卸',
        zh: '盘点',
        ko: '재고 실사',
        hi: 'इन्वेंट्री गिनती',
        ar: 'جرد المخزون'
    }
});
data.push({
    name: 'ICCountingItem',
    module: 'inv',
    display: {
        vi: 'Đề nghị kiểm kho',
        en: 'Inventory Counting Items',
        fr: 'Articles comptage',
        es: 'Artículos de conteo',
        id: 'Item penghitungan',
        ja: '棚卸明細',
        zh: '盘点明细',
        ko: '재고 실사 항목',
        hi: 'गिनती आइटम',
        ar: 'بنود جرد المخزون'
    }
});
data.push({
    name: 'ICCountingDetail',
    module: 'inv',
    display: {
        vi: 'Thực kiểm kho',
        en: 'Inventory Counted Items',
        fr: 'Articles comptés',
        es: 'Artículos contados',
        id: 'Item dihitung',
        ja: '棚卸済み明細',
        zh: '已盘点明细',
        ko: '실사 완료 항목',
        hi: 'गिने हुए आइटम',
        ar: 'البنود المجروده'
    }
});
data.push({
    name: 'ICInventory',
    module: 'inv',
    display: {
        vi: 'Tồn kho',
        en: 'Inventory Status',
        fr: 'État du stock',
        es: 'Estado del inventario',
        id: 'Status stok',
        ja: '在庫状況',
        zh: '库存状态',
        ko: '재고 상태',
        hi: 'इन्वेंट्री स्थिति',
        ar: 'حالة المخزون'
    }
});
data.push({
    name: 'ICInventorySerial',
    module: 'inv',
    display: {
        vi: 'Tồn kho Serial',
        en: 'Serial Inventory Status',
        fr: 'État stock série',
        es: 'Estado de inventario serial',
        id: 'Status stok serial',
        ja: 'シリアル在庫状況',
        zh: '序列号库存状态',
        ko: '시리얼 재고 상태',
        hi: 'सीरियल इन्वेंट्री स्थिति',
        ar: 'حالة مخزون الرقم التسلسلي'
    }
});
data.push({
    name: 'ICInventoryLot',
    module: 'inv',
    display: {
        vi: 'Tồn kho Mã Lô',
        en: 'Lot Inventory Status',
        fr: 'État stock lot',
        es: 'Estado de inventario lote',
        id: 'Status stok lot',
        ja: 'ロット在庫状況',
        zh: '批次库存状态',
        ko: '로트 재고 상태',
        hi: 'लॉट इन्वेंट्री स्थिति',
        ar: 'حالة مخزون الدفعة'
    }
});
data.push({
    name: 'ICMonthlyReport',
    module: 'inv',
    display: {
        vi: 'Nhập xuất tồn',
        en: 'Inventory Monthly Report',
        fr: 'Rapport mensuel stock',
        es: 'Informe mensual de inventario',
        id: 'Laporan stok bulanan',
        ja: '月次在庫レポート',
        zh: '月度库存报告',
        ko: '월간 재고 보고서',
        hi: 'मासिक इन्वेंट्री रिपोर्ट',
        ar: 'تقرير المخزون الشهري'
    }
});
data.push({
    name: 'ICValuation',
    module: 'inv',
    display: {
        vi: 'Giá vốn',
        en: 'Inventory Valuation',
        fr: 'Valorisation stock',
        es: 'Valoración de inventario',
        id: 'Valuasi stok',
        ja: '在庫評価',
        zh: '库存估值',
        ko: '재고 평가',
        hi: 'इन्वेंट्री मूल्यांकन',
        ar: 'تقييم المخزون'
    }
});

data.push({
    name: 'ICBOM',
    module: 'inv',
    display: {
        vi: 'Định mức lắp ráp',
        en: 'Assembly BOM',
        fr: 'Nomenclature assemblage',
        es: 'Lista de ensamblaje',
        id: 'BOM perakitan',
        ja: '組立部品表',
        zh: '组装物料清单',
        ko: '조립 BOM',
        hi: 'असेंबली BOM',
        ar: 'قائمة مواد التجميع'
    }
});
data.push({
    name: 'ICBOMItem',
    module: 'inv',
    display: {
        vi: 'Đầu vào lắp ráp',
        en: 'Assembly Input Item',
        fr: 'Article entrée assemblage',
        es: 'Artículo de entrada de ensamblaje',
        id: 'Item input perakitan',
        ja: '組立入力品目',
        zh: '组装输入项',
        ko: '조립 입력 품목',
        hi: 'असेंबली इनपुट आइटम',
        ar: 'بند إدخال التجميع'
    }
});
data.push({
    name: 'ICAssemblyOrder',
    module: 'inv',
    display: {
        vi: 'Lệnh lắp ráp',
        en: 'Assembly Order',
        fr: "Ordre d'assemblage",
        es: 'Orden de ensamblaje',
        id: 'Perintah perakitan',
        ja: '組立指示',
        zh: '组装指令',
        ko: '조립 주문',
        hi: 'असेंबली ऑर्डर',
        ar: 'أمر التجميع'
    }
});
data.push({
    name: 'ICDeassemblyOrder',
    module: 'inv',
    display: {
        vi: 'Lệnh phân rã',
        en: 'DeAssembly Order',
        fr: 'Ordre de désassemblage',
        es: 'Orden de desensamblaje',
        id: 'Perintah pembongkaran',
        ja: '分解指示',
        zh: '拆解指令',
        ko: '분해 주문',
        hi: 'डिसएसेंबली ऑर्डर',
        ar: 'أمر التفكيك'
    }
});
data.push({
    name: 'ICAssemblyOrderItem',
    module: 'inv',
    display: {
        vi: 'Chi tiết',
        en: 'Assembly Detail',
        fr: 'Détail assemblage',
        es: 'Detalle de ensamblaje',
        id: 'Detail perakitan',
        ja: '組立明細',
        zh: '组装明细',
        ko: '조립 상세',
        hi: 'असेंबली विवरण',
        ar: 'تفاصيل التجميع'
    }
});

data.push({
    name: 'SPCSourcingPolicy',
    module: 'spc',
    display: {
        vi: 'Quy tắc luân chuyển kho',
        en: 'Stock Transfer Rule',
        fr: 'Règle de transfert de stock',
        es: 'Regla de transferencia de stock',
        id: 'Aturan transfer stok',
        ja: '在庫移動ルール',
        zh: '库存转移规则',
        ko: '재고 이동 규칙',
        hi: 'स्टॉक ट्रांसफर नियम',
        ar: 'قاعدة نقل المخزون'
    }
});
data.push({
    name: 'SPCSourcingPolicyItem',
    module: 'spc',
    display: {
        vi: 'Chi tiết quy tắc',
        en: 'Rule Detail',
        fr: 'Détail de la règle',
        es: 'Detalle de la regla',
        id: 'Detail aturan',
        ja: 'ルール詳細',
        zh: '规则明细',
        ko: '규칙 상세',
        hi: 'नियम विवरण',
        ar: 'تفاصيل القاعدة'
    }
});

data.push({
    name: 'SPCPurchaseByICRule',
    module: 'spc',
    display: {
        vi: 'Quy tắc mua hàng bổ sung tồn kho',
        en: 'Inventory Purchase Rule',
        fr: 'Règle achat inventaire',
        es: 'Regla de compra de inventario',
        id: 'Aturan pembelian inventaris',
        ja: '在庫購入ルール',
        zh: '库存采购规则',
        ko: '재고 구매 규칙',
        hi: 'इन्वेंट्री खरीद नियम',
        ar: 'قاعدة شراء المخزون'
    }
});
data.push({
    name: 'SPCPurchaseByICRuleItem',
    module: 'spc',
    display: {
        vi: 'Chi tiết quy tắc',
        en: 'Rule Detail',
        fr: 'Détail de la règle',
        es: 'Detalle de la regla',
        id: 'Detail aturan',
        ja: 'ルール詳細',
        zh: '规则明细',
        ko: '규칙 상세',
        hi: 'नियम विवरण',
        ar: 'تفاصيل القاعدة'
    }
});

data.push({
    name: 'SPCPurchaseByARRule',
    module: 'spc',
    display: {
        vi: 'Quy tắc mua hàng bổ sung hàng bán',
        en: 'Revenue Purchase Rule',
        fr: 'Règle achat revenus',
        es: 'Regla de compra de ingresos',
        id: 'Aturan pembelian pendapatan',
        ja: '売上購入ルール',
        zh: '收入采购规则',
        ko: '매출 구매 규칙',
        hi: 'राजस्व खरीद नियम',
        ar: 'قاعدة شراء الإيرادات'
    }
});
data.push({
    name: 'SPCPurchaseByARRuleItem',
    module: 'spc',
    display: {
        vi: 'Chi tiết quy tắc',
        en: 'Rule Detail',
        fr: 'Détail de la règle',
        es: 'Detalle de la regla',
        id: 'Detail aturan',
        ja: 'ルール詳細',
        zh: '规则明细',
        ko: '규칙 상세',
        hi: 'नियम विवरण',
        ar: 'تفاصيل القاعدة'
    }
});
data.push({
    name: 'SPCDemandBatch',
    module: 'spc',
    display: {
        vi: 'Kế hoạch cung-cầu',
        en: 'Demand Planning',
        fr: 'Planification besoins',
        es: 'Planificación demanda',
        id: 'Perencanaan kebutuhan',
        ja: '需給計画',
        zh: '供需计划',
        ko: '수급 계획',
        hi: 'मांग योजना',
        ar: 'تخطيط الطلب'
    }
});
data.push({
    name: 'SPCDemand',
    module: 'spc',
    display: {
        vi: 'Nhu cầu cung ứng',
        en: 'Supply Demand',
        fr: 'Besoin approvisionnement',
        es: 'Demanda de suministro',
        id: 'Kebutuhan pasokan',
        ja: '供給需要',
        zh: '供应需求',
        ko: '공급 수요',
        hi: 'आपूर्ति मांग',
        ar: 'طلب التوريد'
    }
});

data.push({
    name: 'TaxVATDeclaration',
    module: 'tax',
    display: {
        vi: 'Tờ khai GTGT',
        en: 'VAT Declaration',
        fr: 'Déclaration de TVA',
        es: 'Declaración de IVA',
        id: 'SPT PPN',
        ja: 'VAT申告',
        zh: '增值税申报',
        ko: '부가세 신고',
        hi: 'वैट घोषणा',
        ar: 'إقرار ضريبة القيمة المضافة'
    }
});
data.push({
    name: 'TaxVATDeclarationLine',
    module: 'tax',
    display: {
        vi: 'Chi tiết tờ khai GTGT',
        en: 'VAT Declaration Line',
        fr: 'Ligne de déclaration TVA',
        es: 'Línea de declaración IVA',
        id: 'Baris SPT PPN',
        ja: 'VAT申告明細',
        zh: '增值税申报明细',
        ko: '부가세 신고 상세',
        hi: 'वैट घोषणा पंक्ति',
        ar: 'بند إقرار ضريبة القيمة المضافة'
    }
});
data.push({
    name: 'TaxVATDeclarationIndicator',
    module: 'tax',
    display: {
        vi: 'Chỉ tiêu tờ khai GTGT',
        en: 'VAT Declaration Indicator',
        fr: 'Indicateur de déclaration TVA',
        es: 'Indicador de declaración IVA',
        id: 'Indikator SPT PPN',
        ja: 'VAT申告欄',
        zh: '增值税申报栏次',
        ko: '부가세 신고 항목',
        hi: 'वैट घोषणा सूचक',
        ar: 'بند إقرار ضريبة القيمة المضافة'
    }
});

data.push({
    name: 'LGFreightRule',
    module: 'lg',
    display: {
        vi: 'Quy tắc tính cước',
        en: 'Freight Rule',
        fr: 'Règle de fret',
        es: 'Regla de flete',
        id: 'Aturan pengiriman',
        ja: '運賃ルール',
        zh: '运费规则',
        ko: '운임 규칙',
        hi: 'माल भाड़ा नियम',
        ar: 'قاعدة الشحن'
    }
});
data.push({
    name: 'LGOrder',
    module: 'lg',
    display: {
        vi: 'Đề nghị vận chuyển',
        en: 'Logistic Request',
        fr: 'Demande logistique',
        es: 'Solicitud logística',
        id: 'Permintaan logistik',
        ja: '物流依頼',
        zh: '物流请求',
        ko: '물류 요청',
        hi: 'लॉजिस्टिक अनुरोध',
        ar: 'طلب لوجستي'
    }
});
data.push({
    name: 'LGOrderItem',
    module: 'lg',
    display: {
        vi: 'Chi tiết đề nghị vận chuyển',
        en: 'Logistic Request Detail',
        fr: 'Détail demande logistique',
        es: 'Detalle solicitud logística',
        id: 'Detail permintaan logistik',
        ja: '物流依頼明細',
        zh: '物流请求明细',
        ko: '물류 요청 상세',
        hi: 'लॉजिस्टिक अनुरोध विवरण',
        ar: 'تفاصيل الطلب اللوجستي'
    }
});
data.push({
    name: 'LGTransport',
    module: 'lg',
    display: {
        vi: 'Vận đơn',
        en: 'Transport',
        fr: 'Transport',
        es: 'Transporte',
        id: 'Transportasi',
        ja: '輸送',
        zh: '运输',
        ko: '운송',
        hi: 'परिवहन',
        ar: 'النقل'
    }
});
data.push({
    name: 'LGTransportDetail',
    module: 'lg',
    display: {
        vi: 'Số Serial',
        en: 'Serials',
        fr: 'Numéros de série',
        es: 'Números de serie',
        id: 'Nomor seri',
        ja: 'シリアル番号',
        zh: '序列号',
        ko: '일련번호',
        hi: 'सीरियल नंबर',
        ar: 'الأرقام التسلسلية'
    }
});
data.push({
    name: 'LGLog',
    module: 'lg',
    display: {
        vi: 'Lịch sử vận đơn',
        en: 'Carrrier Logs',
        fr: 'Journaux transporteur',
        es: 'Registros del transportista',
        id: 'Log pengangkut',
        ja: '運送業者ログ',
        zh: '承运商日志',
        ko: '운송업체 로그',
        hi: 'कैरियर लॉग',
        ar: 'سجلات الناقل'
    }
});
data.push({
    name: 'LGSVCWarehouse',
    module: 'lg',
    display: {
        vi: 'Thuê vận chuyển theo kho',
        en: 'Carrier By Warehouse',
        fr: 'Transporteur par entrepôt',
        es: 'Transportista por almacén',
        id: 'Pengangkut per gudang',
        ja: '倉庫別運送業者',
        zh: '按仓库承运商',
        ko: '창고별 운송업체',
        hi: 'गोदाम द्वारा वाहक',
        ar: 'الناقل حسب المستودع'
    }
});
data.push({
    name: 'CarrierService',
    module: 'lg',
    display: {
        vi: 'Dịch vụ vận chuyển',
        en: 'Carrier Service',
        fr: 'Service de transport',
        es: 'Servicio de transporte',
        id: 'Layanan pengangkut',
        ja: '運送サービス',
        zh: '承运服务',
        ko: '운송 서비스',
        hi: 'कैरियर सेवा',
        ar: 'خدمة الناقل'
    }
});

data.push({
    name: 'HRWorkShift',
    module: 'timesheet',
    display: {
        vi: 'Ca làm việc',
        en: 'Working Shift',
        fr: 'Quart de travail',
        es: 'Turno de trabajo',
        id: 'Shift kerja',
        ja: '勤務シフト',
        zh: '工作班次',
        ko: '근무 교대',
        hi: 'कार्य शिफ्ट',
        ar: 'وردية العمل'
    }
});
data.push({
    name: 'HRWorkingAttendance',
    module: 'timesheet',
    display: {
        vi: 'Chấm công',
        en: 'Working Attendance',
        fr: 'Présence au travail',
        es: 'Asistencia laboral',
        id: 'Kehadiran kerja',
        ja: '勤怠',
        zh: '考勤',
        ko: '근태',
        hi: 'कार्य उपस्थिति',
        ar: 'حضور العمل'
    }
});
data.push({
    name: 'HRWorkingTimesheet',
    module: 'timesheet',
    display: {
        vi: 'Tính công',
        en: 'Working Timesheet',
        fr: 'Feuille de temps',
        es: 'Hoja de tiempo',
        id: 'Lembar waktu kerja',
        ja: '勤務表',
        zh: '工时表',
        ko: '근무 기록표',
        hi: 'कार्य समय पत्रक',
        ar: 'جدول ساعات العمل'
    }
});

data.push({ name: 'HRWorkingDay', module: 'timesheet', display: { vi: 'Công ngày', en: 'Workday', fr: 'Journée de travail', es: 'Día laboral', id: 'Hari kerja', ja: '勤務日', zh: '工作日', ko: '근무일', hi: 'कार्य दिवस', ar: 'يوم العمل' } });

data.push({
    name: 'HRWorkingSalary',
    module: 'payroll',
    display: {
        vi: 'Lương thời gian',
        en: 'Working Salary',
        fr: 'Salaire horaire',
        es: 'Salario por tiempo',
        id: 'Gaji waktu kerja',
        ja: '時間給',
        zh: '时薪',
        ko: '시간급',
        hi: 'कार्य वेतन',
        ar: 'راتب العمل'
    }
});
data.push({
    name: 'HRWorkingSalaryItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết lương thời gian',
        en: 'Working Salary Detail',
        fr: 'Détail salaire horaire',
        es: 'Detalle salario por tiempo',
        id: 'Detail gaji waktu kerja',
        ja: '時間給明細',
        zh: '时薪明细',
        ko: '시간급 상세',
        hi: 'कार्य वेतन विवरण',
        ar: 'تفاصيل راتب العمل'
    }
});
data.push({
    name: 'HRAdjust',
    module: 'payroll',
    display: {
        vi: 'Thưởng phạt',
        en: 'Payroll Adjustment',
        fr: 'Ajustement de paie',
        es: 'Ajuste de nómina',
        id: 'Penyesuaian gaji',
        ja: '給与調整',
        zh: '工资调整',
        ko: '급여 조정',
        hi: 'पेरोल समायोजन',
        ar: 'تعديل الرواتب'
    }
});
data.push({
    name: 'HRAdjustItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết Thưởng phạt',
        en: 'Payroll Adjustment Detail',
        fr: 'Détail ajustement paie',
        es: 'Detalle ajuste nómina',
        id: 'Detail penyesuaian gaji',
        ja: '給与調整明細',
        zh: '工资调整明细',
        ko: '급여 조정 상세',
        hi: 'पेरोल समायोजन विवरण',
        ar: 'تفاصيل تعديل الرواتب'
    }
});
data.push({
    name: 'HRCommision',
    module: 'payroll',
    display: {
        vi: 'Lương kinh doanh',
        en: 'Payroll Commission',
        fr: 'Commission de paie',
        es: 'Comisión de nómina',
        id: 'Komisi gaji',
        ja: '給与歩合',
        zh: '工资佣金',
        ko: '급여 커미션',
        hi: 'पेरोल कमीशन',
        ar: 'عمولة الرواتب'
    }
});
data.push({
    name: 'HRCommisionItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết lương kinh doanh',
        en: 'Payroll Commission Detail',
        fr: 'Détail commission paie',
        es: 'Detalle comisión nómina',
        id: 'Detail komisi gaji',
        ja: '給与歩合明細',
        zh: '工资佣金明细',
        ko: '급여 커미션 상세',
        hi: 'पेरोल कमीशन विवरण',
        ar: 'تفاصيل عمولة الرواتب'
    }
});
data.push({
    name: 'HRAllowance',
    module: 'payroll',
    display: {
        vi: 'Phụ cấp',
        en: 'Payroll Allowance',
        fr: 'Indemnité de paie',
        es: 'Subsidio de nómina',
        id: 'Tunjangan gaji',
        ja: '給与手当',
        zh: '工资津贴',
        ko: '급여 수당',
        hi: 'पेरोल भत्ता',
        ar: 'بدل الرواتب'
    }
});
data.push({
    name: 'HRAllowanceItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết Phụ cấp',
        en: 'Payroll Allowance Detail',
        fr: 'Détail indemnité paie',
        es: 'Detalle subsidio nómina',
        id: 'Detail tunjangan gaji',
        ja: '給与手当明細',
        zh: '工资津贴明细',
        ko: '급여 수당 상세',
        hi: 'पेरोल भत्ता विवरण',
        ar: 'تفاصيل بدل الرواتب'
    }
});
data.push({
    name: 'HROrder',
    module: 'payroll',
    display: {
        vi: 'Phiếu lương',
        en: 'Payroll Slip',
        fr: 'Fiche de paie',
        es: 'Recibo de nómina',
        id: 'Slip gaji',
        ja: '給与明細書',
        zh: '工资条',
        ko: '급여 명세서',
        hi: 'पेरोल स्लिप',
        ar: 'قسيمة الراتب'
    }
});
data.push({
    name: 'HROrderItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết Phiếu lương',
        en: 'Payroll Slip Detail',
        fr: 'Détail fiche de paie',
        es: 'Detalle recibo nómina',
        id: 'Detail slip gaji',
        ja: '給与明細書詳細',
        zh: '工资条明细',
        ko: '급여 명세서 상세',
        hi: 'पेरोल स्लिप विवरण',
        ar: 'تفاصيل قسيمة الراتب'
    }
});
data.push({
    name: 'HRCredit',
    module: 'payroll',
    display: {
        vi: 'Công nợ tiền lương',
        en: 'Payroll Credit',
        fr: 'Crédit de paie',
        es: 'Crédito de nómina',
        id: 'Kredit gaji',
        ja: '給与掛金',
        zh: '工资信用',
        ko: '급여 외상',
        hi: 'पेरोल क्रेडिट',
        ar: 'ائتمان الرواتب'
    }
});
data.push({
    name: 'HRCreditItem',
    module: 'payroll',
    display: {
        vi: 'Chi tiết Công nợ tiền lương',
        en: 'Payroll Credit Detail',
        fr: 'Détail crédit de paie',
        es: 'Detalle crédito nómina',
        id: 'Detail kredit gaji',
        ja: '給与掛金明細',
        zh: '工资信用明细',
        ko: '급여 외상 상세',
        hi: 'पेरोल क्रेडिट विवरण',
        ar: 'تفاصيل ائتمان الرواتب'
    }
});
data.push({
    name: 'HRPayment',
    module: 'payroll',
    display: {
        vi: 'Trả lương',
        en: 'Payroll Disbursement',
        fr: 'Décaissement de paie',
        es: 'Desembolso de nómina',
        id: 'Pencairan gaji',
        ja: '給与支払',
        zh: '工资发放',
        ko: '급여 지급',
        hi: 'पेरोल वितरण',
        ar: 'صرف الرواتب'
    }
});

data.push({
    name: 'CAAccount',
    module: 'ca',
    display: {
        vi: 'Tài khoản tiền',
        en: 'Cash Account',
        fr: 'Compte de caisse',
        es: 'Cuenta de caja',
        id: 'Akun kas',
        ja: '現金勘定',
        zh: '现金账户',
        ko: '현금 계정',
        hi: 'नकद खाता',
        ar: 'حساب النقدية'
    }
});
data.push({
    name: 'CARequest',
    module: 'ca',
    display: {
        vi: 'Đề nghị thu/chi',
        en: 'Cash Request',
        fr: 'Demande de caisse',
        es: 'Solicitud de caja',
        id: 'Permintaan kas',
        ja: '現金依頼',
        zh: '现金请求',
        ko: '현금 요청',
        hi: 'नकद अनुरोध',
        ar: 'طلب نقدي'
    }
});
data.push({
    name: 'CARequestItem',
    module: 'ca',
    display: {
        vi: 'Chi tiết đề nghị thu/chi',
        en: 'Cash Request Detail',
        fr: 'Détail demande caisse',
        es: 'Detalle solicitud caja',
        id: 'Detail permintaan kas',
        ja: '現金依頼明細',
        zh: '现金请求明细',
        ko: '현금 요청 상세',
        hi: 'नकद अनुरोध विवरण',
        ar: 'تفاصيل الطلب النقدي'
    }
});
data.push({
    name: 'CAApply',
    module: 'ca',
    display: {
        vi: 'Thanh toán',
        en: 'Payment',
        fr: 'Paiement',
        es: 'Pago',
        id: 'Pembayaran',
        ja: '支払',
        zh: '付款',
        ko: '결제',
        hi: 'भुगतान',
        ar: 'الدفع'
    }
});
data.push({
    name: 'CAIssue',
    module: 'ca',
    display: {
        vi: 'Phiếu chi',
        en: 'Cash Out',
        fr: 'Décaissement',
        es: 'Retiro de efectivo',
        id: 'Pengeluaran kas',
        ja: '出金',
        zh: '现金支出',
        ko: '출금',
        hi: 'नकद निकासी',
        ar: 'صرف نقدي'
    }
});
data.push({
    name: 'CAIssueItem',
    module: 'ca',
    display: {
        vi: 'Chi tiết Phiếu chi',
        en: 'Cash Out Detail',
        fr: 'Détail décaissement',
        es: 'Detalle retiro efectivo',
        id: 'Detail pengeluaran kas',
        ja: '出金明細',
        zh: '现金支出明细',
        ko: '출금 상세',
        hi: 'नकद निकासी विवरण',
        ar: 'تفاصيل الصرف النقدي'
    }
});
data.push({
    name: 'CAReceive',
    module: 'ca',
    display: {
        vi: 'Phiếu thu',
        en: 'Cash In',
        fr: 'Encaissement',
        es: 'Ingreso de efectivo',
        id: 'Penerimaan kas',
        ja: '入金',
        zh: '现金收入',
        ko: '입금',
        hi: 'नकद जमा',
        ar: 'إيداع نقدي'
    }
});
data.push({
    name: 'CAReceiveItem',
    module: 'ca',
    display: {
        vi: 'Chi tiết Phiếu thu',
        en: 'Cash In Detail',
        fr: 'Détail encaissement',
        es: 'Detalle ingreso efectivo',
        id: 'Detail penerimaan kas',
        ja: '入金明細',
        zh: '现金收入明细',
        ko: '입금 상세',
        hi: 'नकद जमा विवरण',
        ar: 'تفاصيل الإيداع النقدي'
    }
});

data.push({
    name: 'CATransfer',
    module: 'ca',
    display: {
        vi: 'Phiếu chuyển tiền',
        en: 'Cash Transfer',
        fr: 'Transfert de caisse',
        es: 'Transferencia de caja',
        id: 'Transfer kas',
        ja: '現金振替',
        zh: '现金转账',
        ko: '현금 이체',
        hi: 'नकद हस्तांतरण',
        ar: 'تحويل نقدي'
    }
});
data.push({
    name: 'CAAdjust',
    module: 'ca',
    display: {
        vi: 'Phiếu điều chỉnh',
        en: 'Cash Adjustment',
        fr: 'Ajustement de caisse',
        es: 'Ajuste de caja',
        id: 'Penyesuaian kas',
        ja: '現金調整',
        zh: '现金调整',
        ko: '현금 조정',
        hi: 'नकद समायोजन',
        ar: 'تسوية نقدية'
    }
});
data.push({
    name: 'CABankStatement',
    module: 'ca',
    display: {
        vi: 'Đối soát ngân hàng',
        en: 'Bank Reconciliation',
        fr: 'Rapprochement bancaire',
        es: 'Conciliación bancaria',
        id: 'Rekonsiliasi bank',
        ja: '銀行照合',
        zh: '银行对账',
        ko: '은행 대사',
        hi: 'बैंक सामंजस्य',
        ar: 'التسوية البنكية'
    }
});

data.push({
    name: 'Customer',
    module: 'entity',
    display: {
        vi: 'Khách hàng',
        en: 'Customer',
        fr: 'Client',
        es: 'Cliente',
        id: 'Pelanggan',
        ja: '顧客',
        zh: '客户',
        ko: '고객',
        hi: 'ग्राहक',
        ar: 'العميل'
    }
});
data.push({
    name: 'Vendor',
    module: 'entity',
    display: {
        vi: 'Người bán',
        en: 'Vendor',
        fr: 'Fournisseur',
        es: 'Proveedor',
        id: 'Vendor',
        ja: 'ベンダー',
        zh: '供应商',
        ko: '공급업체',
        hi: 'विक्रेता',
        ar: 'المورد'
    }
});
data.push({
    name: 'Supplier',
    module: 'entity',
    display: {
        vi: 'Nhà cung cấp',
        en: 'Supplier',
        fr: 'Fournisseur',
        es: 'Proveedor',
        id: 'Pemasok',
        ja: 'サプライヤー',
        zh: '供货商',
        ko: '공급자',
        hi: 'आपूर्तिकर्ता',
        ar: 'المورد'
    }
});
data.push({
    name: 'Carrier',
    module: 'entity',
    display: {
        vi: 'Đơn vị vận chuyển',
        en: 'Carrier',
        fr: 'Transporteur',
        es: 'Transportista',
        id: 'Pengangkut',
        ja: '運送業者',
        zh: '承运商',
        ko: '운송업체',
        hi: 'वाहक',
        ar: 'الناقل'
    }
});
data.push({
    name: 'Employee',
    module: 'entity',
    display: {
        vi: 'Nhân viên',
        en: 'Employee',
        fr: 'Employé',
        es: 'Empleado',
        id: 'Karyawan',
        ja: '従業員',
        zh: '员工',
        ko: '직원',
        hi: 'कर्मचारी',
        ar: 'الموظف'
    }
});
data.push({
    name: 'GovEntity',
    module: 'entity',
    display: {
        vi: 'Thuế/hải quan',
        en: 'Government',
        fr: 'Gouvernement',
        es: 'Gobierno',
        id: 'Pemerintah',
        ja: '政府',
        zh: '政府',
        ko: '정부',
        hi: 'सरकार',
        ar: 'الحكومة'
    }
});

data.push({
    name: 'SaleChannel',
    module: 'org',
    display: {
        vi: 'Kênh bán',
        en: 'Sale Channel',
        fr: 'Canal de vente',
        es: 'Canal de venta',
        id: 'Saluran penjualan',
        ja: '販売チャネル',
        zh: '销售渠道',
        ko: '판매 채널',
        hi: 'बिक्री चैनल',
        ar: 'قناة البيع'
    }
});
data.push({
    name: 'Store',
    module: 'org',
    display: { vi: 'Cửa hàng', en: 'Store', fr: 'Magasin', es: 'Tienda', id: 'Toko', ja: '店舗', zh: '门店', ko: '매장', hi: 'स्टोर', ar: 'المتجر' }
});

data.push({
    name: 'Warehouse',
    module: 'org',
    display: {
        vi: 'Kho hàng',
        en: 'Warehouse',
        fr: 'Entrepôt',
        es: 'Almacén',
        id: 'Gudang',
        ja: '倉庫',
        zh: '仓库',
        ko: '창고',
        hi: 'गोदाम',
        ar: 'المستودع'
    }
});

data.push({
    name: 'UOM',
    module: 'item',
    display: {
        vi: 'Đơn vị tính',
        en: 'UOM',
        fr: 'Unité de mesure',
        es: 'Unidad de medida',
        id: 'Satuan',
        ja: '単位',
        zh: '单位',
        ko: '단위',
        hi: 'माप इकाई',
        ar: 'وحدة القياس'
    }
});
data.push({
    name: 'Item',
    module: 'item',
    display: { vi: 'Mặt hàng', en: 'Item', fr: 'Article', es: 'Artículo', id: 'Barang', ja: '品目', zh: '物品', ko: '품목', hi: 'आइटम', ar: 'الصنف' }
});
data.push({
    name: 'Good',
    module: 'item',
    display: {
        vi: 'Hàng hóa',
        en: 'Commodity',
        fr: 'Marchandise',
        es: 'Mercancía',
        id: 'Komoditas',
        ja: '商品',
        zh: '商品',
        ko: '상품',
        hi: 'वस्तु',
        ar: 'السلعة'
    }
});
data.push({
    name: 'Material',
    module: 'item',
    display: {
        vi: 'Nguyên liệu',
        en: 'Material',
        fr: 'Matériau',
        es: 'Material',
        id: 'Bahan',
        ja: '材料',
        zh: '材料',
        ko: '자재',
        hi: 'सामग्री',
        ar: 'المادة'
    }
});
data.push({
    name: 'Consumable',
    module: 'item',
    display: {
        vi: 'Phụ liệu',
        en: 'Consumable',
        fr: 'Consommable',
        es: 'Consumible',
        id: 'Bahan habis pakai',
        ja: '消耗品',
        zh: '消耗品',
        ko: '소모품',
        hi: 'उपभोज्य',
        ar: 'المستهلكات'
    }
});
data.push({
    name: 'Food',
    module: 'item',
    display: { vi: 'Món ăn', en: 'Food', fr: 'Nourriture', es: 'Comida', id: 'Makanan', ja: '料理', zh: '食品', ko: '음식', hi: 'भोजन', ar: 'الطعام' }
});
data.push({
    name: 'Beverage',
    module: 'item',
    display: {
        vi: 'Đồ uống',
        en: 'Beverage',
        fr: 'Boisson',
        es: 'Bebida',
        id: 'Minuman',
        ja: '飲料',
        zh: '饮料',
        ko: '음료',
        hi: 'पेय',
        ar: 'المشروبات'
    }
});
data.push({
    name: 'ExtraFee',
    module: 'item',
    display: {
        vi: 'Phụ phí',
        en: 'ExtraFee',
        fr: 'Frais supplémentaires',
        es: 'Cargo adicional',
        id: 'Biaya tambahan',
        ja: '追加料金',
        zh: '附加费',
        ko: '추가 요금',
        hi: 'अतिरिक्त शुल्क',
        ar: 'رسوم إضافية'
    }
});
data.push({
    name: 'FixedService',
    module: 'item',
    display: {
        vi: 'Dịch vụ',
        en: 'Instant Service',
        fr: 'Service instantané',
        es: 'Servicio instantáneo',
        id: 'Layanan instan',
        ja: '即時サービス',
        zh: '即时服务',
        ko: '즉시 서비스',
        hi: 'तत्काल सेवा',
        ar: 'خدمة فورية'
    }
});
data.push({
    name: 'ExpandableService',
    module: 'item',
    display: {
        vi: 'Dịch vụ theo giờ',
        en: 'Timming Service',
        fr: 'Service horaire',
        es: 'Servicio por hora',
        id: 'Layanan per jam',
        ja: '時間制サービス',
        zh: '计时服务',
        ko: '시간제 서비스',
        hi: 'समय आधारित सेवा',
        ar: 'خدمة بالساعة'
    }
});
data.push({
    name: 'Variant',
    module: 'item',
    display: {
        vi: 'Biến thể',
        en: 'Item Variant',
        fr: 'Variante article',
        es: 'Variante de artículo',
        id: 'Varian barang',
        ja: '品目バリアント',
        zh: '商品变体',
        ko: '품목 변형',
        hi: 'आइटम वेरिएंट',
        ar: 'متغير الصنف'
    }
});

data.push({
    name: 'EXPItem',
    module: 'exp',
    display: {
        vi: 'Danh mục chi phí',
        en: 'Expense items',
        fr: 'Postes de dépense',
        es: 'Partidas de gasto',
        id: 'Item pengeluaran',
        ja: '経費項目',
        zh: '费用项目',
        ko: '비용 항목',
        hi: 'व्यय मद',
        ar: 'بنود المصروفات'
    }
});

data.push({
    name: 'EXPOrder',
    module: 'exp',
    display: {
        vi: 'Phiếu chi tiêu',
        en: 'Expense Order',
        fr: 'Ordre de dépense',
        es: 'Orden de gasto',
        id: 'Order pengeluaran',
        ja: '経費オーダー',
        zh: '费用订单',
        ko: '비용 주문',
        hi: 'व्यय आदेश',
        ar: 'أمر المصروفات'
    }
});
data.push({
    name: 'EXPOrderItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Phiếu chi tiêu',
        en: 'Expense Order Detail',
        fr: 'Détail ordre dépense',
        es: 'Detalle orden gasto',
        id: 'Detail order pengeluaran',
        ja: '経費オーダー明細',
        zh: '费用订单明细',
        ko: '비용 주문 상세',
        hi: 'व्यय आदेश विवरण',
        ar: 'تفاصيل أمر المصروفات'
    }
});

data.push({
    name: 'EXPCredit',
    module: 'exp',
    display: {
        vi: 'Công nợ phải trả',
        en: 'Expense Credit',
        fr: 'Crédit de dépense',
        es: 'Crédito de gasto',
        id: 'Kredit pengeluaran',
        ja: '経費掛金',
        zh: '费用信用',
        ko: '비용 외상',
        hi: 'व्यय क्रेडिट',
        ar: 'ائتمان المصروفات'
    }
});
data.push({
    name: 'EXPCreditItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Công nợ phải trả',
        en: 'Expense Credit Detail',
        fr: 'Détail crédit dépense',
        es: 'Detalle crédito gasto',
        id: 'Detail kredit pengeluaran',
        ja: '経費掛金明細',
        zh: '费用信用明细',
        ko: '비용 외상 상세',
        hi: 'व्यय क्रेडिट विवरण',
        ar: 'تفاصيل ائتمان المصروفات'
    }
});

data.push({
    name: 'EXPCost',
    module: 'exp',
    display: {
        vi: 'Trích chi phí',
        en: 'Expense Posting',
        fr: 'Imputation dépense',
        es: 'Contabilización gasto',
        id: 'Posting pengeluaran',
        ja: '経費計上',
        zh: '费用过账',
        ko: '비용 전기',
        hi: 'व्यय पोस्टिंग',
        ar: 'ترحيل المصروفات'
    }
});
data.push({
    name: 'EXPCostItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Trích chi phí',
        en: 'Expense Posting Detail',
        fr: 'Détail imputation dépense',
        es: 'Detalle contabilización',
        id: 'Detail posting pengeluaran',
        ja: '経費計上明細',
        zh: '费用过账明细',
        ko: '비용 전기 상세',
        hi: 'व्यय पोस्टिंग विवरण',
        ar: 'تفاصيل ترحيل المصروفات'
    }
});

data.push({
    name: 'EXPInvoice',
    module: 'exp',
    display: {
        vi: 'Hóa đơn phải trả',
        en: 'Expense Invoice',
        fr: 'Facture de dépense',
        es: 'Factura de gasto',
        id: 'Faktur pengeluaran',
        ja: '経費請求書',
        zh: '费用发票',
        ko: '비용 송장',
        hi: 'व्यय चालान',
        ar: 'فاتورة المصروفات'
    }
});
data.push({
    name: 'EXPInvoiceItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Hóa đơn phải trả',
        en: 'Expense Invoice Detail',
        fr: 'Détail facture dépense',
        es: 'Detalle factura gasto',
        id: 'Detail faktur pengeluaran',
        ja: '経費請求書明細',
        zh: '费用发票明细',
        ko: '비용 송장 상세',
        hi: 'व्यय चालान विवरण',
        ar: 'تفاصيل فاتورة المصروفات'
    }
});

data.push({
    name: 'EXPAllocate',
    module: 'exp',
    display: {
        vi: 'Phân bổ chi phí',
        en: 'Expense Allocate',
        fr: 'Allocation dépense',
        es: 'Asignación de gasto',
        id: 'Alokasi pengeluaran',
        ja: '経費配賦',
        zh: '费用分配',
        ko: '비용 배분',
        hi: 'व्यय आवंटन',
        ar: 'تخصيص المصروفات'
    }
});
data.push({
    name: 'EXPAllocatePM',
    module: 'exp',
    display: {
        vi: 'Phân bổ chi phí dự án',
        en: 'Project Expense Allocatation',
        fr: 'Allocation dépense projet',
        es: 'Asignación gasto proyecto',
        id: 'Alokasi pengeluaran proyek',
        ja: 'プロジェクト経費配賦',
        zh: '项目费用分配',
        ko: '프로젝트 비용 배분',
        hi: 'परियोजना व्यय आवंटन',
        ar: 'تخصيص مصروفات المشروع'
    }
});
data.push({
    name: 'EXPAllocateAP',
    module: 'exp',
    display: {
        vi: 'Phân bổ chi phí mua hàng',
        en: 'Purchase LandedCost Allocatation',
        fr: 'Allocation coût rendu',
        es: 'Asignación costo destino',
        id: 'Alokasi biaya landed',
        ja: '購入諸掛配賦',
        zh: '采购落地成本分配',
        ko: '구매 랜디드코스트 배분',
        hi: 'खरीद लैंडेड कॉस्ट आवंटन',
        ar: 'تخصيص تكلفة الشراء المحملة'
    }
});
data.push({
    name: 'EXPAllocateInput',
    module: 'exp',
    display: {
        vi: 'Tập hợp chi phí',
        en: 'Expense Allocate Input',
        fr: 'Entrée allocation dépense',
        es: 'Entrada asignación gasto',
        id: 'Input alokasi pengeluaran',
        ja: '経費配賦入力',
        zh: '费用分配输入',
        ko: '비용 배분 입력',
        hi: 'व्यय आवंटन इनपुट',
        ar: 'إدخال تخصيص المصروفات'
    }
});

data.push({
    name: 'EXPGeneralOrder',
    module: 'exp',
    display: {
        vi: 'Phiếu chi tiêu',
        en: 'Payable Voucher',
        fr: 'Bon à payer',
        es: 'Comprobante por pagar',
        id: 'Voucher hutang',
        ja: '支払伝票',
        zh: '应付凭证',
        ko: '지급 전표',
        hi: 'देय वाउचर',
        ar: 'قسيمة الدائنين'
    }
});
data.push({
    name: 'EXPPurchaseOrder',
    module: 'exp',
    display: {
        vi: 'Mua hàng',
        en: 'Purchases',
        fr: 'Achats',
        es: 'Compras',
        id: 'Pembelian',
        ja: '仕入',
        zh: '采购',
        ko: '매입',
        hi: 'खरीद',
        ar: 'المشتريات'
    }
});
data.push({
    name: 'EXPImportDutyOrder',
    module: 'exp',
    display: {
        vi: 'Nhập khẩu',
        en: 'Imports',
        fr: 'Importations',
        es: 'Importaciones',
        id: 'Impor',
        ja: '輸入',
        zh: '进口',
        ko: '수입',
        hi: 'आयात',
        ar: 'الاستيراد'
    }
});
data.push({
    name: 'EXPPayrollOrder',
    module: 'exp',
    display: {
        vi: 'Bảng lương',
        en: 'Payroll',
        fr: 'Paie',
        es: 'Nómina',
        id: 'Penggajian',
        ja: '給与',
        zh: '工资单',
        ko: '급여',
        hi: 'वेतन',
        ar: 'الرواتب'
    }
});
data.push({
    name: 'EXPInsuranceOrder',
    module: 'exp',
    display: {
        vi: 'Bảo hiểm',
        en: 'Insurance',
        fr: 'Assurance',
        es: 'Seguros',
        id: 'Asuransi',
        ja: '保険',
        zh: '保险',
        ko: '보험',
        hi: 'बीमा',
        ar: 'التأمين'
    }
});
data.push({
    name: 'EXPTaxOrder',
    module: 'exp',
    display: {
        vi: 'Nộp thuế, phí',
        en: 'Taxes & Fees',
        fr: 'Impôts et taxes',
        es: 'Impuestos y tasas',
        id: 'Pajak dan biaya',
        ja: '税金・手数料',
        zh: '税费',
        ko: '세금 및 수수료',
        hi: 'कर और शुल्क',
        ar: 'الضرائب والرسوم'
    }
});
data.push({
    name: 'EXPLogisticOrder',
    module: 'exp',
    display: {
        vi: 'Chi phí vận tải',
        en: 'Logistic Fee',
        fr: 'Frais logistique',
        es: 'Cargo logístico',
        id: 'Biaya logistik',
        ja: '物流費',
        zh: '物流费用',
        ko: '물류 비용',
        hi: 'लॉजिस्टिक शुल्क',
        ar: 'رسوم النقل'
    }
});
data.push({
    name: 'EXPAssetProcurementOrder',
    module: 'exp',
    display: {
        vi: 'Mua sắm tài sản',
        en: 'Asset Procurement',
        fr: 'Acquisition actif',
        es: 'Adquisición de activo',
        id: 'Pengadaan aset',
        ja: '資産調達',
        zh: '资产采购',
        ko: '자산 조달',
        hi: 'संपत्ति खरीद',
        ar: 'شراء الأصول'
    }
});
data.push({
    name: 'EXPAssetProcurementOrderItem',
    module: 'exp',
    display: {
        vi: 'Mua sắm tài sản',
        en: 'Asset Procurement',
        fr: 'Acquisition actif',
        es: 'Adquisición de activo',
        id: 'Pengadaan aset',
        ja: '資産調達',
        zh: '资产采购',
        ko: '자산 조달',
        hi: 'संपत्ति खरीद',
        ar: 'شراء الأصول'
    }
});
data.push({
    name: 'EXPEquipmentProcurementOrder',
    module: 'exp',
    display: {
        vi: 'Mua sắm Công Cụ',
        en: 'Equipment Procurement',
        fr: 'Acquisition équipement',
        es: 'Adquisición de equipo',
        id: 'Pengadaan alat',
        ja: '備品調達',
        zh: '设备采购',
        ko: '장비 조달',
        hi: 'उपकरण खरीद',
        ar: 'شراء المعدات'
    }
});
data.push({
    name: 'EXPEquipmentProcurementOrderItem',
    module: 'exp',
    display: {
        vi: 'Mua sắm Công Cụ',
        en: 'Equipment Procurement',
        fr: 'Acquisition équipement',
        es: 'Adquisición de equipo',
        id: 'Pengadaan alat',
        ja: '備品調達',
        zh: '设备采购',
        ko: '장비 조달',
        hi: 'उपकरण खरीद',
        ar: 'شراء المعدات'
    }
});
data.push({
    name: 'EXPExtraPayableOrder',
    module: 'exp',
    display: {
        vi: 'Phải trả khác',
        en: 'ExtraPayable',
        fr: 'Autre à payer',
        es: 'Otro por pagar',
        id: 'Hutang lainnya',
        ja: 'その他支払',
        zh: '其他应付',
        ko: '기타 지급',
        hi: 'अन्य देय',
        ar: 'مستحقات أخرى'
    }
});

data.push({
    name: 'EXROrder',
    module: 'exp',
    display: {
        vi: 'Phiếu phải thu',
        en: 'Receivable Voucher',
        fr: 'Bon à recevoir',
        es: 'Comprobante por cobrar',
        id: 'Voucher piutang',
        ja: '受取伝票',
        zh: '应收凭证',
        ko: '수취 전표',
        hi: 'प्राप्य वाउचर',
        ar: 'قسيمة المدينين'
    }
});
data.push({
    name: 'EXROtherOrder',
    module: 'exp',
    display: {
        vi: 'Phải thu khác',
        en: 'Other Receivables',
        fr: 'Autres créances',
        es: 'Otras cuentas por cobrar',
        id: 'Piutang lain',
        ja: 'その他未収金',
        zh: '其他应收',
        ko: '기타 미수금',
        hi: 'अन्य प्राप्य',
        ar: 'ذمم أخرى'
    }
});
data.push({
    name: 'EXROrderItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Phiếu phải thu',
        en: 'Receivable Voucher Detail',
        fr: 'Détail bon à recevoir',
        es: 'Detalle comprobante cobrar',
        id: 'Detail voucher piutang',
        ja: '受取伝票明細',
        zh: '应收凭证明细',
        ko: '수취 전표 상세',
        hi: 'प्राप्य वाउचर विवरण',
        ar: 'تفاصيل قسيمة المدينين'
    }
});

data.push({
    name: 'EXRCredit',
    module: 'exp',
    display: {
        vi: 'Công nợ phải thu',
        en: 'Receivable Credit',
        fr: 'Crédit à recevoir',
        es: 'Crédito por cobrar',
        id: 'Kredit piutang',
        ja: '受取掛金',
        zh: '应收信用',
        ko: '수취 외상',
        hi: 'प्राप्य क्रेडिट',
        ar: 'ائتمان المدينين'
    }
});
data.push({
    name: 'EXRCreditItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Công nợ phải thu',
        en: 'Receivable Credit Detail',
        fr: 'Détail crédit recevoir',
        es: 'Detalle crédito cobrar',
        id: 'Detail kredit piutang',
        ja: '受取掛金明細',
        zh: '应收信用明细',
        ko: '수취 외상 상세',
        hi: 'प्राप्य क्रेडिट विवरण',
        ar: 'تفاصيل ائتمان المدينين'
    }
});

data.push({
    name: 'EXRRevenue',
    module: 'exp',
    display: {
        vi: 'Trích doanh thu',
        en: 'Receivable Posting',
        fr: 'Imputation recette',
        es: 'Contabilización cobro',
        id: 'Posting piutang',
        ja: '収益計上',
        zh: '应收过账',
        ko: '수취 전기',
        hi: 'प्राप्य पोस्टिंग',
        ar: 'ترحيل المدينين'
    }
});
data.push({
    name: 'EXRRevenueItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Trích doanh thu',
        en: 'Receivable Posting Detail',
        fr: 'Détail imputation recette',
        es: 'Detalle contabilización',
        id: 'Detail posting piutang',
        ja: '収益計上明細',
        zh: '应收过账明细',
        ko: '수취 전기 상세',
        hi: 'प्राप्य पोस्टिंग विवरण',
        ar: 'تفاصيل ترحيل المدينين'
    }
});

data.push({
    name: 'EXRInvoice',
    module: 'exp',
    display: {
        vi: 'Hóa đơn phải thu',
        en: 'Receivable Invoice',
        fr: 'Facture à recevoir',
        es: 'Factura por cobrar',
        id: 'Faktur piutang',
        ja: '受取請求書',
        zh: '应收发票',
        ko: '수취 송장',
        hi: 'प्राप्य चालान',
        ar: 'فاتورة المدينين'
    }
});
data.push({
    name: 'EXRInvoiceItem',
    module: 'exp',
    display: {
        vi: 'Chi tiết Hóa đơn phải thu',
        en: 'Receivable Invoice Detail',
        fr: 'Détail facture recevoir',
        es: 'Detalle factura cobrar',
        id: 'Detail faktur piutang',
        ja: '受取請求書明細',
        zh: '应收发票明细',
        ko: '수취 송장 상세',
        hi: 'प्राप्य चालान विवरण',
        ar: 'تفاصيل فاتورة المدينين'
    }
});

data.push({
    name: 'GLAccount',
    module: 'gl',
    display: {
        vi: 'Tài khoản kế toán',
        en: 'GL Account',
        fr: 'Compte comptable',
        es: 'Cuenta contable',
        id: 'Akun GL',
        ja: '総勘定科目',
        zh: '总账科目',
        ko: '총계정 과목',
        hi: 'जीएल खाता',
        ar: 'حساب دفتر الأستاذ'
    }
});
data.push({
    name: 'GLJournal',
    module: 'gl',
    display: {
        vi: 'Phiếu kế toán',
        en: 'GL Journal',
        fr: 'Journal comptable',
        es: 'Diario contable',
        id: 'Jurnal GL',
        ja: '仕訳帳',
        zh: '总账分录',
        ko: '총계정 분개',
        hi: 'जीएल जर्नल',
        ar: 'يومية دفتر الأستاذ'
    }
});
// Phiếu kế toán hợp nhất (đợt 5, TH-00): VIEW chỉ đọc gộp phiếu hạch toán, phiếu kế toán và lỗi tạo bút toán.
data.push({
    name: 'GLVoucher',
    module: 'gl',
    display: { vi: 'Phiếu kế toán', en: 'Journal Voucher', fr: 'Pièce comptable', es: 'Comprobante diario', id: 'Voucher jurnal', ja: '仕訳伝票', zh: '记账凭证', ko: '분개 전표', hi: 'जर्नल वाउचर', ar: 'قسيمة اليومية' }
});
data.push({
    name: 'GLEntry',
    module: 'gl',
    display: {
        vi: 'Bút toán',
        en: 'GL Entry',
        fr: 'Écriture comptable',
        es: 'Asiento contable',
        id: 'Entri GL',
        ja: '仕訳',
        zh: '分录',
        ko: '분개',
        hi: 'जीएल प्रविष्टि',
        ar: 'قيد دفتر الأستاذ'
    }
});
data.push({
    name: 'GLAdjustBalance',
    module: 'gl',
    display: {
        vi: 'Điều chỉnh TK kế toán',
        en: 'Adjust Balance',
        fr: 'Ajustement solde',
        es: 'Ajuste saldo',
        id: 'Penyesuaian saldo',
        ja: '調整残高',
        zh: '调整余额',
        ko: '조정 잔액',
        hi: 'समायोजन शेष',
        ar: 'تعديل الرصيد'
    }
});
data.push({
    name: 'GLAdjustBalanceItem',
    module: 'gl',
    display: {
        vi: 'Điều chỉnh TK kế toán',
        en: 'Adjust Balance',
        fr: 'Ajustement solde',
        es: 'Ajuste saldo',
        id: 'Penyesuaian saldo',
        ja: '調整残高',
        zh: '调整余额',
        ko: '조정 잔액',
        hi: 'समायोजन शेष',
        ar: 'تعديل الرصيد'
    }
});
data.push({
    name: 'GLServeCosting',
    module: 'gl',
    display: {
        vi: 'Giá thành dịch vụ',
        en: 'Service Costing',
        fr: 'Coût de service',
        es: 'Costeo de servicio',
        id: 'Biaya layanan',
        ja: 'サービス原価',
        zh: '服务成本',
        ko: '서비스 원가',
        hi: 'सेवा लागत',
        ar: 'تكلفة الخدمة'
    }
});
data.push({
    name: 'GLServeCostingItem',
    module: 'gl',
    display: {
        vi: 'Giá thành dịch vụ',
        en: 'Service Costing',
        fr: 'Coût de service',
        es: 'Costeo de servicio',
        id: 'Biaya layanan',
        ja: 'サービス原価',
        zh: '服务成本',
        ko: '서비스 원가',
        hi: 'सेवा लागत',
        ar: 'تكلفة الخدمة'
    }
});
data.push({
    name: 'GLMFCosting',
    module: 'gl',
    display: {
        vi: 'Giá thành sản xuất',
        en: 'Manufacture Costing',
        fr: 'Coût de fabrication',
        es: 'Costeo de manufactura',
        id: 'Biaya manufaktur',
        ja: '製造原価',
        zh: '制造成本',
        ko: '제조 원가',
        hi: 'विनिर्माण लागत',
        ar: 'تكلفة التصنيع'
    }
});
data.push({
    name: 'GLMFCostingItem',
    module: 'gl',
    display: {
        vi: 'Giá thành sản xuất',
        en: 'Manufacture Costing',
        fr: 'Coût de fabrication',
        es: 'Costeo de manufactura',
        id: 'Biaya manufaktur',
        ja: '製造原価',
        zh: '制造成本',
        ko: '제조 원가',
        hi: 'विनिर्माण लागत',
        ar: 'تكلفة التصنيع'
    }
});
data.push({
    name: 'GLMFCostingAlloc',
    module: 'gl',
    display: {
        vi: 'Giá thành sản xuất',
        en: 'Manufacture Costing',
        fr: 'Coût de fabrication',
        es: 'Costeo de manufactura',
        id: 'Biaya manufaktur',
        ja: '製造原価',
        zh: '制造成本',
        ko: '제조 원가',
        hi: 'विनिर्माण लागत',
        ar: 'تكلفة التصنيع'
    }
});
data.push({
    name: 'GLPNLCalculate',
    module: 'gl',
    display: {
        vi: 'Xác định kết quả kinh doanh',
        en: 'P&L Calculation',
        fr: 'Calcul résultat',
        es: 'Cálculo P&L',
        id: 'Perhitungan L/R',
        ja: '損益計算',
        zh: '损益计算',
        ko: '손익 계산',
        hi: 'पी एंड एल गणना',
        ar: 'حساب الأرباح والخسائر'
    }
});
data.push({
    name: 'GLPNLCalculateItem',
    module: 'gl',
    display: {
        vi: 'Xác định kết quả kinh doanh',
        en: 'P&L Calculation',
        fr: 'Calcul résultat',
        es: 'Cálculo P&L',
        id: 'Perhitungan L/R',
        ja: '損益計算',
        zh: '损益计算',
        ko: '손익 계산',
        hi: 'पी एंड एल गणना',
        ar: 'حساب الأرباح والخسائر'
    }
});
data.push({
    name: 'GLPeriodClosing',
    module: 'gl',
    display: {
        vi: 'Kỳ kế toán',
        en: 'Accounting Periods',
        fr: 'Périodes comptables',
        es: 'Períodos contables',
        id: 'Periode akuntansi',
        ja: '会計期間',
        zh: '会计期间',
        ko: '회계 기간',
        hi: 'लेखा अवधि',
        ar: 'الفترات المحاسبية'
    }
});

data.push({
    name: 'PNLAccount',
    module: 'pnl',
    display: {
        vi: 'Tài khoản ngầm định',
        en: 'Default accounts',
        fr: 'Comptes par défaut',
        es: 'Cuentas por defecto',
        id: 'Akun default',
        ja: '既定勘定科目',
        zh: '默认科目',
        ko: '기본 계정',
        hi: 'डिफ़ॉल्ट खाते',
        ar: 'الحسابات الافتراضية'
    }
});
data.push({
    name: 'PNLCost',
    module: 'pnl',
    display: {
        vi: 'Khoản mục chi phí',
        en: 'Cost categories',
        fr: 'Catégories de coûts',
        es: 'Categorías de costos',
        id: 'Kategori biaya',
        ja: '費用区分',
        zh: '费用类别',
        ko: '비용 분류',
        hi: 'लागत श्रेणियाँ',
        ar: 'فئات التكاليف'
    }
});
data.push({
    name: 'PNLServeCosting',
    module: 'pnl',
    display: {
        vi: 'Giá thành dịch vụ',
        en: 'Service Costing',
        fr: 'Coût de service',
        es: 'Costeo de servicio',
        id: 'Biaya layanan',
        ja: 'サービス原価',
        zh: '服务成本',
        ko: '서비스 원가',
        hi: 'सेवा लागत',
        ar: 'تكلفة الخدمة'
    }
});

data.push({
    name: 'PNLRawPosting',
    module: 'pnl',
    display: {
        vi: 'Chi tiết hạch toán',
        en: 'Auto Posting Raw Entry',
        fr: 'Écriture brute auto',
        es: 'Asiento bruto auto',
        id: 'Entri mentah otomatis',
        ja: '自動仕訳生データ',
        zh: '自动过账原始分录',
        ko: '자동 전기 원시 항목',
        hi: 'ऑटो पोस्टिंग रॉ एंट्री',
        ar: 'قيد خام تلقائي'
    }
});
data.push({
    name: 'PNLPosting',
    module: 'pnl',
    display: {
        vi: 'Chi tiết hạch toán',
        en: 'Auto Posting Entry',
        fr: 'Écriture auto',
        es: 'Asiento auto',
        id: 'Entri otomatis',
        ja: '自動仕訳',
        zh: '自动过账分录',
        ko: '자동 전기 항목',
        hi: 'ऑटो पोस्टिंग एंट्री',
        ar: 'قيد تلقائي'
    }
});
data.push({
    name: 'PNLJournal',
    module: 'pnl',
    display: {
        vi: 'Phiếu hạch toán tự động',
        en: 'Auto Posting Journal',
        fr: 'Journal imputation auto',
        es: 'Diario contabilización auto',
        id: 'Jurnal posting otomatis',
        ja: '自動仕訳帳',
        zh: '自动过账日记账',
        ko: '자동 전기 분개장',
        hi: 'ऑटो पोस्टिंग जर्नल',
        ar: 'يومية الترحيل التلقائي'
    }
});
data.push({
    name: 'PNLJournalGroupingTemplate',
    module: 'pnl',
    display: { vi: 'Phiếu mẫu gom PNL', en: 'PNL Grouping Template', fr: 'Modèle groupement PNL', es: 'Plantilla agrupación PNL', id: 'Template grup PNL', ja: 'PNLグループテンプレート', zh: 'PNL分组模板', ko: 'PNL그룹템플릿', hi: 'PNL ग्रुपिंग टेम्पलेट', ar: 'قالب تجميع PNL' }
});
data.push({
    name: 'PNLJournalGrouping',
    module: 'pnl',
    display: { vi: 'Phiếu gom hạch toán', en: 'PNL Grouping', fr: 'Groupement PNL', es: 'Agrupación PNL', id: 'Grup PNL', ja: 'PNLグループ', zh: 'PNL分组', ko: 'PNL그룹', hi: 'PNL समूह', ar: 'تجميع PNL' }
});
data.push({
    name: 'PNLJournalGroupingItem',
    module: 'pnl',
    display: { vi: 'Phiếu PNL trong batch', en: 'PNL in batch', fr: 'PNL dans lot', es: 'PNL en lote', id: 'PNL dalam grup', ja: 'バッチ内PNL', zh: '批次内PNL', ko: '배치내PNL', hi: 'बैच में PNL', ar: 'PNL في الدفعة' }
});
data.push({
    name: 'PNLJournalGroupingPosting',
    module: 'pnl',
    display: { vi: 'Bút toán gom', en: 'Grouped posting', fr: 'Écriture groupée', es: 'Asiento agrupado', id: 'Posting grup', ja: 'グループ仕訳', zh: '分组分录', ko: '그룹분개', hi: 'समूहित प्रविष्टि', ar: 'قيد مجمع' }
});
data.push({
    name: 'PNLMonthlyReport',
    module: 'pnl',
    display: {
        vi: 'Báo cáo lời lỗ',
        en: 'Draft Profit & Loss',
        fr: 'Résultat provisoire',
        es: 'P&L borrador',
        id: 'Draft L/R',
        ja: '仮損益',
        zh: '草稿损益表',
        ko: '초안 손익',
        hi: 'ड्राफ्ट लाभ और हानि',
        ar: 'مسودة الأرباح والخسائر'
    }
});

data.push({
    name: 'ACUserGroup',
    module: 'user',
    display: {
        vi: 'Nhóm người dùng',
        en: 'User Group',
        fr: 'Groupe utilisateur',
        es: 'Grupo de usuario',
        id: 'Grup pengguna',
        ja: 'ユーザーグループ',
        zh: '用户组',
        ko: '사용자 그룹',
        hi: 'उपयोगकर्ता समूह',
        ar: 'مجموعة المستخدمين'
    }
});
data.push({
    name: 'ACUserAccount',
    module: 'user',
    display: {
        vi: 'Người dùng',
        en: 'User Account',
        fr: 'Compte utilisateur',
        es: 'Cuenta de usuario',
        id: 'Akun pengguna',
        ja: 'ユーザーアカウント',
        zh: '用户账户',
        ko: '사용자 계정',
        hi: 'उपयोगकर्ता खाता',
        ar: 'حساب المستخدم'
    }
});
data.push({
    name: 'ACUserApproval',
    module: 'user',
    display: {
        vi: 'Quyền phê duyệt',
        en: 'User Approval Rule',
        fr: 'Règle approbation',
        es: 'Regla de aprobación',
        id: 'Aturan persetujuan',
        ja: '承認ルール',
        zh: '审批规则',
        ko: '승인 규칙',
        hi: 'अनुमोदन नियम',
        ar: 'قاعدة الموافقة'
    }
});

data.push({
    name: 'ACUserStore',
    module: 'user',
    display: {
        vi: 'Store by User',
        en: 'Store by User',
        fr: 'Magasin par utilisateur',
        es: 'Tienda por usuario',
        id: 'Toko per pengguna',
        ja: 'ユーザー別店舗',
        zh: '按用户门店',
        ko: '사용자별 매장',
        hi: 'उपयोगकर्ता द्वारा स्टोर',
        ar: 'المتجر حسب المستخدم'
    }
});
data.push({
    name: 'ACUserWarehouse',
    module: 'user',
    display: {
        vi: 'Warehouse by User',
        en: 'Warehouse by User',
        fr: 'Entrepôt par utilisateur',
        es: 'Almacén por usuario',
        id: 'Gudang per pengguna',
        ja: 'ユーザー別倉庫',
        zh: '按用户仓库',
        ko: '사용자별 창고',
        hi: 'उपयोगकर्ता द्वारा गोदाम',
        ar: 'المستودع حسب المستخدم'
    }
});
data.push({
    name: 'ACUserProject',
    module: 'user',
    display: {
        vi: 'Project by User',
        en: 'Project by User',
        fr: 'Projet par utilisateur',
        es: 'Proyecto por usuario',
        id: 'Proyek per pengguna',
        ja: 'ユーザー別プロジェクト',
        zh: '按用户项目',
        ko: '사용자별 프로젝트',
        hi: 'उपयोगकर्ता द्वारा परियोजना',
        ar: 'المشروع حسب المستخدم'
    }
});
data.push({
    name: 'ACUserVendor',
    module: 'user',
    display: {
        vi: 'Vendor by User',
        en: 'Vendor by User',
        fr: 'Fournisseur par utilisateur',
        es: 'Proveedor por usuario',
        id: 'Vendor per pengguna',
        ja: 'ユーザー別ベンダー',
        zh: '按用户供应商',
        ko: '사용자별 공급업체',
        hi: 'उपयोगकर्ता द्वारा विक्रेता',
        ar: 'المورد حسب المستخدم'
    }
});
data.push({
    name: 'ACUserEmployee',
    module: 'user',
    display: {
        vi: 'Employee by User',
        en: 'Employee by User',
        fr: 'Employé par utilisateur',
        es: 'Empleado por usuario',
        id: 'Karyawan per pengguna',
        ja: 'ユーザー別従業員',
        zh: '按用户员工',
        ko: '사용자별 직원',
        hi: 'उपयोगकर्ता द्वारा कर्मचारी',
        ar: 'الموظف حسب المستخدم'
    }
});
data.push({
    name: 'ACUserCashAccount',
    module: 'user',
    display: {
        vi: 'Cash Account by User',
        en: 'Cash Account by User',
        fr: 'Compte caisse par utilisateur',
        es: 'Cuenta caja por usuario',
        id: 'Akun kas per pengguna',
        ja: 'ユーザー別現金勘定',
        zh: '按用户现金账户',
        ko: '사용자별 현금 계정',
        hi: 'उपयोगकर्ता द्वारा नकद खाता',
        ar: 'حساب النقدية حسب المستخدم'
    }
});
data.push({
    name: 'ACUserRemoteEvent',
    module: 'user',
    display: {
        vi: 'Xử lý từ xa',
        en: 'Remote Events',
        fr: 'Événements distants',
        es: 'Eventos remotos',
        id: 'Event jarak jauh',
        ja: 'リモートイベント',
        zh: '远程事件',
        ko: '원격 이벤트',
        hi: 'रिमोट इवेंट्स',
        ar: 'أحداث عن بعد'
    }
});
data.push({
    name: 'ACUserLocalEvent',
    module: 'user',
    display: {
        vi: 'Thiết bị',
        en: 'Local Events',
        fr: 'Événements locaux',
        es: 'Eventos locales',
        id: 'Event lokal',
        ja: 'ローカルイベント',
        zh: '本地事件',
        ko: '로컬 이벤트',
        hi: 'लोकल इवेंट्स',
        ar: 'أحداث محلية'
    }
});
data.push({
    name: 'OFTask',
    module: 'of',
    display: { vi: 'Giao việc', en: 'Task', fr: 'Tâche', es: 'Tarea', id: 'Tugas', ja: 'タスク', zh: '任务', ko: '작업', hi: 'कार्य', ar: 'المهمة' }
});
data.push({
    name: 'OFApproval',
    module: 'of',
    display: {
        vi: 'Trình duyệt',
        en: 'Approval',
        fr: 'Approbation',
        es: 'Aprobación',
        id: 'Persetujuan',
        ja: '承認',
        zh: '审批',
        ko: '승인',
        hi: 'अनुमोदन',
        ar: 'الموافقة'
    }
});
data.push({
    name: 'OFDailyReport',
    module: 'of',
    display: {
        vi: 'Báo cáo công việc',
        en: 'Daily Report',
        fr: 'Rapport quotidien',
        es: 'Informe diario',
        id: 'Laporan harian',
        ja: '日報',
        zh: '日报',
        ko: '일일보고',
        hi: 'दैनिक रिपोर्ट',
        ar: 'التقرير اليومي'
    }
});
data.push({
    name: 'OFMeetingRoom',
    module: 'of',
    display: {
        vi: 'Phòng họp',
        en: 'Meeting Room',
        fr: 'Salle de réunion',
        es: 'Sala de reunión',
        id: 'Ruang rapat',
        ja: '会議室',
        zh: '会议室',
        ko: '회의실',
        hi: 'बैठक कक्ष',
        ar: 'غرفة الاجتماع'
    }
});
data.push({
    name: 'OFMeeting',
    module: 'of',
    display: {
        vi: 'Cuộc họp',
        en: 'Meeting',
        fr: 'Réunion',
        es: 'Reunión',
        id: 'Rapat',
        ja: '会議',
        zh: '会议',
        ko: '회의',
        hi: 'बैठक',
        ar: 'الاجتماع'
    }
});
data.push({
    name: 'OFDocFolder',
    module: 'of',
    display: {
        vi: 'Thư mục tài liệu',
        en: 'Document Folder',
        fr: 'Dossier',
        es: 'Carpeta',
        id: 'Folder',
        ja: 'フォルダ',
        zh: '文件夹',
        ko: '폴더',
        hi: 'फ़ोल्डर',
        ar: 'المجلد'
    }
});
data.push({
    name: 'OFDocument',
    module: 'of',
    display: {
        vi: 'Tài liệu',
        en: 'Document',
        fr: 'Document',
        es: 'Documento',
        id: 'Dokumen',
        ja: 'ドキュメント',
        zh: '文档',
        ko: '문서',
        hi: 'दस्तावेज़',
        ar: 'المستند'
    }
});
data.push({
    name: 'OFBulletin',
    module: 'of',
    display: {
        vi: 'Bảng tin',
        en: 'Bulletin',
        fr: 'Bulletin',
        es: 'Boletín',
        id: 'Buletin',
        ja: '掲示板',
        zh: '公告',
        ko: '게시판',
        hi: 'बुलेटिन',
        ar: 'النشرة'
    }
});
data.push({
    name: 'OFBulletinRead',
    module: 'of',
    display: {
        vi: 'Lượt đọc bảng tin',
        en: 'Bulletin Read',
        fr: 'Lecture',
        es: 'Lectura',
        id: 'Baca',
        ja: '既読',
        zh: '已读',
        ko: '읽음',
        hi: 'पढ़ा',
        ar: 'القراءة'
    }
});
data.push({
    name: 'OFObjective',
    module: 'of',
    display: {
        vi: 'Mục tiêu',
        en: 'Objective',
        fr: 'Objectif',
        es: 'Objetivo',
        id: 'Tujuan',
        ja: '目標',
        zh: '目标',
        ko: '목표',
        hi: 'उद्देश्य',
        ar: 'الهدف'
    }
});
data.push({
    name: 'OFKeyResult',
    module: 'of',
    display: {
        vi: 'Kết quả then chốt',
        en: 'Key Result',
        fr: 'Résultat clé',
        es: 'Resultado clave',
        id: 'Hasil utama',
        ja: '重要結果',
        zh: '关键结果',
        ko: '핵심결과',
        hi: 'मुख्य परिणाम',
        ar: 'النتيجة الرئيسية'
    }
});
data.push({
    name: 'SCPost',
    module: 'social',
    display: {
        vi: 'Bảng tin',
        en: 'Post',
        fr: 'Publication',
        es: 'Publicación',
        id: 'Postingan',
        ja: '投稿',
        zh: '帖子',
        ko: '게시물',
        hi: 'पोस्ट',
        ar: 'منشور'
    }
});

data.push({
    name: 'CRMComsRulePurchaseGlobal',
    module: 'coms',
    display: {
        vi: 'Quy tắc tính hoa hồng giới thiệu',
        en: 'Referral Commission Rule',
        fr: 'Règle commission parrainage',
        es: 'Regla comisión referido',
        id: 'Aturan komisi referral',
        ja: '紹介手数料ルール',
        zh: '推荐佣金规则',
        ko: '추천 수수료 규칙',
        hi: 'रेफरल कमीशन नियम',
        ar: 'قاعدة عمولة الإحالة'
    }
});
data.push({
    name: 'CRMComsRulePurchaseOnItem',
    module: 'coms',
    display: {
        vi: 'Hoa hồng giới thiệu theo mặt hàng',
        en: 'Referral Commission On Item',
        fr: 'Commission parrainage par article',
        es: 'Comisión referido por artículo',
        id: 'Komisi referral per item',
        ja: '品目別紹介手数料',
        zh: '按商品推荐佣金',
        ko: '품목별 추천 수수료',
        hi: 'आइटम पर रेफरल कमीशन',
        ar: 'عمولة الإحالة حسب الصنف'
    }
});
data.push({
    name: 'CRMComsRule',
    module: 'coms',
    display: {
        vi: 'Quy tắc tính hoa hồng bán hàng',
        en: 'Sale Commission Rule',
        fr: 'Règle commission vente',
        es: 'Regla comisión venta',
        id: 'Aturan komisi penjualan',
        ja: '販売手数料ルール',
        zh: '销售佣金规则',
        ko: '판매 수수료 규칙',
        hi: 'बिक्री कमीशन नियम',
        ar: 'قاعدة عمولة البيع'
    }
});
data.push({
    name: 'CRMComsRuleSaleOnItem',
    module: 'coms',
    display: {
        vi: 'Hoa hồng bán hàng theo mặt hàng',
        en: 'Sale Commission On Item',
        fr: 'Commission vente par article',
        es: 'Comisión venta por artículo',
        id: 'Komisi penjualan per item',
        ja: '品目別販売手数料',
        zh: '按商品销售佣金',
        ko: '품목별 판매 수수료',
        hi: 'आइटम पर बिक्री कमीशन',
        ar: 'عمولة البيع حسب الصنف'
    }
});
data.push({
    name: 'CRMComsInit',
    module: 'coms',
    display: {
        vi: 'Hoa hồng ghi nhận',
        en: 'Actual Commission',
        fr: 'Commission réelle',
        es: 'Comisión real',
        id: 'Komisi aktual',
        ja: '実績手数料',
        zh: '实际佣金',
        ko: '실제 수수료',
        hi: 'वास्तविक कमीशन',
        ar: 'العمولة الفعلية'
    }
});
data.push({
    name: 'CRMComsPayment',
    module: 'coms',
    display: {
        vi: 'Trả hoa hồng',
        en: 'Commission Disbursement',
        fr: 'Paiement commission',
        es: 'Pago de comisión',
        id: 'Pencairan komisi',
        ja: '手数料支払',
        zh: '佣金发放',
        ko: '수수료 지급',
        hi: 'कमीशन वितरण',
        ar: 'صرف العمولة'
    }
});

data.push({
    name: 'CRMLoyaltyPurchaseRule',
    module: 'crm',
    display: {
        vi: 'Tặng điểm theo đơn',
        en: 'Loyalty Purchase Rule',
        fr: 'Règle fidélité achat',
        es: 'Regla lealtad compra',
        id: 'Aturan loyalitas pembelian',
        ja: '購入ポイントルール',
        zh: '购买积分规则',
        ko: '구매 포인트 규칙',
        hi: 'लॉयल्टी खरीद नियम',
        ar: 'قاعدة نقاط الشراء'
    }
});
data.push({
    name: 'CRMLoyaltyLevel',
    module: 'crm',
    display: {
        vi: 'Xếp hạng theo điểm',
        en: 'Loyalty Level',
        fr: 'Niveau fidélité',
        es: 'Nivel de lealtad',
        id: 'Level loyalitas',
        ja: '会員ランク',
        zh: '会员等级',
        ko: '회원 등급',
        hi: 'लॉयल्टी स्तर',
        ar: 'مستوى الولاء'
    }
});
data.push({
    name: 'CRMLoyaltyMonthlyRule',
    module: 'crm',
    display: {
        vi: 'Tặng điểm theo tháng',
        en: 'Loyalty Monthly Rule',
        fr: 'Règle fidélité mensuelle',
        es: 'Regla lealtad mensual',
        id: 'Aturan loyalitas bulanan',
        ja: '月次ポイントルール',
        zh: '月度积分规则',
        ko: '월 포인트 규칙',
        hi: 'मासिक लॉयल्टी नियम',
        ar: 'قاعدة النقاط الشهرية'
    }
});
data.push({
    name: 'CRMLoyaltyDetail',
    module: 'crm',
    display: {
        vi: 'Thực tế tích điểm',
        en: 'Loyalty Detail',
        fr: 'Détail fidélité',
        es: 'Detalle de lealtad',
        id: 'Detail loyalitas',
        ja: 'ポイント明細',
        zh: '积分明细',
        ko: '포인트 상세',
        hi: 'लॉयल्टी विवरण',
        ar: 'تفاصيل الولاء'
    }
});
data.push({
    name: 'CRMCredit',
    module: 'crm',
    display: {
        vi: 'Công nợ chăm sóc khách hàng',
        en: 'CRM Credit',
        fr: 'Crédit CRM',
        es: 'Crédito CRM',
        id: 'Kredit CRM',
        ja: 'CRM債権',
        zh: '客户关系信用',
        ko: 'CRM 외상',
        hi: 'सीआरएम क्रेडिट',
        ar: 'ائتمان إدارة علاقات العملاء'
    }
});
data.push({
    name: 'CRMProfile',
    module: 'crm',
    display: {
        vi: 'Hồ sơ khách hàng',
        en: 'CRM Profile',
        fr: 'Profil CRM',
        es: 'Perfil CRM',
        id: 'Profil CRM',
        ja: 'CRMプロファイル',
        zh: '客户档案',
        ko: 'CRM 프로필',
        hi: 'सीआरएम प्रोफाइल',
        ar: 'ملف إدارة علاقات العملاء'
    }
});
data.push({
    name: 'WalletTrans',
    module: 'crm',
    display: {
        vi: 'Nạp rút tiền',
        en: 'Prepaid Wallet',
        fr: 'Portefeuille prépayé',
        es: 'Billetera prepago',
        id: 'Dompet prabayar',
        ja: 'プリペイドウォレット',
        zh: '预付钱包',
        ko: '선불 지갑',
        hi: 'प्रीपेड वॉलेट',
        ar: 'المحفظة المدفوعة مسبقاً'
    }
});

data.push({
    name: 'CRMLead',
    module: 'crm',
    display: {
        vi: 'Khách hàng tiềm năng',
        en: 'Lead',
        fr: 'Prospect',
        es: 'Prospecto',
        id: 'Prospek',
        ja: 'リード',
        zh: '潜在客户',
        ko: '잠재고객',
        hi: 'लीड',
        ar: 'العميل المحتمل'
    }
});
data.push({
    name: 'CRMLeadActivity',
    module: 'crm',
    display: {
        vi: 'Tiếp cận khách hàng',
        en: 'Lead Activity',
        fr: 'Activité prospect',
        es: 'Actividad prospecto',
        id: 'Aktivitas prospek',
        ja: 'リード活動',
        zh: '潜在客户活动',
        ko: '잠재고객 활동',
        hi: 'लीड गतिविधि',
        ar: 'نشاط العميل المحتمل'
    }
});

data.push({
    name: 'PMProject',
    module: 'pm',
    display: {
        vi: 'Dự án',
        en: 'Project',
        fr: 'Projet',
        es: 'Proyecto',
        id: 'Proyek',
        ja: 'プロジェクト',
        zh: '项目',
        ko: '프로젝트',
        hi: 'परियोजना',
        ar: 'المشروع'
    }
});
data.push({
    name: 'PMFeature',
    module: 'pm',
    display: {
        vi: 'Hạng mục dự án',
        en: 'Project Feature',
        fr: 'Fonctionnalité projet',
        es: 'Característica proyecto',
        id: 'Fitur proyek',
        ja: 'プロジェクト機能',
        zh: '项目功能',
        ko: '프로젝트 기능',
        hi: 'परियोजना सुविधा',
        ar: 'ميزة المشروع'
    }
});
data.push({
    name: 'PMTimelineHistory',
    module: 'pm',
    display: {
        vi: 'Tiến độ thực tế dự án',
        en: 'Project Timeline History',
        fr: 'Historique chronologie projet',
        es: 'Historial línea tiempo',
        id: 'Riwayat timeline proyek',
        ja: 'プロジェクト進捗履歴',
        zh: '项目时间线历史',
        ko: '프로젝트 타임라인 기록',
        hi: 'परियोजना टाइमलाइन इतिहास',
        ar: 'سجل الجدول الزمني للمشروع'
    }
});

data.push({
    name: 'FAAsset',
    module: 'fa',
    display: { vi: 'Tài sản', en: 'Asset', fr: 'Actif', es: 'Activo', id: 'Aset', ja: '資産', zh: '资产', ko: '자산', hi: 'संपत्ति', ar: 'الأصل' }
});
data.push({
    name: 'FAAssetDepreciate',
    module: 'fa',
    display: {
        vi: 'Khấu hao tài sản',
        en: 'Asset Depreciation',
        fr: 'Amortissement actif',
        es: 'Depreciación activo',
        id: 'Penyusutan aset',
        ja: '減価償却',
        zh: '资产折旧',
        ko: '자산 감가상각',
        hi: 'संपत्ति मूल्यह्रास',
        ar: 'إهلاك الأصل'
    }
});
data.push({
    name: 'FAAssetRegister',
    module: 'fa',
    display: {
        vi: 'Ghi tăng tài sản',
        en: 'Asset Register',
        fr: 'Registre actif',
        es: 'Registro activo',
        id: 'Register aset',
        ja: '資産登録',
        zh: '资产登记',
        ko: '자산 등록',
        hi: 'संपत्ति रजिस्टर',
        ar: 'سجل الأصول'
    }
});
data.push({
    name: 'FAAssetAdjInc',
    module: 'fa',
    display: {
        vi: 'Nâng cấp tài sản',
        en: 'Asset Upgrade',
        fr: 'Amélioration actif',
        es: 'Mejora activo',
        id: 'Upgrade aset',
        ja: '資産改良',
        zh: '资产升级',
        ko: '자산 업그레이드',
        hi: 'संपत्ति उन्नयन',
        ar: 'ترقية الأصل'
    }
});
data.push({
    name: 'FAAssetAdjDec',
    module: 'fa',
    display: {
        vi: 'Định giá tài sản',
        en: 'Asset Revaluation',
        fr: 'Réévaluation actif',
        es: 'Revaluación activo',
        id: 'Revaluasi aset',
        ja: '資産再評価',
        zh: '资产重估',
        ko: '자산 재평가',
        hi: 'संपत्ति पुनर्मूल्यांकन',
        ar: 'إعادة تقييم الأصل'
    }
});
data.push({
    name: 'FAAssetDispose',
    module: 'fa',
    display: {
        vi: 'Ghi giảm tài sản',
        en: 'Asset Disposal',
        fr: 'Cession actif',
        es: 'Disposición activo',
        id: 'Disposal aset',
        ja: '資産除却',
        zh: '资产处置',
        ko: '자산 처분',
        hi: 'संपत्ति निपटान',
        ar: 'التخلص من الأصل'
    }
});

data.push({
    name: 'FAEquipment',
    module: 'fa',
    display: {
        vi: 'Công cụ dụng cụ',
        en: 'Equipment',
        fr: 'Équipement',
        es: 'Equipo',
        id: 'Alat',
        ja: '備品',
        zh: '设备',
        ko: '장비',
        hi: 'उपकरण',
        ar: 'المعدات'
    }
});
data.push({
    name: 'FAEquipmentIssue',
    module: 'fa',
    display: {
        vi: 'Xuất dùng CCDC',
        en: 'Issue Equipment',
        fr: 'Sortie équipement',
        es: 'Emisión equipo',
        id: 'Pengeluaran alat',
        ja: '備品払出',
        zh: '设备领用',
        ko: '장비 출고',
        hi: 'उपकरण जारी',
        ar: 'إصدار المعدات'
    }
});
data.push({
    name: 'FAEquipmentDepreciate',
    module: 'fa',
    display: {
        vi: 'Phân bổ chi phí CCDC',
        en: 'Allocate Equipment Expense',
        fr: 'Allocation dépense équipement',
        es: 'Asignación gasto equipo',
        id: 'Alokasi biaya alat',
        ja: '備品費配賦',
        zh: '设备费用分配',
        ko: '장비 비용 배분',
        hi: 'उपकरण व्यय आवंटन',
        ar: 'تخصيص مصروفات المعدات'
    }
});
data.push({
    name: 'FAEquipmentRegister',
    module: 'fa',
    display: {
        vi: 'Ghi tăng CCDC',
        en: 'Equipment Register',
        fr: 'Registre équipement',
        es: 'Registro equipo',
        id: 'Register alat',
        ja: '備品登録',
        zh: '设备登记',
        ko: '장비 등록',
        hi: 'उपकरण रजिस्टर',
        ar: 'سجل المعدات'
    }
});
data.push({
    name: 'FAEquipmentDispose',
    module: 'fa',
    display: {
        vi: 'Ghi giảm CCDC',
        en: 'Equipment Disposal',
        fr: 'Cession équipement',
        es: 'Disposición equipo',
        id: 'Disposal alat',
        ja: '備品除却',
        zh: '设备处置',
        ko: '장비 처분',
        hi: 'उपकरण निपटान',
        ar: 'التخلص من المعدات'
    }
});

data.push({
    name: 'MFWorkshop',
    module: 'mf',
    display: {
        vi: 'Phân xưởng',
        en: 'Workshop',
        fr: 'Atelier',
        es: 'Taller',
        id: 'Bengkel',
        ja: '工場',
        zh: '车间',
        ko: '작업장',
        hi: 'कार्यशाला',
        ar: 'الورشة'
    }
});
data.push({
    name: 'MFLine',
    module: 'mf',
    display: { vi: 'Chuyền', en: 'Line', fr: 'Ligne', es: 'Línea', id: 'Lini', ja: 'ライン', zh: '生产线', ko: '라인', hi: 'लाइन', ar: 'الخط' }
});
data.push({
    name: 'MFStorage',
    module: 'mf',
    display: {
        vi: 'Kho công đoạn',
        en: 'Storage',
        fr: 'Stockage',
        es: 'Almacenamiento',
        id: 'Penyimpanan',
        ja: '保管庫',
        zh: '存储',
        ko: '저장소',
        hi: 'भंडारण',
        ar: 'التخزين'
    }
});
data.push({
    name: 'MFStorageStatus',
    module: 'mf',
    display: {
        vi: 'Trạng thái kho',
        en: 'Storage Status',
        fr: 'État du stockage',
        es: 'Estado de almacenamiento',
        id: 'Status penyimpanan',
        ja: '保管状況',
        zh: '库存状态',
        ko: '보관 상태',
        hi: 'भंडारण स्थिति',
        ar: 'حالة التخزين'
    }
});
data.push({
    name: 'MFProceduce',
    module: 'mf',
    display: {
        vi: 'Quy trình',
        en: 'Procedure',
        fr: 'Procédure',
        es: 'Procedimiento',
        id: 'Prosedur',
        ja: '手順',
        zh: '程序',
        ko: '절차',
        hi: 'प्रक्रिया',
        ar: 'الإجراء'
    }
});
data.push({
    name: 'MFPhase',
    module: 'mf',
    display: { vi: 'Công đoạn', en: 'Phase', fr: 'Phase', es: 'Fase', id: 'Fase', ja: '工程', zh: '阶段', ko: '단계', hi: 'चरण', ar: 'المرحلة' }
});
data.push({
    name: 'MFRoute',
    module: 'mf',
    display: {
        vi: 'Luồng sản xuất',
        en: 'Route',
        fr: 'Gamme',
        es: 'Ruta',
        id: 'Rute',
        ja: 'ルート',
        zh: '工艺路线',
        ko: '경로',
        hi: 'मार्ग',
        ar: 'المسار'
    }
});
data.push({
    name: 'MFBOM',
    module: 'mf',
    display: {
        vi: 'Định mức',
        en: 'BOM',
        fr: 'Nomenclature',
        es: 'Lista de materiales',
        id: 'BOM',
        ja: '部品表',
        zh: '物料清单',
        ko: 'BOM',
        hi: 'बीओएम',
        ar: 'قائمة المواد'
    }
});
data.push({
    name: 'MFBOMItem',
    module: 'mf',
    display: {
        vi: 'Nguyên vật liệu',
        en: 'Item',
        fr: 'Article',
        es: 'Artículo',
        id: 'Barang',
        ja: '品目',
        zh: '物品',
        ko: '품목',
        hi: 'आइटम',
        ar: 'الصنف'
    }
});
data.push({
    name: 'MFBOMPhase',
    module: 'mf',
    display: { vi: 'Công đoạn', en: 'Phase', fr: 'Phase', es: 'Fase', id: 'Fase', ja: '工程', zh: '阶段', ko: '단계', hi: 'चरण', ar: 'المرحلة' }
});

data.push({
    name: 'MFMDSTicket',
    module: 'mf',
    display: {
        vi: 'Đề nghị sản xuất',
        en: 'Demand Request',
        fr: 'Demande de production',
        es: 'Solicitud de demanda',
        id: 'Permintaan produksi',
        ja: '生産依頼',
        zh: '需求请求',
        ko: '생산 요청',
        hi: 'मांग अनुरोध',
        ar: 'طلب الطلب'
    }
});
data.push({
    name: 'MFMDSTicketItem',
    module: 'mf',
    display: {
        vi: 'Đề nghị sản xuất',
        en: 'Demand Request',
        fr: 'Demande de production',
        es: 'Solicitud de demanda',
        id: 'Permintaan produksi',
        ja: '生産依頼',
        zh: '需求请求',
        ko: '생산 요청',
        hi: 'मांग अनुरोध',
        ar: 'طلب الطلب'
    }
});
data.push({
    name: 'MFMDSSummary',
    module: 'mf',
    display: {
        vi: 'Nhu cầu sản xuất',
        en: 'Master Demand Schedule',
        fr: 'Plan directeur demande',
        es: 'Programa maestro demanda',
        id: 'Jadwal permintaan master',
        ja: '需要マスタースケジュール',
        zh: '主需求计划',
        ko: '마스터 수요 일정',
        hi: 'मास्टर डिमांड शेड्यूल',
        ar: 'جدول الطلب الرئيسي'
    }
});
data.push({
    name: 'MFMDSSummaryItem',
    module: 'mf',
    display: {
        vi: 'Nhu cầu sản xuất',
        en: 'Master Demand Schedule',
        fr: 'Plan directeur demande',
        es: 'Programa maestro demanda',
        id: 'Jadwal permintaan master',
        ja: '需要マスタースケジュール',
        zh: '主需求计划',
        ko: '마스터 수요 일정',
        hi: 'मास्टर डिमांड शेड्यूल',
        ar: 'جدول الطلب الرئيسي'
    }
});
data.push({
    name: 'MFMPS',
    module: 'mf',
    display: {
        vi: 'Kế hoạch sản xuất',
        en: 'Master Production Schedule',
        fr: 'Plan directeur production',
        es: 'Programa maestro producción',
        id: 'Jadwal produksi master',
        ja: '生産マスタースケジュール',
        zh: '主生产计划',
        ko: '마스터 생산 일정',
        hi: 'मास्टर प्रोडक्शन शेड्यूल',
        ar: 'جدول الإنتاج الرئيسي'
    }
});
data.push({
    name: 'MFMPSItem',
    module: 'mf',
    display: {
        vi: 'Kế hoạch sản xuất',
        en: 'Master Production Schedule',
        fr: 'Plan directeur production',
        es: 'Programa maestro producción',
        id: 'Jadwal produksi master',
        ja: '生産マスタースケジュール',
        zh: '主生产计划',
        ko: '마스터 생산 일정',
        hi: 'मास्टर प्रोडक्शन शेड्यूल',
        ar: 'جدول الإنتاج الرئيسي'
    }
});

data.push({
    name: 'MFMRPSummary',
    module: 'mf',
    display: {
        vi: 'Nhu cầu NVL',
        en: 'Material Requirement Planning',
        fr: 'Planification besoins matières',
        es: 'Planificación requerimientos material',
        id: 'Perencanaan kebutuhan material',
        ja: '資材所要量計画',
        zh: '物料需求计划',
        ko: '자재 소요량 계획',
        hi: 'सामग्री आवश्यकता योजना',
        ar: 'تخطيط متطلبات المواد'
    }
});
data.push({
    name: 'MFMRPSummaryItem',
    module: 'mf',
    display: {
        vi: 'Nhu cầu NVL',
        en: 'Material Requirement Planning',
        fr: 'Planification besoins matières',
        es: 'Planificación requerimientos material',
        id: 'Perencanaan kebutuhan material',
        ja: '資材所要量計画',
        zh: '物料需求计划',
        ko: '자재 소요량 계획',
        hi: 'सामग्री आवश्यकता योजना',
        ar: 'تخطيط متطلبات المواد'
    }
});

data.push({
    name: 'MFMRPTicket',
    module: 'mf',
    display: {
        vi: 'Phiếu yêu cầu vật tư',
        en: 'Material Requisition',
        fr: 'Demande de matériel',
        es: 'Solicitud de material',
        id: 'Permintaan material',
        ja: '資材要求',
        zh: '物料申请',
        ko: '자재 요청',
        hi: 'सामग्री अनुरोध',
        ar: 'طلب المواد'
    }
});
data.push({
    name: 'MFMRPTicketItem',
    module: 'mf',
    display: {
        vi: 'Phiếu yêu cầu vật tư',
        en: 'Material Requisition',
        fr: 'Demande de matériel',
        es: 'Solicitud de material',
        id: 'Permintaan material',
        ja: '資材要求',
        zh: '物料申请',
        ko: '자재 요청',
        hi: 'सामग्री अनुरोध',
        ar: 'طلب المواد'
    }
});
data.push({
    name: 'MFMakeOrder',
    module: 'mf',
    display: {
        vi: 'Lệnh sản xuất',
        en: 'Manufacture Order',
        fr: 'Ordre de fabrication',
        es: 'Orden de manufactura',
        id: 'Order manufaktur',
        ja: '製造指示',
        zh: '生产订单',
        ko: '제조 주문',
        hi: 'विनिर्माण आदेश',
        ar: 'أمر التصنيع'
    }
});
data.push({
    name: 'MFMakeOrderItem',
    module: 'mf',
    display: {
        vi: 'Lệnh sản xuất',
        en: 'Manufacture Order',
        fr: 'Ordre de fabrication',
        es: 'Orden de manufactura',
        id: 'Order manufaktur',
        ja: '製造指示',
        zh: '生产订单',
        ko: '제조 주문',
        hi: 'विनिर्माण आदेश',
        ar: 'أمر التصنيع'
    }
});

data.push({
    name: 'MFWorkTicket',
    module: 'mf',
    display: {
        vi: 'Phiếu sản xuất',
        en: 'Work Ticket',
        fr: 'Bon de travail',
        es: 'Boleto de trabajo',
        id: 'Tiket kerja',
        ja: '作業票',
        zh: '工票',
        ko: '작업 티켓',
        hi: 'कार्य टिकट',
        ar: 'بطاقة العمل'
    }
});
data.push({
    name: 'MFWorkTicketActivity',
    module: 'mf',
    display: {
        vi: 'Phiếu sản xuất',
        en: 'Work Ticket',
        fr: 'Bon de travail',
        es: 'Boleto de trabajo',
        id: 'Tiket kerja',
        ja: '作業票',
        zh: '工票',
        ko: '작업 티켓',
        hi: 'कार्य टिकट',
        ar: 'بطاقة العمل'
    }
});
data.push({
    name: 'MFWorkStatus',
    module: 'mf',
    display: {
        vi: 'Trạng thái sản xuất',
        en: 'Work Status',
        fr: 'État du travail',
        es: 'Estado del trabajo',
        id: 'Status kerja',
        ja: '作業状況',
        zh: '作业状态',
        ko: '작업 상태',
        hi: 'कार्य स्थिति',
        ar: 'حالة العمل'
    }
});
data.push({
    name: 'MFWorkFinish',
    module: 'mf',
    display: {
        vi: 'Nhập thành phẩm',
        en: 'Work Finish',
        fr: 'Fin de travail',
        es: 'Trabajo terminado',
        id: 'Selesai kerja',
        ja: '作業完了',
        zh: '完工',
        ko: '작업 완료',
        hi: 'कार्य समाप्त',
        ar: 'إنهاء العمل'
    }
});
data.push({
    name: 'MFWorkMove',
    module: 'mf',
    display: {
        vi: 'Luân chuyển',
        en: 'Work Move',
        fr: 'Transfert travail',
        es: 'Movimiento trabajo',
        id: 'Pindah kerja',
        ja: '作業移動',
        zh: '工序转移',
        ko: '작업 이동',
        hi: 'कार्य स्थानांतरण',
        ar: 'نقل العمل'
    }
});
data.push({
    name: 'MFWorkMoveActivity',
    module: 'mf',
    display: {
        vi: 'Luân chuyển',
        en: 'Work Move',
        fr: 'Transfert travail',
        es: 'Movimiento trabajo',
        id: 'Pindah kerja',
        ja: '作業移動',
        zh: '工序转移',
        ko: '작업 이동',
        hi: 'कार्य स्थानांतरण',
        ar: 'نقل العمل'
    }
});
data.push({
    name: 'MFWorkSemiFinish',
    module: 'mf',
    display: {
        vi: 'Nhập bán thành phẩm',
        en: 'Work Semi-Finish',
        fr: 'Fin de travail semi-fini',
        es: 'Trabajo semi-terminado',
        id: 'Selesai kerja setengah jadi',
        ja: '半製品作業完了',
        zh: '半成品完工',
        ko: '반제품 작업 완료',
        hi: 'अर्ध-तैयार कार्य समाप्त',
        ar: 'إنهاء العمل شبه المصنع'
    }
});
data.push({
    name: 'MFWorkSemiFinishItem',
    module: 'mf',
    display: {
        vi: 'Nhập bán thành phẩm',
        en: 'Work Semi-Finish',
        fr: 'Fin de travail semi-fini',
        es: 'Trabajo semi-terminado',
        id: 'Selesai kerja setengah jadi',
        ja: '半製品作業完了',
        zh: '半成品完工',
        ko: '반제품 작업 완료',
        hi: 'अर्ध-तैयार कार्य समाप्त',
        ar: 'إنهاء العمل شبه المصنع'
    }
});
data.push({
    name: 'MFMaterialIssue',
    module: 'mf',
    display: {
        vi: 'Xuất nguyên liệu',
        en: 'Material Issue',
        fr: 'Sortie matière',
        es: 'Emisión material',
        id: 'Pengeluaran material',
        ja: '材料払出',
        zh: '材料领用',
        ko: '자재 출고',
        hi: 'सामग्री जारी',
        ar: 'إصدار المواد'
    }
});
data.push({
    name: 'MFMaterialIssueItem',
    module: 'mf',
    display: {
        vi: 'Xuất nguyên liệu',
        en: 'Material Issue',
        fr: 'Sortie matière',
        es: 'Emisión material',
        id: 'Pengeluaran material',
        ja: '材料払出',
        zh: '材料领用',
        ko: '자재 출고',
        hi: 'सामग्री जारी',
        ar: 'إصدار المواد'
    }
});

data.push({
    name: 'ARServeBOM',
    module: 'serve',
    display: {
        vi: 'Định mức chế biến',
        en: 'Cooking BOM',
        fr: 'Nomenclature cuisine',
        es: 'Lista materiales cocina',
        id: 'BOM masak',
        ja: '調理部品表',
        zh: '烹饪物料清单',
        ko: '조리 BOM',
        hi: 'कुकिंग बीओएम',
        ar: 'قائمة مواد الطبخ'
    }
});
data.push({
    name: 'ARServeBOMItem',
    module: 'serve',
    display: {
        vi: 'Đầu vào chế biến',
        en: 'Cooking Input Item',
        fr: 'Ingrédient cuisine',
        es: 'Artículo entrada cocina',
        id: 'Item input masak',
        ja: '調理入力品目',
        zh: '烹饪输入项',
        ko: '조리 입력 품목',
        hi: 'कुकिंग इनपुट आइटम',
        ar: 'بند إدخال الطبخ'
    }
});
data.push({
    name: 'ItemModifierProfile',
    module: 'item',
    display: {
        vi: 'Topping',
        en: 'Toppings',
        fr: 'Profil d’options',
        es: 'Perfil de modificadores',
        id: 'Profil opsi',
        ja: 'オプションプロファイル',
        zh: '选项配置',
        ko: '옵션 프로필',
        hi: 'विकल्प प्रोफ़ाइल',
        ar: 'ملف الخيارات'
    }
});
data.push({
    name: 'ItemModifierGroup',
    module: 'item',
    display: {
        vi: 'Nhóm topping',
        en: 'Modifier Group',
        fr: 'Groupe de garnitures',
        es: 'Grupo de toppings',
        id: 'Grup topping',
        ja: 'トッピンググループ',
        zh: '配料分组',
        ko: '토핑 그룹',
        hi: 'टॉपिंग समूह',
        ar: 'مجموعة الإضافات'
    }
});
data.push({
    name: 'ItemModifierItem',
    module: 'item',
    display: {
        vi: 'Topping',
        en: 'Modifier',
        fr: 'Garniture',
        es: 'Topping',
        id: 'Topping',
        ja: 'トッピング',
        zh: '配料',
        ko: '토핑',
        hi: 'टॉपिंग',
        ar: 'إضافة'
    }
});
data.push({
    name: 'DeployVendor',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo số dư người bán',
        en: 'Vendor Opening Balance',
        fr: 'Solde ouverture fournisseur',
        es: 'Saldo apertura proveedor',
        id: 'Saldo awal vendor',
        ja: '仕入先期首残高',
        zh: '供应商期初余额',
        ko: '공급업체 기초 잔액',
        hi: 'विक्रेता प्रारंभिक शेष',
        ar: 'رصيد افتتاحي للمورد'
    }
});
data.push({
    name: 'DeployCustomer',
    module: 'deployment',
    display: {
        vi: 'Triển khai khách hàng',
        en: 'Deploy Customers',
        fr: 'Déployer clients',
        es: 'Desplegar clientes',
        id: 'Terapkan pelanggan',
        ja: '顧客展開',
        zh: '部署客户',
        ko: '고객 배포',
        hi: 'ग्राहक तैनात करें',
        ar: 'نشر العملاء'
    }
});
data.push({
    name: 'DeployCustomerItem',
    module: 'deployment',
    display: {
        vi: 'Dòng khách hàng',
        en: 'Customer line',
        fr: 'Détail déploiement client',
        es: 'Detalle despliegue cliente',
        id: 'Detail terapkan pelanggan',
        ja: '顧客展開明細',
        zh: '部署客户明细',
        ko: '고객 배포 항목',
        hi: 'ग्राहक तैनाती विवरण',
        ar: 'تفاصيل نشر العميل'
    }
});
data.push({
    name: 'Deployment',
    module: 'deployment',
    display: {
        vi: 'Triển khai dữ liệu',
        en: 'Deployment',
        fr: 'Déploiement',
        es: 'Despliegue',
        id: 'Penerapan',
        ja: 'デプロイ',
        zh: '部署',
        ko: '배포',
        hi: 'तैनाती',
        ar: 'النشر'
    }
});
data.push({
    name: 'DeployItemGood',
    module: 'deployment',
    display: {
        vi: 'Triển khai hàng hóa',
        en: 'Deploy Goods',
        fr: 'Deploy Goods',
        es: 'Deploy Goods',
        id: 'Deploy Goods',
        ja: 'Deploy Goods',
        zh: 'Deploy Goods',
        ko: 'Deploy Goods',
        hi: 'Deploy Goods',
        ar: 'Deploy Goods'
    }
});
data.push({
    name: 'DeployItemGoodItem',
    module: 'deployment',
    display: {
        vi: 'Dòng hàng hóa',
        en: 'Goods line',
        fr: 'Deploy Goods Item',
        es: 'Deploy Goods Item',
        id: 'Deploy Goods Item',
        ja: 'Deploy Goods Item',
        zh: 'Deploy Goods Item',
        ko: 'Deploy Goods Item',
        hi: 'Deploy Goods Item',
        ar: 'Deploy Goods Item'
    }
});
data.push({
    name: 'DeployItemFood',
    module: 'deployment',
    display: {
        vi: 'Triển khai món ăn',
        en: 'Deploy Food',
        fr: 'Deploy Food',
        es: 'Deploy Food',
        id: 'Deploy Food',
        ja: 'Deploy Food',
        zh: 'Deploy Food',
        ko: 'Deploy Food',
        hi: 'Deploy Food',
        ar: 'Deploy Food'
    }
});
data.push({
    name: 'DeployItemFoodItem',
    module: 'deployment',
    display: {
        vi: 'Dòng món ăn',
        en: 'Food line',
        fr: 'Deploy Food Item',
        es: 'Deploy Food Item',
        id: 'Deploy Food Item',
        ja: 'Deploy Food Item',
        zh: 'Deploy Food Item',
        ko: 'Deploy Food Item',
        hi: 'Deploy Food Item',
        ar: 'Deploy Food Item'
    }
});
data.push({
    name: 'DeployItemBeverage',
    module: 'deployment',
    display: {
        vi: 'Triển khai đồ uống',
        en: 'Deploy Beverages',
        fr: 'Deploy Beverages',
        es: 'Deploy Beverages',
        id: 'Deploy Beverages',
        ja: 'Deploy Beverages',
        zh: 'Deploy Beverages',
        ko: 'Deploy Beverages',
        hi: 'Deploy Beverages',
        ar: 'Deploy Beverages'
    }
});
data.push({
    name: 'DeployItemBeverageItem',
    module: 'deployment',
    display: {
        vi: 'Dòng đồ uống',
        en: 'Beverage line',
        fr: 'Deploy Beverages Item',
        es: 'Deploy Beverages Item',
        id: 'Deploy Beverages Item',
        ja: 'Deploy Beverages Item',
        zh: 'Deploy Beverages Item',
        ko: 'Deploy Beverages Item',
        hi: 'Deploy Beverages Item',
        ar: 'Deploy Beverages Item'
    }
});
data.push({
    name: 'DeployItemMaterial',
    module: 'deployment',
    display: {
        vi: 'Triển khai nguyên vật liệu',
        en: 'Deploy Materials',
        fr: 'Deploy Materials',
        es: 'Deploy Materials',
        id: 'Deploy Materials',
        ja: 'Deploy Materials',
        zh: 'Deploy Materials',
        ko: 'Deploy Materials',
        hi: 'Deploy Materials',
        ar: 'Deploy Materials'
    }
});
data.push({
    name: 'DeployItemMaterialItem',
    module: 'deployment',
    display: {
        vi: 'Dòng nguyên liệu',
        en: 'Material line',
        fr: 'Deploy Materials Item',
        es: 'Deploy Materials Item',
        id: 'Deploy Materials Item',
        ja: 'Deploy Materials Item',
        zh: 'Deploy Materials Item',
        ko: 'Deploy Materials Item',
        hi: 'Deploy Materials Item',
        ar: 'Deploy Materials Item'
    }
});
data.push({
    name: 'DeployItemConsumable',
    module: 'deployment',
    display: {
        vi: 'Triển khai CCDC tiêu hao',
        en: 'Deploy Consumables',
        fr: 'Deploy Consumables',
        es: 'Deploy Consumables',
        id: 'Deploy Consumables',
        ja: 'Deploy Consumables',
        zh: 'Deploy Consumables',
        ko: 'Deploy Consumables',
        hi: 'Deploy Consumables',
        ar: 'Deploy Consumables'
    }
});
data.push({
    name: 'DeployItemConsumableItem',
    module: 'deployment',
    display: {
        vi: 'Dòng công cụ dụng cụ',
        en: 'Consumable line',
        fr: 'Deploy Consumables Item',
        es: 'Deploy Consumables Item',
        id: 'Deploy Consumables Item',
        ja: 'Deploy Consumables Item',
        zh: 'Deploy Consumables Item',
        ko: 'Deploy Consumables Item',
        hi: 'Deploy Consumables Item',
        ar: 'Deploy Consumables Item'
    }
});
data.push({
    name: 'DeployItemFixedService',
    module: 'deployment',
    display: {
        vi: 'Triển khai dịch vụ cố định',
        en: 'Deploy Fixed Services',
        fr: 'Deploy Fixed Services',
        es: 'Deploy Fixed Services',
        id: 'Deploy Fixed Services',
        ja: 'Deploy Fixed Services',
        zh: 'Deploy Fixed Services',
        ko: 'Deploy Fixed Services',
        hi: 'Deploy Fixed Services',
        ar: 'Deploy Fixed Services'
    }
});
data.push({
    name: 'DeployItemFixedServiceItem',
    module: 'deployment',
    display: {
        vi: 'Dòng dịch vụ',
        en: 'Service line',
        fr: 'Deploy Fixed Services Item',
        es: 'Deploy Fixed Services Item',
        id: 'Deploy Fixed Services Item',
        ja: 'Deploy Fixed Services Item',
        zh: 'Deploy Fixed Services Item',
        ko: 'Deploy Fixed Services Item',
        hi: 'Deploy Fixed Services Item',
        ar: 'Deploy Fixed Services Item'
    }
});
data.push({
    name: 'DeployItemExtraFee',
    module: 'deployment',
    display: {
        vi: 'Triển khai phí phụ thu',
        en: 'Deploy Extra Fees',
        fr: 'Deploy Extra Fees',
        es: 'Deploy Extra Fees',
        id: 'Deploy Extra Fees',
        ja: 'Deploy Extra Fees',
        zh: 'Deploy Extra Fees',
        ko: 'Deploy Extra Fees',
        hi: 'Deploy Extra Fees',
        ar: 'Deploy Extra Fees'
    }
});
data.push({
    name: 'DeployItemExtraFeeItem',
    module: 'deployment',
    display: {
        vi: 'Dòng phí phụ thu',
        en: 'Extra fee line',
        fr: 'Deploy Extra Fees Item',
        es: 'Deploy Extra Fees Item',
        id: 'Deploy Extra Fees Item',
        ja: 'Deploy Extra Fees Item',
        zh: 'Deploy Extra Fees Item',
        ko: 'Deploy Extra Fees Item',
        hi: 'Deploy Extra Fees Item',
        ar: 'Deploy Extra Fees Item'
    }
});
data.push({
    name: 'DeployItemServicePack',
    module: 'deployment',
    display: {
        vi: 'Triển khai gói dịch vụ',
        en: 'Deploy Service Packs',
        fr: 'Deploy Service Packs',
        es: 'Deploy Service Packs',
        id: 'Deploy Service Packs',
        ja: 'Deploy Service Packs',
        zh: 'Deploy Service Packs',
        ko: 'Deploy Service Packs',
        hi: 'Deploy Service Packs',
        ar: 'Deploy Service Packs'
    }
});
data.push({
    name: 'DeployItemServicePackItem',
    module: 'deployment',
    display: {
        vi: 'Dòng gói dịch vụ',
        en: 'Service pack line',
        fr: 'Deploy Service Packs Item',
        es: 'Deploy Service Packs Item',
        id: 'Deploy Service Packs Item',
        ja: 'Deploy Service Packs Item',
        zh: 'Deploy Service Packs Item',
        ko: 'Deploy Service Packs Item',
        hi: 'Deploy Service Packs Item',
        ar: 'Deploy Service Packs Item'
    }
});
data.push({
    name: 'DeployItemDepositPack',
    module: 'deployment',
    display: {
        vi: 'Triển khai gói trả trước',
        en: 'Deploy Deposit Packs',
        fr: 'Deploy Deposit Packs',
        es: 'Deploy Deposit Packs',
        id: 'Deploy Deposit Packs',
        ja: 'Deploy Deposit Packs',
        zh: 'Deploy Deposit Packs',
        ko: 'Deploy Deposit Packs',
        hi: 'Deploy Deposit Packs',
        ar: 'Deploy Deposit Packs'
    }
});
data.push({
    name: 'DeployItemDepositPackItem',
    module: 'deployment',
    display: {
        vi: 'Dòng gói trả trước',
        en: 'Prepaid pack line',
        fr: 'Deploy Deposit Packs Item',
        es: 'Deploy Deposit Packs Item',
        id: 'Deploy Deposit Packs Item',
        ja: 'Deploy Deposit Packs Item',
        zh: 'Deploy Deposit Packs Item',
        ko: 'Deploy Deposit Packs Item',
        hi: 'Deploy Deposit Packs Item',
        ar: 'Deploy Deposit Packs Item'
    }
});
// Phase 3b — 6 services (parent + item)
data.push({
    name: 'DeployStore',
    module: 'deployment',
    display: { vi: 'Triển khai cửa hàng, kho', en: 'Deploy Stores & Warehouses', fr: 'Déployer magasins/entrepôts', es: 'Implementar tiendas/almacenes', id: 'Implementasi toko/gudang', ja: '店舗倉庫配置', zh: '部署门店仓库', ko: '매장 창고 배치', hi: 'स्टोर गोदाम तैनात', ar: 'نشر المتاجر والمستودعات' }
});
data.push({
    name: 'DeployStoreItem',
    module: 'deployment',
    display: { vi: 'Dòng cửa hàng, kho', en: 'Store line', fr: 'Ligne magasin', es: 'Línea tienda', id: 'Baris toko', ja: '店舗明細', zh: '门店行', ko: '매장 라인', hi: 'स्टोर पंक्ति', ar: 'بند متجر' }
});
data.push({
    name: 'DeployEXPCostDeferral',
    module: 'deployment',
    display: { vi: 'Triển khai chi phí trả trước', en: 'Deploy Deferred Expenses', fr: 'Déployer charges constatées', es: 'Implementar gastos diferidos', id: 'Implementasi biaya ditangguhkan', ja: '前払費用配置', zh: '部署预付费用', ko: '이연비용 배치', hi: 'विलंबित व्यय तैनात', ar: 'نشر المصاريف المؤجلة' }
});
data.push({
    name: 'DeployEXPCostDeferralItem',
    module: 'deployment',
    display: { vi: 'Dòng chi phí trả trước', en: 'Prepaid expense line', fr: 'Ligne charge', es: 'Línea gasto', id: 'Baris biaya', ja: '費用明細', zh: '费用行', ko: '비용 라인', hi: 'व्यय पंक्ति', ar: 'بند مصاريف' }
});
data.push({
    name: 'DeployVendorBalance',
    module: 'deployment',
    display: { vi: 'Triển khai nhà cung cấp', en: 'Deploy Vendors', fr: 'Déployer fournisseurs', es: 'Implementar proveedores', id: 'Implementasi pemasok', ja: '仕入先配置', zh: '部署供应商', ko: '공급업체 배치', hi: 'विक्रेता तैनात', ar: 'نشر الموردين' }
});
data.push({
    name: 'DeployVendorBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng nhà cung cấp', en: 'Vendor line', fr: 'Ligne fournisseur', es: 'Línea proveedor', id: 'Baris pemasok', ja: '仕入先明細', zh: '供应商行', ko: '공급업체 라인', hi: 'विक्रेता पंक्ति', ar: 'بند المورد' }
});
data.push({
    name: 'DeployEmployeeBalance',
    module: 'deployment',
    display: { vi: 'Triển khai nhân viên', en: 'Deploy Employees', fr: 'Déployer employés', es: 'Implementar empleados', id: 'Implementasi karyawan', ja: '従業員配置', zh: '部署员工', ko: '직원 배치', hi: 'कर्मचारी तैनात', ar: 'نشر الموظفين' }
});
data.push({
    name: 'DeployEmployeeBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng nhân viên', en: 'Employee line', fr: 'Ligne employé', es: 'Línea empleado', id: 'Baris karyawan', ja: '従業員明細', zh: '员工行', ko: '직원 라인', hi: 'कर्मचारी पंक्ति', ar: 'بند الموظف' }
});
data.push({
    name: 'DeployCashBalance',
    module: 'deployment',
    display: { vi: 'Triển khai tiền mặt, ngân hàng', en: 'Deploy Cash & Bank', fr: 'Déployer trésorerie', es: 'Implementar caja y bancos', id: 'Implementasi kas & bank', ja: '現預金配置', zh: '部署现金银行', ko: '현금·은행 배치', hi: 'नकद व बैंक तैनात', ar: 'نشر النقد والبنوك' }
});
data.push({
    name: 'DeployCashBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng quỹ', en: 'Cash account line', fr: 'Ligne trésorerie', es: 'Línea caja', id: 'Baris kas', ja: '現預金明細', zh: '现金行', ko: '현금 라인', hi: 'नकद पंक्ति', ar: 'بند النقد' }
});
data.push({
    name: 'DeployInventoryBalance',
    module: 'deployment',
    display: { vi: 'Triển khai tồn kho ban đầu', en: 'Deploy Opening Inventory', fr: 'Déployer stock initial', es: 'Implementar inventario inicial', id: 'Implementasi stok awal', ja: '期首在庫配置', zh: '部署期初库存', ko: '기초재고 배치', hi: 'प्रारंभिक स्टॉक तैनात', ar: 'نشر المخزون الافتتاحي' }
});
data.push({
    name: 'DeployInventoryBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng tồn kho', en: 'Inventory line', fr: 'Ligne stock', es: 'Línea inventario', id: 'Baris stok', ja: '在庫明細', zh: '库存行', ko: '재고 라인', hi: 'स्टॉक पंक्ति', ar: 'بند المخزون' }
});
data.push({
    name: 'DeployAssetBalance',
    module: 'deployment',
    display: { vi: 'Triển khai tài sản, CCDC', en: 'Deploy Assets & Tools', fr: 'Déployer immobilisations', es: 'Implementar activos', id: 'Implementasi aset', ja: '固定資産配置', zh: '部署资产工具', ko: '자산·공구 배치', hi: 'संपत्ति तैनात', ar: 'نشر الأصول' }
});
data.push({
    name: 'DeployAssetBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng tài sản', en: 'Asset line', fr: 'Ligne immobilisation', es: 'Línea activo', id: 'Baris aset', ja: '資産明細', zh: '资产行', ko: '자산 라인', hi: 'संपत्ति पंक्ति', ar: 'بند الأصل' }
});
data.push({
    name: 'DeployTrialBalance',
    module: 'deployment',
    display: { vi: 'Triển khai bảng cân đối thử', en: 'Deploy Trial Balance', fr: 'Déployer balance de vérification', es: 'Implementar balance de comprobación', id: 'Implementasi neraca saldo', ja: '試算表配置', zh: '部署试算表', ko: '시산표 배치', hi: 'तलपट तैनात', ar: 'نشر ميزان المراجعة' }
});
data.push({
    name: 'DeployTrialBalanceItem',
    module: 'deployment',
    display: { vi: 'Dòng số dư tài khoản', en: 'Account balance line', fr: 'Ligne balance', es: 'Línea balance', id: 'Baris neraca', ja: '試算表明細', zh: '试算表行', ko: '시산표 라인', hi: 'तलपट पंक्ति', ar: 'بند ميزان المراجعة' }
});
// 2026-05-22 — DeployCOA voucher (Chart of Accounts)
data.push({
    name: 'DeployCOA',
    module: 'deployment',
    display: { vi: 'Triển khai sơ đồ tài khoản', en: 'Deploy Chart of Accounts', fr: 'Déployer plan comptable', es: 'Implementar plan contable', id: 'Implementasi bagan akun', ja: '勘定科目体系配置', zh: '部署会计科目表', ko: '계정과목표 배치', hi: 'खाता चार्ट तैनात', ar: 'نشر دليل الحسابات' }
});
data.push({
    name: 'DeployCOAItem',
    module: 'deployment',
    display: { vi: 'Dòng tài khoản', en: 'Account line', fr: 'Ligne compte', es: 'Línea cuenta', id: 'Baris akun', ja: '勘定明細', zh: '科目行', ko: '계정 라인', hi: 'खाता पंक्ति', ar: 'بند الحساب' }
});
data.push({
    name: 'DeployInventory',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo tồn kho',
        en: 'Initialize Inventory',
        fr: 'Initialisation stock',
        es: 'Inicializar inventario',
        id: 'Inisialisasi stok',
        ja: '在庫初期化',
        zh: '初始化库存',
        ko: '재고 초기화',
        hi: 'इन्वेंट्री आरंभ करें',
        ar: 'تهيئة المخزون'
    }
});
data.push({
    name: 'DeployAsset',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo tài sản',
        en: 'Initialize Fixed Asset',
        fr: 'Initialisation immobilisation',
        es: 'Inicializar activo fijo',
        id: 'Inisialisasi aset tetap',
        ja: '固定資産初期化',
        zh: '初始化固定资产',
        ko: '고정 자산 초기화',
        hi: 'स्थिर संपत्ति आरंभ करें',
        ar: 'تهيئة الأصول الثابتة'
    }
});
data.push({
    name: 'DeployEquipment',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo CCDC',
        en: 'Initialize Equipment',
        fr: 'Initialisation équipement',
        es: 'Inicializar equipo',
        id: 'Inisialisasi alat',
        ja: '備品初期化',
        zh: '初始化设备',
        ko: '장비 초기화',
        hi: 'उपकरण आरंभ करें',
        ar: 'تهيئة المعدات'
    }
});
data.push({
    name: 'DeployCash',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo Sổ Quỹ',
        en: 'Initialize Cash Balance',
        fr: 'Initialisation solde caisse',
        es: 'Inicializar saldo caja',
        id: 'Inisialisasi saldo kas',
        ja: '現金残高初期化',
        zh: '初始化现金余额',
        ko: '현금 잔액 초기화',
        hi: 'नकद शेष आरंभ करें',
        ar: 'تهيئة رصيد النقدية'
    }
});
data.push({
    name: 'DeployEmployee',
    module: 'deploy',
    display: {
        vi: 'Khởi tạo nhân sự',
        en: 'Initialize Employees',
        fr: 'Initialisation employés',
        es: 'Inicializar empleados',
        id: 'Inisialisasi karyawan',
        ja: '従業員初期化',
        zh: '初始化员工',
        ko: '직원 초기화',
        hi: 'कर्मचारी आरंभ',
        ar: 'تهيئة الموظفين'
    }
});

data.push({
    name: 'ARServicePlan',
    module: 'ar',
    display: {
        vi: 'Kế hoạch dịch vụ',
        en: 'Service Plan'
    }
});

data.push({
    name: 'SysDataBackup',
    module: 'sys',
    display: {
        vi: 'Sao lưu dữ liệu',
        en: 'Data Backup',
        fr: 'Sauvegarde des données',
        es: 'Copia de seguridad',
        id: 'Cadangan Data',
        ja: 'データバックアップ',
        zh: '数据备份',
        ko: '데이터 백업',
        hi: 'डेटा बैकअप',
        ar: 'نسخ احتياطي'
    }
});
data.push({
    name: 'SysDataAudit',
    module: 'sys',
    display: {
        vi: 'Kiểm tra dữ liệu',
        en: 'Data Audit',
        fr: 'Audit des données',
        es: 'Auditoría de datos',
        id: 'Audit Data',
        ja: 'データ監査',
        zh: '数据审计',
        ko: '데이터 감사',
        hi: 'डेटा ऑडिट',
        ar: 'تدقيق البيانات'
    }
});
data.push({
    name: 'SysDataAuditItem',
    module: 'sys',
    display: {
        vi: 'Chi tiết kiểm tra',
        en: 'Audit Detail',
        fr: 'Détail de l\'audit',
        es: 'Detalle de auditoría',
        id: 'Detail Audit',
        ja: '監査詳細',
        zh: '审计详情',
        ko: '감사 상세',
        hi: 'ऑडिट विवरण',
        ar: 'تفاصيل التدقيق'
    }
});

// Sale Channel module — BE service names renamed INTSale* (Phase 8B-P3 align)
data.push({
    name: 'INTSaleApp',
    module: 'saleChannel',
    display: {
        vi: 'Kết nối sàn',
        en: 'Sale Channel App',
        fr: 'Application canal',
        es: 'App canal',
        id: 'Aplikasi saluran',
        ja: '販売チャネルアプリ',
        zh: '销售渠道应用',
        ko: '판매 채널 앱',
        hi: 'सेल्स चैनल ऐप',
        ar: 'تطبيق قناة البيع'
    }
});
data.push({
    name: 'INTSaleShop',
    module: 'saleChannel',
    display: {
        vi: 'Cửa hàng sàn',
        en: 'Sale Channel Shop',
        fr: 'Boutique canal',
        es: 'Tienda canal',
        id: 'Toko saluran',
        ja: '販売チャネル店舗',
        zh: '销售渠道店铺',
        ko: '판매 채널 매장',
        hi: 'सेल्स चैनल शॉप',
        ar: 'متجر قناة البيع'
    }
});
data.push({
    name: 'INTConnectionItem',
    module: 'integration',
    display: {
        vi: 'Mapping sản phẩm',
        en: 'Product Mapping',
        fr: 'Mapping produit',
        es: 'Mapeo producto',
        id: 'Pemetaan produk',
        ja: '商品マッピング',
        zh: '商品映射',
        ko: '상품 매핑',
        hi: 'उत्पाद मैपिंग',
        ar: 'ربط المنتج'
    }
});
data.push({
    name: 'INTSaleOrder',
    module: 'saleChannel',
    display: {
        vi: 'Đơn từ sàn',
        en: 'Sale Channel Order',
        fr: 'Commande canal',
        es: 'Pedido canal',
        id: 'Pesanan saluran',
        ja: 'チャネル注文',
        zh: '渠道订单',
        ko: '채널 주문',
        hi: 'चैनल ऑर्डर',
        ar: 'طلب القناة'
    }
});
data.push({
    name: 'INTSaleInventory',
    module: 'saleChannel',
    display: {
        vi: 'Đồng bộ tồn kho',
        en: 'Stock Sync',
        fr: 'Sync stock',
        es: 'Sinc. stock',
        id: 'Sinkron stok',
        ja: '在庫同期',
        zh: '库存同步',
        ko: '재고 동기화',
        hi: 'स्टॉक सिंक',
        ar: 'مزامنة المخزون'
    }
});
data.push({
    name: 'INTSaleEvent',
    module: 'saleChannel',
    display: {
        vi: 'Nhật ký',
        en: 'Activity Log',
        fr: 'Journal',
        es: 'Registro',
        id: 'Log aktivitas',
        ja: 'ログ',
        zh: '日志',
        ko: '로그',
        hi: 'लॉग',
        ar: 'السجل'
    }
});
data.push({
    name: 'INTSaleJobQueue',
    module: 'saleChannel',
    display: {
        vi: 'Hàng đợi xử lý',
        en: 'Processing Queue',
        fr: 'File de traitement',
        es: 'Cola de procesamiento',
        id: 'Antrean proses',
        ja: '処理キュー',
        zh: '处理队列',
        ko: '처리 대기열',
        hi: 'प्रोसेसिंग कतार',
        ar: 'قائمة انتظار المعالجة'
    }
});
data.push({
    name: 'INTSalePlatform',
    module: 'saleChannel',
    display: {
        vi: 'Nền tảng sàn',
        en: 'Platform',
        fr: 'Plateforme',
        es: 'Plataforma',
        id: 'Platform',
        ja: 'プラットフォーム',
        zh: '平台',
        ko: '플랫폼',
        hi: 'प्लेटफ़ॉर्म',
        ar: 'منصة'
    }
});
data.push({
    name: 'INTSaleFulfillment',
    module: 'saleChannel',
    display: {
        vi: 'Thông báo lên sàn',
        en: 'Push to Channel',
        fr: 'Envoyer à la plateforme',
        es: 'Enviar al canal',
        id: 'Kirim ke kanal',
        ja: 'チャネルへ送信',
        zh: '推送至平台',
        ko: '채널로 전송',
        hi: 'चैनल पर भेजें',
        ar: 'إرسال للقناة'
    }
});
data.push({
    name: 'INTSaleSettlement',
    module: 'saleChannel',
    display: {
        vi: 'Đối soát thanh toán',
        en: 'Settlement',
        fr: 'Règlement',
        es: 'Liquidación',
        id: 'Penyelesaian',
        ja: '清算',
        zh: '结算',
        ko: '정산',
        hi: 'निपटान',
        ar: 'التسوية'
    }
});

// Social Channel module — BE service names INTSocial* (Phase 8B-P3 align)
data.push({
    name: 'INTSocialApp',
    module: 'socialChannel',
    display: {
        vi: 'Kết nối kênh chat',
        en: 'Social Channel App',
        fr: 'Application sociale',
        es: 'App social',
        id: 'Aplikasi sosial',
        ja: 'ソーシャルアプリ',
        zh: '社交应用',
        ko: '소셜 앱',
        hi: 'सोशल चैनल ऐप',
        ar: 'تطبيق القناة الاجتماعية'
    }
});
data.push({
    name: 'INTSocialShop',
    module: 'socialChannel',
    display: {
        vi: 'Trang/Page',
        en: 'Social Shop',
        fr: 'Boutique sociale',
        es: 'Tienda social',
        id: 'Toko sosial',
        ja: 'ソーシャル店舗',
        zh: '社交店铺',
        ko: '소셜 매장',
        hi: 'सोशल शॉप',
        ar: 'متجر اجتماعي'
    }
});
data.push({
    name: 'INTSocialChat',
    module: 'socialChannel',
    display: {
        vi: 'Cuộc trò chuyện',
        en: 'Conversation',
        fr: 'Conversation',
        es: 'Conversación',
        id: 'Percakapan',
        ja: '会話',
        zh: '会话',
        ko: '대화',
        hi: 'वार्तालाप',
        ar: 'محادثة'
    }
});
data.push({
    name: 'INTSocialMessage',
    module: 'socialChannel',
    display: {
        vi: 'Tin nhắn',
        en: 'Message',
        fr: 'Message',
        es: 'Mensaje',
        id: 'Pesan',
        ja: 'メッセージ',
        zh: '消息',
        ko: '메시지',
        hi: 'संदेश',
        ar: 'رسالة'
    }
});
data.push({
    name: 'INTSocialComment',
    module: 'socialChannel',
    display: {
        vi: 'Bình luận',
        en: 'Comment',
        fr: 'Commentaire',
        es: 'Comentario',
        id: 'Komentar',
        ja: 'コメント',
        zh: '评论',
        ko: '댓글',
        hi: 'टिप्पणी',
        ar: 'تعليق'
    }
});
data.push({
    name: 'INTSocialOrder',
    module: 'socialChannel',
    display: {
        vi: 'Đơn chat',
        en: 'Social Order',
        fr: 'Commande sociale',
        es: 'Pedido social',
        id: 'Pesanan sosial',
        ja: 'ソーシャル注文',
        zh: '社交订单',
        ko: '소셜 주문',
        hi: 'सोशल ऑर्डर',
        ar: 'طلب اجتماعي'
    }
});
data.push({
    name: 'INTSocialEvent',
    module: 'socialChannel',
    display: {
        vi: 'Sự kiện chat',
        en: 'Social Event',
        fr: 'Événement social',
        es: 'Evento social',
        id: 'Acara sosial',
        ja: 'ソーシャルイベント',
        zh: '社交事件',
        ko: '소셜 이벤트',
        hi: 'सोशल इवेंट',
        ar: 'حدث اجتماعي'
    }
});
data.push({
    name: 'INTSocialJobQueue',
    module: 'socialChannel',
    display: {
        vi: 'Xử lý chat',
        en: 'Social Processing',
        fr: 'Traitement social',
        es: 'Procesamiento social',
        id: 'Pemrosesan sosial',
        ja: 'ソーシャル処理',
        zh: '社交处理',
        ko: '소셜 처리',
        hi: 'सोशल प्रसंस्करण',
        ar: 'معالجة اجتماعية'
    }
});
data.push({
    name: 'INTSocialTemplate',
    module: 'socialChannel',
    display: {
        vi: 'Mẫu tin',
        en: 'Templates',
        fr: 'Modèles',
        es: 'Plantillas',
        id: 'Templat',
        ja: 'テンプレート',
        zh: '模板',
        ko: '템플릿',
        hi: 'टेम्पलेट',
        ar: 'قوالب'
    }
});
data.push({
    name: 'INTSocialAutoRule',
    module: 'socialChannel',
    display: {
        vi: 'Tự động',
        en: 'Automation',
        fr: 'Automatisation',
        es: 'Automatización',
        id: 'Otomatis',
        ja: '自動化',
        zh: '自动化',
        ko: '자동화',
        hi: 'स्वचालन',
        ar: 'أتمتة'
    }
});

// Integration umbrella module (Phase 9B-C) — INTConnection cross-namespace + 5 INT*App
data.push({
    name: 'INTConnection',
    module: 'integration',
    display: {
        vi: 'Kết nối đối tác',
        en: 'Provider Connection',
        fr: 'Connexion partenaire',
        es: 'Conexión socio',
        id: 'Koneksi mitra',
        ja: 'パートナー接続',
        zh: '合作伙伴连接',
        ko: '파트너 연결',
        hi: 'पार्टनर कनेक्शन',
        ar: 'اتصال الشريك'
    }
});
data.push({
    name: 'INTAdvertiseApp',
    module: 'marketing',
    display: {
        vi: 'Kết nối quảng cáo',
        en: 'Ads Connection',
        fr: 'Connexion pub',
        es: 'Conexión anuncios',
        id: 'Koneksi iklan',
        ja: '広告接続',
        zh: '广告连接',
        ko: '광고 연결',
        hi: 'विज्ञापन कनेक्शन',
        ar: 'اتصال الإعلانات'
    }
});
data.push({
    name: 'INTAffiliateApp',
    module: 'marketing',
    display: {
        vi: 'Kết nối affiliate',
        en: 'Affiliate Connection',
        fr: 'Connexion affilié',
        es: 'Conexión afiliado',
        id: 'Koneksi afiliasi',
        ja: 'アフィリエイト接続',
        zh: '联盟连接',
        ko: '제휴 연결',
        hi: 'एफ़िलिएट कनेक्शन',
        ar: 'اتصال الإحالة'
    }
});
data.push({
    name: 'INTReviewApp',
    module: 'marketing',
    display: {
        vi: 'Kết nối review',
        en: 'Review Connection',
        fr: 'Connexion avis',
        es: 'Conexión reseñas',
        id: 'Koneksi ulasan',
        ja: 'レビュー接続',
        zh: '评论连接',
        ko: '리뷰 연결',
        hi: 'रिव्यू कनेक्शन',
        ar: 'اتصال المراجعات'
    }
});
data.push({
    name: 'MKGReview',
    module: 'marketing',
    display: {
        vi: 'Đánh giá',
        en: 'Reviews',
        fr: 'Avis',
        es: 'Reseñas',
        id: 'Ulasan',
        ja: 'レビュー',
        zh: '评价',
        ko: '리뷰',
        hi: 'समीक्षाएं',
        ar: 'التقييمات'
    }
});
data.push({
    name: 'INTMessageEmailApp',
    module: 'marketing',
    display: {
        vi: 'Kết nối Email',
        en: 'Email Connection',
        fr: 'Connexion email',
        es: 'Conexión email',
        id: 'Koneksi email',
        ja: 'メール接続',
        zh: '邮件连接',
        ko: '이메일 연결',
        hi: 'ईमेल कनेक्शन',
        ar: 'اتصال البريد'
    }
});
data.push({
    name: 'INTMessageSmsApp',
    module: 'marketing',
    display: {
        vi: 'Kết nối SMS',
        en: 'SMS Connection',
        fr: 'Connexion SMS',
        es: 'Conexión SMS',
        id: 'Koneksi SMS',
        ja: 'SMS接続',
        zh: 'SMS连接',
        ko: 'SMS 연결',
        hi: 'SMS कनेक्शन',
        ar: 'اتصال SMS'
    }
});
data.push({
    name: 'INTCarrierOrder',
    module: 'carrier',
    display: {
        vi: 'Đơn vận chuyển',
        en: 'Shipments',
        fr: 'Envois',
        es: 'Envíos',
        id: 'Pengiriman',
        ja: '配送注文',
        zh: '运单',
        ko: '배송 주문',
        hi: 'शिपमेंट',
        ar: 'الشحنات'
    }
});
data.push({
    name: 'INTCarrierEvent',
    module: 'carrier',
    display: {
        vi: 'Hành trình',
        en: 'Events',
        fr: 'Suivi',
        es: 'Eventos',
        id: 'Pelacakan',
        ja: '配送イベント',
        zh: '物流轨迹',
        ko: '배송 이벤트',
        hi: 'ट्रैकिंग',
        ar: 'الأحداث'
    }
});
data.push({
    name: 'INTCarrierJobQueue',
    module: 'carrier',
    display: {
        vi: 'Xử lý job',
        en: 'Jobs',
        fr: 'Tâches',
        es: 'Tareas',
        id: 'Job',
        ja: 'ジョブ',
        zh: '任务',
        ko: '작업',
        hi: 'कार्य',
        ar: 'مهام'
    }
});

data.push({
    name: 'ACUserComment',
    module: 'user',
    display: {
        vi: "Bình luận",
        en: "Comments",
        fr: "Commentaires",
        es: "Comentarios",
        id: "Komentar",
        ja: "コメント",
        zh: "评论",
        ko: "댓글",
        hi: "टिप्पणी",
        ar: "تعليقات"
    }
});
data.push({
    name: 'AIConfig',
    module: 'ai',
    display: {
        vi: "Cấu hình AI",
        en: "AI Config",
        fr: "Config IA",
        es: "Config IA",
        id: "Konfig AI",
        ja: "AI設定",
        zh: "AI配置",
        ko: "AI 설정",
        hi: "AI विन्यास",
        ar: "إعداد AI"
    }
});
data.push({
    name: 'AIDocumentSource',
    module: 'ai',
    display: {
        vi: "Nguồn tài liệu AI",
        en: "AI Source",
        fr: "Source IA",
        es: "Fuente IA",
        id: "Sumber AI",
        ja: "AIソース",
        zh: "AI来源",
        ko: "AI 소스",
        hi: "AI स्रोत",
        ar: "مصدر AI"
    }
});
data.push({
    name: 'TaxBook',
    module: 'tax',
    display: {
        vi: "Sổ kế toán thuế",
        en: "Tax books",
        fr: "Livres fiscaux",
        es: "Libros fiscales",
        id: "Buku pajak",
        ja: "税務帳簿",
        zh: "税务账簿",
        ko: "세무 장부",
        hi: "कर बहियाँ",
        ar: "الدفاتر الضريبية"
    }
});
data.push({
    name: 'ARInvoiceAdjustment',
    module: 'ar',
    display: {
        vi: "Hoá đơn huỷ, điều chỉnh",
        en: "Cancelled invoices",
        fr: "Factures annulées",
        es: "Facturas anuladas",
        id: "Faktur batal",
        ja: "取消請求書",
        zh: "作废发票",
        ko: "취소 계산서",
        hi: "रद्द चालान",
        ar: "الفواتير الملغاة"
    }
});
data.push({
    name: 'ARInvoiceQueue',
    module: 'ar',
    display: {
        vi: "Nhật ký hoá đơn",
        en: "E-invoice log",
        fr: "Journal factures",
        es: "Registro facturas",
        id: "Log faktur",
        ja: "請求書ログ",
        zh: "发票日志",
        ko: "송장 기록",
        hi: "चालान लॉग",
        ar: "سجل الفواتير"
    }
});
data.push({
    name: 'AIJobQueue',
    module: 'ai',
    display: {
        vi: "Hàng đợi AI",
        en: "AI Queue",
        fr: "File IA",
        es: "Cola IA",
        id: "Antrean AI",
        ja: "AIキュー",
        zh: "AI队列",
        ko: "AI 큐",
        hi: "AI कतार",
        ar: "طابور AI"
    }
});
data.push({
    name: 'AIKnowledgeBase',
    module: 'ai',
    display: {
        vi: "Tri thức AI",
        en: "AI Knowledge",
        fr: "Savoir IA",
        es: "Saber IA",
        id: "Pengetahuan AI",
        ja: "AIナレッジ",
        zh: "AI知识",
        ko: "AI 지식",
        hi: "AI ज्ञान",
        ar: "معرفة AI"
    }
});
data.push({
    name: 'APExpense',
    module: 'ap',
    display: {
        vi: "Chi phí mua hàng",
        en: "Purchase Expense",
        fr: "Frais achat",
        es: "Gasto compra",
        id: "Biaya beli",
        ja: "仕入費用",
        zh: "采购费用",
        ko: "매입 비용",
        hi: "क्रय व्यय",
        ar: "مصروف شراء"
    }
});
data.push({
    name: 'APPayment',
    module: 'ap',
    display: {
        vi: "Thanh toán mua",
        en: "AP Payment",
        fr: "Paiement achat",
        es: "Pago compra",
        id: "Bayar beli",
        ja: "支払",
        zh: "采购付款",
        ko: "매입 지급",
        hi: "क्रय भुगतान",
        ar: "دفع شراء"
    }
});
data.push({
    name: 'APPaymentApply',
    module: 'ap',
    display: {
        vi: "Phân bổ thanh toán",
        en: "Payment Apply",
        fr: "Affectation",
        es: "Aplicación",
        id: "Alokasi bayar",
        ja: "支払充当",
        zh: "付款分摊",
        ko: "지급 배분",
        hi: "भुगतान आवंटन",
        ar: "تخصيص دفع"
    }
});
data.push({
    name: 'APPaymentItem',
    module: 'ap',
    display: {
        vi: "Dòng thanh toán",
        en: "Payment Item",
        fr: "Ligne paiement",
        es: "Línea pago",
        id: "Baris bayar",
        ja: "支払明細",
        zh: "付款明细",
        ko: "지급 명세",
        hi: "भुगतान पंक्ति",
        ar: "بند دفع"
    }
});
data.push({
    name: 'ARAssetRegistration',
    module: 'ar',
    display: {
        vi: "Đăng ký tài sản",
        en: "Asset Registration",
        fr: "Enregistrement bien",
        es: "Registro activo",
        id: "Registrasi aset",
        ja: "資産登録",
        zh: "资产登记",
        ko: "자산 등록",
        hi: "संपत्ति पंजीकरण",
        ar: "تسجيل أصل"
    }
});
data.push({
    name: 'ARCoverageClaim',
    module: 'ar',
    display: {
        vi: "Yêu cầu bồi thường",
        en: "Coverage Claim",
        fr: "Réclamation",
        es: "Reclamación",
        id: "Klaim",
        ja: "補償請求",
        zh: "理赔",
        ko: "보상 청구",
        hi: "दावा",
        ar: "مطالبة"
    }
});
data.push({
    name: 'ARCoveragePlan',
    module: 'ar',
    display: {
        vi: "Kế hoạch bảo vệ",
        en: "Coverage Plan",
        fr: "Plan protection",
        es: "Plan cobertura",
        id: "Paket proteksi",
        ja: "補償プラン",
        zh: "保障计划",
        ko: "보장 플랜",
        hi: "कवरेज योजना",
        ar: "خطة تغطية"
    }
});
data.push({
    name: 'ARDeliveryInspection',
    module: 'ar',
    display: {
        vi: "Kiểm tra trước giao",
        en: "Delivery Inspection",
        fr: "Inspection livraison",
        es: "Inspección entrega",
        id: "Inspeksi kirim",
        ja: "納品検査",
        zh: "交付检查",
        ko: "납품 검사",
        hi: "डिलीवरी निरीक्षण",
        ar: "فحص التسليم"
    }
});
data.push({
    name: 'ARFinancingPlan',
    module: 'ar',
    display: {
        vi: "Hồ sơ trả góp",
        en: "Financing Plan",
        fr: "Dossier crédit",
        es: "Plan financiación",
        id: "Rencana cicilan",
        ja: "分割プラン",
        zh: "分期方案",
        ko: "할부 플랜",
        hi: "किस्त योजना",
        ar: "خطة تقسيط"
    }
});
data.push({
    name: 'ARFinancingSchedule',
    module: 'ar',
    display: {
        vi: "Lịch trả góp",
        en: "Installment Schedule",
        fr: "Échéancier",
        es: "Calendario pagos",
        id: "Jadwal cicilan",
        ja: "分割スケジュール",
        zh: "分期计划",
        ko: "할부 일정",
        hi: "किस्त अनुसूची",
        ar: "جدول أقساط"
    }
});
data.push({
    name: 'ARMaintainPlan',
    module: 'ar',
    display: {
        vi: "Lịch bảo dưỡng",
        en: "Maintenance Plan",
        fr: "Plan entretien",
        es: "Plan mantenimiento",
        id: "Rencana servis",
        ja: "保守計画",
        zh: "保养计划",
        ko: "정비 계획",
        hi: "रखरखाव योजना",
        ar: "خطة صيانة"
    }
});
data.push({
    name: 'ARMaintainReminder',
    module: 'ar',
    display: {
        vi: "Nhắc bảo dưỡng",
        en: "Maintenance Reminder",
        fr: "Rappel entretien",
        es: "Aviso mantenimiento",
        id: "Pengingat servis",
        ja: "保守リマインド",
        zh: "保养提醒",
        ko: "정비 알림",
        hi: "रखरखाव अनुस्मारक",
        ar: "تذكير صيانة"
    }
});
data.push({
    name: 'ARProductCampaign',
    module: 'ar',
    display: {
        vi: "Chiến dịch sản phẩm",
        en: "Product Campaign",
        fr: "Campagne produit",
        es: "Campaña producto",
        id: "Kampanye produk",
        ja: "製品キャンペーン",
        zh: "产品活动",
        ko: "제품 캠페인",
        hi: "उत्पाद अभियान",
        ar: "حملة منتج"
    }
});
data.push({
    name: 'ARProductTrial',
    module: 'ar',
    display: {
        vi: "Dùng thử sản phẩm",
        en: "Product Trial",
        fr: "Essai produit",
        es: "Prueba producto",
        id: "Uji coba produk",
        ja: "製品トライアル",
        zh: "产品试用",
        ko: "제품 체험",
        hi: "उत्पाद परीक्षण",
        ar: "تجربة منتج"
    }
});
data.push({
    name: 'ARRentalBookingExtraItem',
    module: 'rental',
    display: {
        vi: "Hàng kèm thuê",
        en: "Extra Items",
        fr: "Articles extra",
        es: "Artículos extra",
        id: "Barang tambahan",
        ja: "追加品",
        zh: "附加物品",
        ko: "추가 품목",
        hi: "अतिरिक्त वस्तु",
        ar: "عناصر إضافية"
    }
});
data.push({
    name: 'ARRentalObject',
    module: 'rental',
    display: {
        vi: "Tài sản cho thuê",
        en: "Rental Object",
        fr: "Bien loué",
        es: "Objeto alquiler",
        id: "Aset sewa",
        ja: "レンタル資産",
        zh: "租赁资产",
        ko: "임대 자산",
        hi: "किराया संपत्ति",
        ar: "أصل مؤجر"
    }
});
data.push({
    name: 'ARRentalStatus',
    module: 'rental',
    display: {
        vi: "Tình trạng thuê",
        en: "Rental Status",
        fr: "Statut location",
        es: "Estado alquiler",
        id: "Status sewa",
        ja: "レンタル状況",
        zh: "租赁状态",
        ko: "임대 상태",
        hi: "किराया स्थिति",
        ar: "حالة الإيجار"
    }
});
data.push({
    name: 'ARServiceOrder',
    module: 'ar',
    display: {
        vi: "Sửa chữa",
        en: "Service Order",
        fr: "Ordre service",
        es: "Orden servicio",
        id: "Order servis",
        ja: "サービス伝票",
        zh: "维修单",
        ko: "서비스 오더",
        hi: "सेवा आदेश",
        ar: "أمر خدمة"
    }
});
data.push({
    name: 'ARServiceOrderJob',
    module: 'ar',
    display: {
        vi: "Công việc sửa chữa",
        en: "Service Job",
        fr: "Tâche service",
        es: "Trabajo servicio",
        id: "Tugas servis",
        ja: "作業",
        zh: "维修作业",
        ko: "서비스 작업",
        hi: "सेवा कार्य",
        ar: "مهمة خدمة"
    }
});
data.push({
    name: 'ARServiceOrderPart',
    module: 'ar',
    display: {
        vi: "Phụ tùng",
        en: "Service Part",
        fr: "Pièce",
        es: "Repuesto",
        id: "Suku cadang",
        ja: "部品",
        zh: "配件",
        ko: "부품",
        hi: "पुर्जा",
        ar: "قطعة غيار"
    }
});
data.push({
    name: 'ARServicePlanItem',
    module: 'ar',
    display: {
        vi: "Buổi dịch vụ",
        en: "Service Session",
        fr: "Séance",
        es: "Sesión",
        id: "Sesi layanan",
        ja: "セッション",
        zh: "服务场次",
        ko: "서비스 회차",
        hi: "सेवा सत्र",
        ar: "جلسة خدمة"
    }
});
data.push({
    name: 'ARTradeIn',
    module: 'ar',
    display: {
        vi: "Thu cũ đổi mới",
        en: "Trade-in",
        fr: "Reprise",
        es: "Recompra",
        id: "Tukar tambah",
        ja: "下取り",
        zh: "以旧换新",
        ko: "보상 판매",
        hi: "एक्सचेंज",
        ar: "استبدال"
    }
});
data.push({
    name: 'ARWarranty',
    module: 'ar',
    display: {
        vi: "Phiếu bảo hành",
        en: "Warranty",
        fr: "Garantie",
        es: "Garantía",
        id: "Garansi",
        ja: "保証",
        zh: "保修单",
        ko: "보증",
        hi: "वारंटी",
        ar: "ضمان"
    }
});
data.push({
    name: 'ARWarrantyClaim',
    module: 'ar',
    display: {
        vi: "Sửa chữa bảo hành",
        en: "Warranty Claim",
        fr: "Réclamation garantie",
        es: "Reclamo garantía",
        id: "Klaim garansi",
        ja: "保証修理",
        zh: "保修维修",
        ko: "보증 수리",
        hi: "वारंटी दावा",
        ar: "مطالبة ضمان"
    }
});
data.push({
    name: 'ASBOM',
    module: 'asm',
    display: {
        vi: "Định mức lắp ráp",
        en: "Assembly BOM",
        fr: "Nomenclature",
        es: "BOM ensamble",
        id: "BOM rakitan",
        ja: "組立BOM",
        zh: "装配BOM",
        ko: "조립 BOM",
        hi: "असेंबली BOM",
        ar: "قائمة تجميع"
    }
});
data.push({
    name: 'ASBOMItem',
    module: 'asm',
    display: {
        vi: "Chi tiết định mức",
        en: "BOM Item",
        fr: "Ligne BOM",
        es: "Línea BOM",
        id: "Baris BOM",
        ja: "BOM明細",
        zh: "BOM明细",
        ko: "BOM 명세",
        hi: "BOM पंक्ति",
        ar: "بند BOM"
    }
});
data.push({
    name: 'ASIssueItem',
    module: 'asm',
    display: {
        vi: "Dòng xuất lắp ráp",
        en: "Issue Item",
        fr: "Ligne sortie",
        es: "Línea salida",
        id: "Baris keluar",
        ja: "出庫明細",
        zh: "出库明细",
        ko: "출고 명세",
        hi: "निर्गम पंक्ति",
        ar: "بند صرف"
    }
});
data.push({
    name: 'ASLandedCost',
    module: 'asm',
    display: {
        vi: "Chi phí nhập",
        en: "Landed Cost",
        fr: "Coût import",
        es: "Costo importación",
        id: "Biaya impor",
        ja: "輸入諸掛",
        zh: "到岸成本",
        ko: "부대 비용",
        hi: "आयात लागत",
        ar: "تكلفة استيراد"
    }
});
data.push({
    name: 'ASOrder',
    module: 'asm',
    display: {
        vi: "Lệnh lắp ráp",
        en: "Assembly Order",
        fr: "Ordre assemblage",
        es: "Orden ensamble",
        id: "Order rakit",
        ja: "組立指図",
        zh: "装配单",
        ko: "조립 오더",
        hi: "असेंबली आदेश",
        ar: "أمر تجميع"
    }
});
data.push({
    name: 'ASOrderItem',
    module: 'asm',
    display: {
        vi: "Dòng lắp ráp",
        en: "Assembly Item",
        fr: "Ligne assemblage",
        es: "Línea ensamble",
        id: "Baris rakit",
        ja: "組立明細",
        zh: "装配明细",
        ko: "조립 명세",
        hi: "असेंबली पंक्ति",
        ar: "بند تجميع"
    }
});
data.push({
    name: 'ASReceiptItem',
    module: 'asm',
    display: {
        vi: "Dòng nhập",
        en: "Receipt Item",
        fr: "Ligne entrée",
        es: "Línea entrada",
        id: "Baris masuk",
        ja: "入庫明細",
        zh: "入库明细",
        ko: "입고 명세",
        hi: "प्राप्ति पंक्ति",
        ar: "بند استلام"
    }
});
data.push({
    name: 'ASReturnItem',
    module: 'asm',
    display: {
        vi: "Dòng trả",
        en: "Return Item",
        fr: "Ligne retour",
        es: "Línea devolución",
        id: "Baris retur",
        ja: "返品明細",
        zh: "退货明细",
        ko: "반품 명세",
        hi: "वापसी पंक्ति",
        ar: "بند إرجاع"
    }
});
data.push({
    name: 'B2BCatalog',
    module: 'b2b',
    display: {
        vi: "Danh mục B2B",
        en: "B2B Catalog",
        fr: "Catalogue B2B",
        es: "Catálogo B2B",
        id: "Katalog B2B",
        ja: "B2Bカタログ",
        zh: "B2B目录",
        ko: "B2B 카탈로그",
        hi: "B2B सूची",
        ar: "كتالوج B2B"
    }
});
data.push({
    name: 'B2BCatalogItem',
    module: 'b2b',
    display: {
        vi: "Hàng B2B",
        en: "Catalog Item",
        fr: "Article B2B",
        es: "Artículo B2B",
        id: "Barang B2B",
        ja: "B2B商品",
        zh: "B2B商品",
        ko: "B2B 상품",
        hi: "B2B वस्तु",
        ar: "سلعة B2B"
    }
});
data.push({
    name: 'B2BItemMapping',
    module: 'b2b',
    display: {
        vi: "Khớp mã hàng",
        en: "Item Mapping",
        fr: "Correspondance",
        es: "Mapeo artículo",
        id: "Pemetaan barang",
        ja: "商品マッピング",
        zh: "商品映射",
        ko: "상품 매핑",
        hi: "वस्तु मैपिंग",
        ar: "ربط الأصناف"
    }
});
data.push({
    name: 'B2BOrder',
    module: 'b2b',
    display: {
        vi: "Đơn B2B",
        en: "B2B Order",
        fr: "Commande B2B",
        es: "Pedido B2B",
        id: "Pesanan B2B",
        ja: "B2B注文",
        zh: "B2B订单",
        ko: "B2B 주문",
        hi: "B2B आदेश",
        ar: "طلب B2B"
    }
});
data.push({
    name: 'B2BOrderItem',
    module: 'b2b',
    display: {
        vi: "Dòng đơn B2B",
        en: "Order Item",
        fr: "Ligne commande",
        es: "Línea pedido",
        id: "Baris pesanan",
        ja: "注文明細",
        zh: "订单明细",
        ko: "주문 명세",
        hi: "आदेश पंक्ति",
        ar: "بند طلب"
    }
});
data.push({
    name: 'B2BPartnership',
    module: 'b2b',
    display: {
        vi: "Đối tác B2B",
        en: "Partnership",
        fr: "Partenariat",
        es: "Socio B2B",
        id: "Kemitraan",
        ja: "パートナー",
        zh: "B2B伙伴",
        ko: "파트너십",
        hi: "साझेदारी",
        ar: "شراكة"
    }
});
data.push({
    name: 'BusinessEntity',
    module: 'entity',
    display: {
        vi: "Đối tượng",
        en: "Entity",
        fr: "Entité",
        es: "Entidad",
        id: "Entitas",
        ja: "エンティティ",
        zh: "对象",
        ko: "엔터티",
        hi: "इकाई",
        ar: "كيان"
    }
});
data.push({
    name: 'BusinessSetting',
    module: 'setting',
    display: {
        vi: "Cấu hình",
        en: "Settings",
        fr: "Paramètres",
        es: "Configuración",
        id: "Pengaturan",
        ja: "設定",
        zh: "设置",
        ko: "설정",
        hi: "सेटिंग",
        ar: "الإعدادات"
    }
});
data.push({
    name: 'CABankStatementItem',
    module: 'ca',
    display: {
        vi: "Dòng sao kê",
        en: "Statement Line",
        fr: "Ligne relevé",
        es: "Línea extracto",
        id: "Baris rekening",
        ja: "明細行",
        zh: "对账单行",
        ko: "명세 라인",
        hi: "विवरण पंक्ति",
        ar: "بند كشف"
    }
});
data.push({
    name: 'CRMComsRuleSaleGlobal',
    module: 'coms',
    display: {
        vi: "Hoa hồng toàn cục",
        en: "Global Commission",
        fr: "Commission globale",
        es: "Comisión global",
        id: "Komisi global",
        ja: "全体手数料",
        zh: "全局佣金",
        ko: "전체 수수료",
        hi: "वैश्विक कमीशन",
        ar: "عمولة عامة"
    }
});
data.push({
    name: 'CRMLeadAssignRule',
    module: 'crm',
    display: {
        vi: "Phân bổ khách",
        en: "Lead Assign",
        fr: "Attribution",
        es: "Asignación",
        id: "Alokasi lead",
        ja: "リード割当",
        zh: "线索分配",
        ko: "리드 배정",
        hi: "लीड आवंटन",
        ar: "توزيع العملاء"
    }
});
data.push({
    name: 'CRMPipeline',
    module: 'crm',
    display: {
        vi: "Quy trình bán",
        en: "Pipeline",
        fr: "Pipeline",
        es: "Pipeline",
        id: "Pipeline",
        ja: "パイプライン",
        zh: "销售流程",
        ko: "파이프라인",
        hi: "पाइपलाइन",
        ar: "مسار البيع"
    }
});
data.push({
    name: 'CRMPipelineStage',
    module: 'crm',
    display: {
        vi: "Giai đoạn",
        en: "Stage",
        fr: "Étape",
        es: "Etapa",
        id: "Tahap",
        ja: "ステージ",
        zh: "阶段",
        ko: "단계",
        hi: "चरण",
        ar: "مرحلة"
    }
});
data.push({
    name: 'CRMTicket',
    module: 'crm',
    display: {
        vi: "Phiếu hỗ trợ",
        en: "Ticket",
        fr: "Ticket",
        es: "Ticket",
        id: "Tiket",
        ja: "チケット",
        zh: "工单",
        ko: "티켓",
        hi: "टिकट",
        ar: "تذكرة"
    }
});
data.push({
    name: 'CRMTicketActivity',
    module: 'crm',
    display: {
        vi: "Hoạt động hỗ trợ",
        en: "Ticket Activity",
        fr: "Activité ticket",
        es: "Actividad ticket",
        id: "Aktivitas tiket",
        ja: "チケット活動",
        zh: "工单活动",
        ko: "티켓 활동",
        hi: "टिकट गतिविधि",
        ar: "نشاط تذكرة"
    }
});
data.push({
    name: 'CustomerAsset',
    module: 'ar',
    display: {
        vi: "Hồ sơ tài sản",
        en: "Customer Asset",
        fr: "Bien client",
        es: "Activo cliente",
        id: "Aset pelanggan",
        ja: "顧客資産",
        zh: "客户资产",
        ko: "고객 자산",
        hi: "ग्राहक संपत्ति",
        ar: "أصل عميل"
    }
});
data.push({
    name: 'EXPBudget',
    module: 'exp',
    display: {
        vi: "Ngân sách",
        en: "Budget",
        fr: "Budget",
        es: "Presupuesto",
        id: "Anggaran",
        ja: "予算",
        zh: "预算",
        ko: "예산",
        hi: "बजट",
        ar: "ميزانية"
    }
});
data.push({
    name: 'EXPBudgetItem',
    module: 'exp',
    display: {
        vi: "Chi tiết ngân sách",
        en: "Budget Item",
        fr: "Ligne budget",
        es: "Línea presupuesto",
        id: "Baris anggaran",
        ja: "予算明細",
        zh: "预算明细",
        ko: "예산 명세",
        hi: "बजट पंक्ति",
        ar: "بند ميزانية"
    }
});
data.push({
    name: 'EXPPayment',
    module: 'exp',
    display: {
        vi: "Phiếu chi",
        en: "Expense Payment",
        fr: "Paiement frais",
        es: "Pago gasto",
        id: "Bayar biaya",
        ja: "経費支払",
        zh: "费用付款",
        ko: "경비 지급",
        hi: "व्यय भुगतान",
        ar: "دفع مصروف"
    }
});
data.push({
    name: 'EXPWizardSuggestion',
    module: 'exp',
    display: {
        vi: "Gợi ý chi phí",
        en: "Expense Suggestion",
        fr: "Suggestion frais",
        es: "Sugerencia gasto",
        id: "Saran biaya",
        ja: "経費提案",
        zh: "费用建议",
        ko: "경비 제안",
        hi: "व्यय सुझाव",
        ar: "اقتراح مصروف"
    }
});
data.push({
    name: 'ExchangeRate',
    module: 'gl',
    display: {
        vi: "Tỷ giá",
        en: "Exchange Rate",
        fr: "Taux change",
        es: "Tipo cambio",
        id: "Kurs",
        ja: "為替レート",
        zh: "汇率",
        ko: "환율",
        hi: "विनिमय दर",
        ar: "سعر الصرف"
    }
});
data.push({
    name: 'FAAssetAdjIncItemEXP',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng",
        en: "Increase Item",
        fr: "Ligne augmentation",
        es: "Línea alta",
        id: "Baris tambah",
        ja: "増加明細",
        zh: "增加明细",
        ko: "증가 명세",
        hi: "वृद्धि पंक्ति",
        ar: "بند زيادة"
    }
});
data.push({
    name: 'FAAssetAdjIncItemIC',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng",
        en: "Increase Item",
        fr: "Ligne augmentation",
        es: "Línea alta",
        id: "Baris tambah",
        ja: "増加明細",
        zh: "增加明细",
        ko: "증가 명세",
        hi: "वृद्धि पंक्ति",
        ar: "بند زيادة"
    }
});
data.push({
    name: 'FAAssetRegisterItemEXP',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng",
        en: "Register Item",
        fr: "Ligne registre",
        es: "Línea registro",
        id: "Baris daftar",
        ja: "登録明細",
        zh: "登记明细",
        ko: "등록 명세",
        hi: "पंजीकरण पंक्ति",
        ar: "بند تسجيل"
    }
});
data.push({
    name: 'FAAssetRegisterItemIC',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng",
        en: "Register Item",
        fr: "Ligne registre",
        es: "Línea registro",
        id: "Baris daftar",
        ja: "登録明細",
        zh: "登记明细",
        ko: "등록 명세",
        hi: "पंजीकरण पंक्ति",
        ar: "بند تسجيل"
    }
});
data.push({
    name: 'FAEquipmentRegisterItemEXP',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng CCDC",
        en: "Tool Register Item",
        fr: "Ligne outillage",
        es: "Línea herramienta",
        id: "Baris alat",
        ja: "工具登録明細",
        zh: "工具登记明细",
        ko: "공구 등록 명세",
        hi: "उपकरण पंक्ति",
        ar: "بند عدة"
    }
});
data.push({
    name: 'FAEquipmentRegisterItemIC',
    module: 'fa',
    display: {
        vi: "Chi tiết ghi tăng CCDC",
        en: "Tool Register Item",
        fr: "Ligne outillage",
        es: "Línea herramienta",
        id: "Baris alat",
        ja: "工具登録明細",
        zh: "工具登记明细",
        ko: "공구 등록 명세",
        hi: "उपकरण पंक्ति",
        ar: "بند عدة"
    }
});
data.push({
    name: 'GLCostCenter',
    module: 'gl',
    display: {
        vi: "Trung tâm chi phí",
        en: "Cost Center",
        fr: "Centre coût",
        es: "Centro costo",
        id: "Pusat biaya",
        ja: "原価センター",
        zh: "成本中心",
        ko: "원가 센터",
        hi: "लागत केंद्र",
        ar: "مركز تكلفة"
    }
});
data.push({
    name: 'GLFXRevaluation',
    module: 'gl',
    display: {
        vi: "Đánh giá ngoại tệ",
        en: "FX Revaluation",
        fr: "Réévaluation",
        es: "Revaluación",
        id: "Revaluasi valas",
        ja: "外貨評価",
        zh: "汇兑重估",
        ko: "외화 재평가",
        hi: "मुद्रा पुनर्मूल्यन",
        ar: "إعادة تقييم عملة"
    }
});
data.push({
    name: 'GLFXRevaluationItem',
    module: 'gl',
    display: {
        vi: "Dòng đánh giá",
        en: "Revaluation Item",
        fr: "Ligne réévaluation",
        es: "Línea revaluación",
        id: "Baris revaluasi",
        ja: "評価明細",
        zh: "重估明细",
        ko: "재평가 명세",
        hi: "पुनर्मूल्यन पंक्ति",
        ar: "بند إعادة تقييم"
    }
});
data.push({
    name: 'GLTrialBalance',
    module: 'gl',
    display: {
        vi: "Cân đối thử",
        en: "Trial Balance",
        fr: "Balance",
        es: "Balance",
        id: "Neraca saldo",
        ja: "試算表",
        zh: "试算表",
        ko: "시산표",
        hi: "तलपट",
        ar: "ميزان مراجعة"
    }
});
data.push({
    name: 'GLTrialBalanceItem',
    module: 'gl',
    display: {
        vi: "Dòng cân đối",
        en: "Balance Item",
        fr: "Ligne balance",
        es: "Línea balance",
        id: "Baris neraca",
        ja: "試算明細",
        zh: "试算明细",
        ko: "시산 명세",
        hi: "तलपट पंक्ति",
        ar: "بند ميزان"
    }
});
data.push({
    name: 'HRAttendanceRequest',
    module: 'timesheet',
    display: {
        vi: "Bổ sung chấm công",
        en: "Attendance Request",
        fr: "Régularisation",
        es: "Solicitud asistencia",
        id: "Permintaan absensi",
        ja: "打刻修正",
        zh: "补卡申请",
        ko: "근태 정정",
        hi: "उपस्थिति अनुरोध",
        ar: "طلب تصحيح حضور"
    }
});
data.push({
    name: 'HRHoliday',
    module: 'timesheet',
    display: {
        vi: "Ngày lễ",
        en: "Holidays",
        fr: "Jours fériés",
        es: "Festivos",
        id: "Hari libur",
        ja: "祝日",
        zh: "节假日",
        ko: "공휴일",
        hi: "अवकाश दिवस",
        ar: "عطلات"
    }
});
data.push({
    name: 'HRLeave',
    module: 'timesheet',
    display: {
        vi: "Nghỉ phép",
        en: "Leave",
        fr: "Congés",
        es: "Permisos",
        id: "Cuti",
        ja: "休暇",
        zh: "请假",
        ko: "휴가",
        hi: "अवकाश",
        ar: "إجازة"
    }
});
data.push({
    name: 'HROvertimeRequest',
    module: 'timesheet',
    display: {
        vi: "Tăng ca",
        en: "Overtime",
        fr: "Heures sup.",
        es: "Horas extra",
        id: "Lembur",
        ja: "残業",
        zh: "加班",
        ko: "초과근무",
        hi: "ओवरटाइम",
        ar: "العمل الإضافي"
    }
});
data.push({
    name: 'HRLeaveType',
    module: 'timesheet',
    display: {
        vi: "Loại nghỉ",
        en: "Leave Type",
        fr: "Type congé",
        es: "Tipo permiso",
        id: "Jenis cuti",
        ja: "休暇種別",
        zh: "请假类型",
        ko: "휴가 유형",
        hi: "अवकाश प्रकार",
        ar: "نوع إجازة"
    }
});
data.push({
    name: 'HROvertime',
    module: 'payroll',
    display: {
        vi: "Tăng ca",
        en: "Overtime",
        fr: "Heures sup.",
        es: "Horas extra",
        id: "Lembur",
        ja: "残業",
        zh: "加班",
        ko: "초과근무",
        hi: "ओवरटाइम",
        ar: "عمل إضافي"
    }
});
data.push({
    name: 'HRAttendanceSite',
    module: 'timesheet',
    display: { vi: 'Điểm chấm công', en: 'Attendance Site', fr: 'Site de présence', es: 'Sitio de asistencia', id: 'Lokasi kehadiran', ja: '勤怠拠点', zh: '考勤地点', ko: '근태 지점', hi: 'उपस्थिति स्थल', ar: 'موقع الحضور' }
});
data.push({
    name: 'HRAttendanceAssignment',
    module: 'timesheet',
    display: { vi: 'Phân công chấm công', en: 'Attendance Assignment', fr: 'Affectation de présence', es: 'Asignación de asistencia', id: 'Penugasan kehadiran', ja: '勤怠割り当て', zh: '考勤分配', ko: '근태 배정', hi: 'उपस्थिति असाइनमेंट', ar: 'تعيين الحضور' }
});
data.push({
    name: 'HRAttendancePolicy',
    module: 'timesheet',
    display: { vi: 'Chính sách chấm công', en: 'Attendance Policy', fr: 'Politique de présence', es: 'Política de asistencia', id: 'Kebijakan kehadiran', ja: '勤怠ポリシー', zh: '考勤策略', ko: '근태 정책', hi: 'उपस्थिति नीति', ar: 'سياسة الحضور' }
});
data.push({
    name: 'HRAttendanceMethodConfig',
    module: 'timesheet',
    display: { vi: 'Điều kiện chấm công', en: 'Attendance Method', fr: 'Méthode de présence', es: 'Método de asistencia', id: 'Metode kehadiran', ja: '勤怠方法', zh: '考勤方式', ko: '근태 방식', hi: 'उपस्थिति विधि', ar: 'طريقة الحضور' }
});
data.push({
    name: 'HRAttendanceRecorderAssignment',
    module: 'timesheet',
    display: { vi: 'Vai trò ghi công', en: 'Attendance Recorder Role', fr: "Rôle d'enregistrement", es: 'Rol de registro', id: 'Peran pencatat', ja: '勤怠記録役割', zh: '考勤记录角色', ko: '근태 기록 역할', hi: 'उपस्थिति रिकॉर्डर भूमिका', ar: 'دور مسجل الحضور' }
});
data.push({
    name: 'HRAttendanceApprovalCase',
    module: 'timesheet',
    display: { vi: 'Yêu cầu duyệt chấm công', en: 'Attendance Approval', fr: 'Approbation de présence', es: 'Aprobación de asistencia', id: 'Persetujuan kehadiran', ja: '勤怠承認', zh: '考勤审批', ko: '근태 승인', hi: 'उपस्थिति अनुमोदन', ar: 'موافقة الحضور' }
});
data.push({
    name: 'HRAttendanceBatch',
    module: 'timesheet',
    display: { vi: 'Phiếu chấm công hộ', en: 'Proxy Attendance Batch' }
});
data.push({
    name: 'HRAttendanceBatchItem',
    module: 'timesheet',
    display: { vi: 'Dòng chấm công hộ', en: 'Proxy Attendance Batch Item' }
});
data.push({
    name: 'HRAttendanceBatchSubmission',
    module: 'timesheet',
    display: { vi: 'Xác nhận chấm công hộ', en: 'Proxy Attendance Confirmation' }
});
data.push({
    name: 'HROvertimeItem',
    module: 'payroll',
    display: {
        vi: "Dòng tăng ca",
        en: "Overtime Item",
        fr: "Ligne heures sup.",
        es: "Línea extra",
        id: "Baris lembur",
        ja: "残業明細",
        zh: "加班明细",
        ko: "초과 명세",
        hi: "ओवरटाइम पंक्ति",
        ar: "بند إضافي"
    }
});
data.push({
    name: 'ICLocation',
    module: 'inv',
    display: {
        vi: "Vị trí kho",
        en: "Location",
        fr: "Emplacement",
        es: "Ubicación",
        id: "Lokasi",
        ja: "ロケーション",
        zh: "库位",
        ko: "로케이션",
        hi: "स्थान",
        ar: "موقع"
    }
});
data.push({
    name: 'ICStockAudit',
    module: 'inv',
    display: {
        vi: "Kiểm kê",
        en: "Stock Audit",
        fr: "Inventaire",
        es: "Inventario",
        id: "Stok opname",
        ja: "棚卸",
        zh: "盘点",
        ko: "재고 실사",
        hi: "स्टॉक ऑडिट",
        ar: "جرد"
    }
});
data.push({
    name: 'ICStockAuditItem',
    module: 'inv',
    display: {
        vi: "Dòng kiểm kê",
        en: "Audit Item",
        fr: "Ligne inventaire",
        es: "Línea inventario",
        id: "Baris opname",
        ja: "棚卸明細",
        zh: "盘点明细",
        ko: "실사 명세",
        hi: "ऑडिट पंक्ति",
        ar: "بند جرد"
    }
});
data.push({
    name: 'ItemShiftSlot',
    module: 'item',
    display: {
        vi: "Ca bán",
        en: "Sale Slot",
        fr: "Créneau vente",
        es: "Franja venta",
        id: "Slot jual",
        ja: "販売枠",
        zh: "销售时段",
        ko: "판매 슬롯",
        hi: "बिक्री स्लॉट",
        ar: "فترة بيع"
    }
});
data.push({
    name: 'ItemSubstitute',
    module: 'inv',
    display: {
        vi: "Hàng thay thế",
        en: "Substitute",
        fr: "Substitut",
        es: "Sustituto",
        id: "Pengganti",
        ja: "代替品",
        zh: "替代品",
        ko: "대체품",
        hi: "विकल्प",
        ar: "بديل"
    }
});
data.push({
    name: 'LGCarrierSelectRule',
    module: 'lg',
    display: {
        vi: "Chọn hãng vận chuyển",
        en: "Carrier Rule",
        fr: "Règle transporteur",
        es: "Regla transportista",
        id: "Aturan kurir",
        ja: "配送業者ルール",
        zh: "承运规则",
        ko: "운송사 규칙",
        hi: "वाहक नियम",
        ar: "قاعدة الناقل"
    }
});
data.push({
    name: 'MEDVoucherTypeConfig',
    module: 'media',
    display: {
        vi: "Loại chứng từ",
        en: "Voucher Type",
        fr: "Type document",
        es: "Tipo documento",
        id: "Jenis dokumen",
        ja: "伝票種別",
        zh: "单据类型",
        ko: "전표 유형",
        hi: "दस्तावेज़ प्रकार",
        ar: "نوع مستند"
    }
});
data.push({
    name: 'MFCostConfig',
    module: 'mf',
    display: {
        vi: "Chi phí sản xuất",
        en: "Cost Config",
        fr: "Config coûts",
        es: "Config costos",
        id: "Konfig biaya",
        ja: "原価設定",
        zh: "成本配置",
        ko: "원가 설정",
        hi: "लागत विन्यास",
        ar: "إعداد تكلفة"
    }
});
data.push({
    name: 'MFCosting',
    module: 'mf',
    display: {
        vi: "Giá thành",
        en: "Costing",
        fr: "Coût revient",
        es: "Costeo",
        id: "Perhitungan biaya",
        ja: "原価計算",
        zh: "成本核算",
        ko: "원가 계산",
        hi: "लागत गणना",
        ar: "حساب تكلفة"
    }
});
data.push({
    name: 'MFCostingAlloc',
    module: 'mf',
    display: {
        vi: "Phân bổ giá thành",
        en: "Allocation",
        fr: "Répartition",
        es: "Asignación",
        id: "Alokasi",
        ja: "原価配賦",
        zh: "成本分摊",
        ko: "원가 배부",
        hi: "लागत आवंटन",
        ar: "توزيع تكلفة"
    }
});
data.push({
    name: 'MFCostingItem',
    module: 'mf',
    display: {
        vi: "Dòng giá thành",
        en: "Costing Item",
        fr: "Ligne coût",
        es: "Línea costeo",
        id: "Baris biaya",
        ja: "原価明細",
        zh: "成本明细",
        ko: "원가 명세",
        hi: "लागत पंक्ति",
        ar: "بند تكلفة"
    }
});
data.push({
    name: 'MFLaborSheet',
    module: 'mf',
    display: {
        vi: "Bảng công xưởng",
        en: "Labor Sheet",
        fr: "Feuille atelier",
        es: "Hoja taller",
        id: "Lembar kerja",
        ja: "工数表",
        zh: "车间工时",
        ko: "작업표",
        hi: "श्रम पत्रक",
        ar: "كشف عمل"
    }
});
data.push({
    name: 'MFLaborSheetItem',
    module: 'mf',
    display: {
        vi: "Dòng công xưởng",
        en: "Labor Item",
        fr: "Ligne atelier",
        es: "Línea taller",
        id: "Baris kerja",
        ja: "工数明細",
        zh: "工时明细",
        ko: "작업 명세",
        hi: "श्रम पंक्ति",
        ar: "بند عمل"
    }
});
data.push({
    name: 'MFReworkTicket',
    module: 'mf',
    display: {
        vi: "Phế và sửa",
        en: "Rework",
        fr: "Retouche",
        es: "Retrabajo",
        id: "Perbaikan",
        ja: "手直し",
        zh: "返工",
        ko: "재작업",
        hi: "पुनर्कार्य",
        ar: "إعادة تشغيل"
    }
});
data.push({
    name: 'MFShiftRoster',
    module: 'mf',
    display: {
        vi: "Điểm danh ca",
        en: "Shift Roster",
        fr: "Pointage équipe",
        es: "Lista turno",
        id: "Absen shift",
        ja: "点呼",
        zh: "班次点名",
        ko: "근무 점호",
        hi: "शिफ्ट रोस्टर",
        ar: "تحضير وردية"
    }
});
data.push({
    name: 'MFShiftRosterItem',
    module: 'mf',
    display: {
        vi: "Dòng điểm danh",
        en: "Roster Item",
        fr: "Ligne pointage",
        es: "Línea lista",
        id: "Baris absen",
        ja: "点呼明細",
        zh: "点名明细",
        ko: "점호 명세",
        hi: "रोस्टर पंक्ति",
        ar: "بند تحضير"
    }
});
data.push({
    name: 'MKGAffOffer',
    module: 'marketing',
    display: {
        vi: "Ưu đãi affiliate",
        en: "Aff Offer",
        fr: "Offre affilié",
        es: "Oferta afiliado",
        id: "Penawaran afiliasi",
        ja: "アフィリ特典",
        zh: "联盟优惠",
        ko: "제휴 오퍼",
        hi: "एफिलिएट ऑफर",
        ar: "عرض شركاء"
    }
});
data.push({
    name: 'MKGAffPostback',
    module: 'marketing',
    display: {
        vi: "Postback",
        en: "Postback",
        fr: "Postback",
        es: "Postback",
        id: "Postback",
        ja: "ポストバック",
        zh: "回传",
        ko: "포스트백",
        hi: "पोस्टबैक",
        ar: "إشعار ارتجاعي"
    }
});
data.push({
    name: 'MKGAffPublisher',
    module: 'marketing',
    display: {
        vi: "Publisher",
        en: "Publisher",
        fr: "Éditeur",
        es: "Publicador",
        id: "Publisher",
        ja: "パブリッシャー",
        zh: "推广者",
        ko: "퍼블리셔",
        hi: "प्रकाशक",
        ar: "ناشر"
    }
});
data.push({
    name: 'MKGAffTrackingLink',
    module: 'marketing',
    display: {
        vi: "Link theo dõi",
        en: "Tracking Link",
        fr: "Lien suivi",
        es: "Enlace seguimiento",
        id: "Tautan lacak",
        ja: "追跡リンク",
        zh: "跟踪链接",
        ko: "추적 링크",
        hi: "ट्रैकिंग लिंक",
        ar: "رابط تتبع"
    }
});
data.push({
    name: 'MKGCampaign',
    module: 'marketing',
    display: {
        vi: "Chiến dịch",
        en: "Campaign",
        fr: "Campagne",
        es: "Campaña",
        id: "Kampanye",
        ja: "キャンペーン",
        zh: "营销活动",
        ko: "캠페인",
        hi: "अभियान",
        ar: "حملة"
    }
});
data.push({
    name: 'MKGConversionEvent',
    module: 'marketing',
    display: {
        vi: "Sự kiện chuyển đổi",
        en: "Conversion",
        fr: "Conversion",
        es: "Conversión",
        id: "Konversi",
        ja: "コンバージョン",
        zh: "转化事件",
        ko: "전환",
        hi: "रूपांतरण",
        ar: "تحويل"
    }
});
data.push({
    name: 'MKGDeliveryLog',
    module: 'marketing',
    display: {
        vi: "Nhật ký gửi",
        en: "Delivery Log",
        fr: "Journal envoi",
        es: "Registro envío",
        id: "Log kirim",
        ja: "送信ログ",
        zh: "发送日志",
        ko: "발송 로그",
        hi: "प्रेषण लॉग",
        ar: "سجل إرسال"
    }
});
data.push({
    name: 'MKGOptOut',
    module: 'marketing',
    display: {
        vi: "Từ chối nhận tin",
        en: "Opt-out",
        fr: "Désinscription",
        es: "Baja",
        id: "Berhenti langganan",
        ja: "配信停止",
        zh: "退订",
        ko: "수신 거부",
        hi: "सदस्यता समाप्त",
        ar: "إلغاء اشتراك"
    }
});
data.push({
    name: 'PMProjectTemplate',
    module: 'pm',
    display: {
        vi: "Mẫu dự án",
        en: "Project Template",
        fr: "Modèle projet",
        es: "Plantilla proyecto",
        id: "Templat proyek",
        ja: "プロジェクト雛形",
        zh: "项目模板",
        ko: "프로젝트 템플릿",
        hi: "परियोजना टेम्पलेट",
        ar: "قالب مشروع"
    }
});
data.push({
    name: 'PMProjectTemplateFeature',
    module: 'pm',
    display: {
        vi: "Hạng mục mẫu",
        en: "Template Phase",
        fr: "Phase modèle",
        es: "Fase plantilla",
        id: "Fase templat",
        ja: "雛形フェーズ",
        zh: "模板阶段",
        ko: "템플릿 단계",
        hi: "टेम्पलेट चरण",
        ar: "مرحلة قالب"
    }
});
data.push({
    name: 'PMProjectTemplateTask',
    module: 'pm',
    display: {
        vi: "Việc mẫu",
        en: "Template Task",
        fr: "Tâche modèle",
        es: "Tarea plantilla",
        id: "Tugas templat",
        ja: "雛形タスク",
        zh: "模板任务",
        ko: "템플릿 작업",
        hi: "टेम्पलेट कार्य",
        ar: "مهمة قالب"
    }
});
data.push({
    name: 'PMResource',
    module: 'pm',
    display: {
        vi: "Tài nguyên",
        en: "Resource",
        fr: "Ressource",
        es: "Recurso",
        id: "Sumber daya",
        ja: "リソース",
        zh: "资源",
        ko: "리소스",
        hi: "संसाधन",
        ar: "مورد"
    }
});
data.push({
    name: 'PMTask',
    module: 'pm',
    display: {
        vi: "Công việc",
        en: "Task",
        fr: "Tâche",
        es: "Tarea",
        id: "Tugas",
        ja: "タスク",
        zh: "任务",
        ko: "작업",
        hi: "कार्य",
        ar: "مهمة"
    }
});
data.push({
    name: 'PMTaskResource',
    module: 'pm',
    display: {
        vi: "Phân bổ tài nguyên",
        en: "Task Resource",
        fr: "Ressource tâche",
        es: "Recurso tarea",
        id: "Sumber daya tugas",
        ja: "タスクリソース",
        zh: "任务资源",
        ko: "작업 리소스",
        hi: "कार्य संसाधन",
        ar: "مورد مهمة"
    }
});
data.push({
    name: 'PNLPostingRetry',
    module: 'pnl',
    display: {
        vi: "Lỗi tạo bút toán",
        en: "Posting Errors",
        fr: "Erreurs d'écriture",
        es: "Errores de asiento",
        id: "Kesalahan posting",
        ja: "仕訳作成エラー",
        zh: "分录生成错误",
        ko: "분개 생성 오류",
        hi: "प्रविष्टि त्रुटियाँ",
        ar: "أخطاء القيود"
    }
});
data.push({
    name: 'POSCashSettlement',
    module: 'ca',
    display: {
        vi: "Chốt ca quầy",
        en: "Cash Settlement",
        fr: "Clôture caisse",
        es: "Cierre caja",
        id: "Tutup kasir",
        ja: "レジ精算",
        zh: "收银结算",
        ko: "정산",
        hi: "कैश निपटान",
        ar: "تسوية نقدية"
    }
});
data.push({
    name: 'POSCashSettlementShift',
    module: 'ca',
    display: {
        vi: "Ca quầy",
        en: "Cash Shift",
        fr: "Poste caisse",
        es: "Turno caja",
        id: "Shift kasir",
        ja: "レジシフト",
        zh: "收银班次",
        ko: "캐셔 근무",
        hi: "कैश शिफ्ट",
        ar: "وردية نقد"
    }
});
data.push({
    name: 'SysAddress',
    module: 'sys',
    display: {
        vi: "Địa chỉ hành chính",
        en: "Address",
        fr: "Adresse",
        es: "Dirección",
        id: "Alamat",
        ja: "住所",
        zh: "行政地址",
        ko: "주소",
        hi: "पता",
        ar: "عنوان"
    }
});
data.push({
    name: 'SysModuleWorkflow',
    module: 'setting',
    display: {
        vi: "Quy trình module",
        en: "Workflow",
        fr: "Flux module",
        es: "Flujo módulo",
        id: "Alur modul",
        ja: "ワークフロー",
        zh: "模块流程",
        ko: "워크플로",
        hi: "वर्कफ़्लो",
        ar: "سير عمل"
    }
});
data.push({
    name: 'WFApprovalActivity',
    module: 'wf',
    display: {
        vi: "Hoạt động duyệt",
        en: "Approval Activity",
        fr: "Activité approbation",
        es: "Actividad aprobación",
        id: "Aktivitas persetujuan",
        ja: "承認活動",
        zh: "审批活动",
        ko: "승인 활동",
        hi: "अनुमोदन गतिविधि",
        ar: "نشاط اعتماد"
    }
});
data.push({
    name: 'WFApprovalPolicy',
    module: 'wf',
    display: {
        vi: "Quy tắc duyệt",
        en: "Approval Policy",
        fr: "Règle approbation",
        es: "Regla aprobación",
        id: "Aturan persetujuan",
        ja: "承認ルール",
        zh: "审批规则",
        ko: "승인 규칙",
        hi: "अनुमोदन नियम",
        ar: "قاعدة اعتماد"
    }
});
data.push({
    name: 'WFApprovalPolicyStep',
    module: 'wf',
    display: {
        vi: "Cấp duyệt",
        en: "Approval Step",
        fr: "Niveau approbation",
        es: "Nivel aprobación",
        id: "Tingkat persetujuan",
        ja: "承認段階",
        zh: "审批层级",
        ko: "승인 단계",
        hi: "अनुमोदन स्तर",
        ar: "مستوى اعتماد"
    }
});

data.push({"name": "TaxPITAnnual", "module": "tax", "display": {"vi": "Đối chiếu TNCN năm", "en": "Annual personal income tax"}});
data.push({"name": "TaxCITCalculate", "module": "tax", "display": {"vi": "Tính thuế TNDN", "en": "Corporate income tax"}});
data.push({"name": "TaxCITCalculateItem", "module": "tax", "display": {"vi": "Điều chỉnh TNDN", "en": "Corporate tax adjustments"}});

export default data;
